var _style, _rect, _defs, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 600",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#8BC4E1;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\n\t.st3{mask:url(#SVGID_1_);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st5{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.1,
    className: "st0",
    width: 800,
    height: 600
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: -501.6,
    y: 368.1,
    width: 1382,
    height: 437
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -501.6,
    y: 368.1,
    width: 1382,
    height: 437,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.36,
    y1: 632.5599,
    x2: 400.36,
    y2: 398.8278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.1,
    className: "st2",
    width: 800,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M289.8,623.8l-73.2,6.4l5.2-5.7l0.1,0.3l0.3-0.1c0-0.2-0.1-0.3-0.2-0.5l6.8-7.4l0.2-0.1l0-0.1l0.3-0.3 l0.1,0.3l0.7-0.3l-0.1-0.3l-0.5,0.2l6.7-7.3l28.8-16.9l25.9,30C290.4,622.5,290,623.1,289.8,623.8z M290,624.7l2.7-0.2l-0.4,4.5 l4.5,2.9l5-2.5l0.4-5.4l-0.3-0.2l0,0h0l-3.4-2.2l1.8-2.1c1.6,0.6,3,1.8,3.8,3.5c1.8,3.7,0.2,8.2-3.6,10.1 c-3.8,1.9-8.4,0.5-10.2-3.2C289.6,628.2,289.5,626.4,290,624.7z M300.4,618.9c-0.5-0.2-1-0.3-1.5-0.4l7-24.4l9.8,7.2 L300.4,618.9z M316.3,601.3l7.7-8.8l6.3,13.3c-0.8,0.4-1.6,0.9-2.2,1.6c-0.5,0.5-0.8,1.2-1.1,1.8L316.3,601.3z M327.1,609.8 l1.3,1l-0.5,0.2l0.2,0.3l0.5-0.2l1.1,3.6l4.1,0.8l2.8-3.2l-1.2-4l-2.6-0.5l0.8-2.1c1.1,0.1,2.1,0.6,3,1.3 c2.3,2.1,2.5,5.8,0.3,8.2c-2.2,2.4-5.8,2.7-8.2,0.6C326.9,614.3,326.4,611.9,327.1,609.8z M331.3,605.9c0.4-0.1,0.9-0.2,1.3-0.2 l-0.6,1.6L331.3,605.9z M328.7,610.5l-1.4-1c0.2-0.6,0.6-1.2,1.1-1.8c0.6-0.7,1.3-1.2,2.1-1.5l0.7,1.5L328.7,610.5z  M332.7,605.3c-0.5,0-1.1,0.1-1.6,0.2l-6.5-13.7l22.4-25.5l0.1,0.1L332.7,605.3z M348.1,566.4l0.5-1.4l2.7,0.2l1.9-2.7l-1.4-3 l-3.4-0.3l-1.5,2.1l-1.4-0.7c0.7-1.8,2.6-3.1,4.7-2.9c2.6,0.2,4.5,2.4,4.2,4.9c-0.2,2.5-2.5,4.3-5,4.1 C349,566.7,348.5,566.6,348.1,566.4z M345.1,560.9c-0.1,0.2-0.1,0.3-0.1,0.5l-23-0.1c0-0.1,0-0.2-0.1-0.2 c-1.3-4.2-5.8-6.5-10.1-5.2c-0.9,0.3-1.8,0.7-2.5,1.3l-5.4-8.3c0.9-0.3,1.7-0.7,2.5-1.3c1.5-1,2.6-2.3,3.4-3.8L345.1,560.9z  M309.5,543.1l-2.4-1.2l-0.4-6.5l-6.1-2.8l-5.7,3.9l0.4,6.3l-2.3,1.7c-2.6-4.2-1.4-9.9,2.9-12.8c4.4-3,10.3-2,13.1,2.3 C310.8,536.7,310.9,540.2,309.5,543.1z M263.5,567l29.4-21.4l0.3,0.3l-20.6,22.5l-8.8,0.9C263.7,568.6,263.6,567.8,263.5,567z  M262.5,566.6l-4,2.9l-3.7-8.1l-9.9-0.9l-5.7,8.2l3.9,8.6l-2.3,3.3c-5.9-4.5-7.2-12.9-2.9-19c4.4-6.2,12.9-7.7,19.1-3.3 C259.9,560.4,261.8,563.4,262.5,566.6z M235.8,608.5l-22.1,13l2.9-4.2c0.1,0.1,0.3,0.2,0.4,0.3l0.2-0.3 c-0.1-0.1-0.3-0.2-0.4-0.4l24.2-35.1c4.8,3.2,10.9,3.1,15.5,0.3l1.6,1.9L235.8,608.5z M264.7,591.6l-27.8,16.3l21.5-23.5 L264.7,591.6z M265,591.4l-6.3-7.3l8.1-8.8l14.4,6.6L265,591.4z M298.8,619c0.4,0.1,0.8,0.2,1.2,0.3l-1.5,1.7l0.1-1.3L298.8,619 z M305.6,593.9l-6.9,24.1l1.4-23.4c1.5-0.1,2.8-0.8,3.7-2.1L305.6,593.9z M305.7,593.5l-1.8-1.3c0-0.1,0.1-0.1,0.1-0.2 c0.7-1.5,0.6-3.3-0.3-4.6l4.4-2.5L305.7,593.5z M323.8,592.1l-7.8,9l-10-7.3l2.6-9.2l9.2-5.3L323.8,592.1z M347.3,565.9l0,0.1 L347.3,565.9L347.3,565.9z M346.9,565.8c-0.7-0.6-1.2-1.4-1.5-2.2l1.4-0.8l0.9,1.9l-0.1,0.3L346.9,565.8z M345.3,561.4 c0-0.1,0-0.2,0.1-0.4l0.8,0.4L345.3,561.4z M346.7,562.4l-1.4,0.8c0-0.3-0.1-0.5-0.1-0.8L346.7,562.4L346.7,562.4z M344.9,562.3 c0,0.3,0,0.7,0.1,1l-26.6,15.2l-3.4-7.2c0.4-0.1,0.9-0.1,1.3-0.3c3.9-1.2,6.3-5,5.8-8.8L344.9,562.3z M308.9,558.1l1.2,1.9 l-1.2,4.6l-2.3,0.2C306.1,562.4,307,559.8,308.9,558.1z M282.6,581.5l24.2-14.2c0.9,1.7,2.5,3,4.3,3.6l-8.2,15.5 c-0.4-0.3-0.7-0.6-1.2-0.9c-2.3-1.1-5.1-0.3-6.4,1.8L282.6,581.5z M303.5,592.4c-0.8,1.2-2,1.9-3.4,2l0.1-1.4l2.1-1.4 L303.5,592.4z M303.5,587.5c0.8,1.3,1,2.9,0.3,4.4c0,0.1-0.1,0.1-0.1,0.2l-1.1-0.8l-0.3-3.1L303.5,587.5z M302.8,586.7l-0.7,1.3 l-2.8-1.4l-2.3,1.5l-1.4-0.6c1.2-2,3.8-2.7,5.9-1.7C302,586,302.4,586.3,302.8,586.7z M303.3,587.2l-0.6,0.3l0.4-0.7 C303.1,587,303.2,587.1,303.3,587.2z M308.3,584.4l-4.8,2.7c-0.1-0.1-0.2-0.3-0.4-0.4l8.3-15.6c0.2,0,0.4,0.1,0.6,0.1 L308.3,584.4z M314.1,571.4l3.6,7.6l-8.9,5.1l3.7-12.9C313,571.3,313.5,571.4,314.1,571.4z M313.8,570.9c-0.4,0-0.9-0.1-1.3-0.1 l0.5-1.6L313.8,570.9z M312.2,570.7l-0.5-0.1l1-1.9l0,0L312.2,570.7z M307.3,567l2.2-1.3l3,2.7l-1.1,2 C309.6,569.8,308.2,568.6,307.3,567z M309.1,565.5l-2,1.1c-0.1-0.3-0.3-0.6-0.4-0.9L309.1,565.5z M321.7,562.2 c0.5,3.6-1.7,7.2-5.4,8.3c-0.5,0.1-0.9,0.2-1.4,0.3l-1.1-2.4l4.4-1.3l1.2-4.9L321.7,562.2z M295.8,591.7l-0.3,0.1 c-0.6-1.1-0.7-2.3-0.3-3.5l1.4,0.6l0.2,2.4l-0.7,0.2l0.1,0.3l0.7-0.2l2.3,1.2l-0.1,1.5c-0.5-0.1-1-0.2-1.5-0.4 c-0.8-0.4-1.5-1-1.9-1.8l0.2-0.1L295.8,591.7z M272.2,569.4l34.1-3.6c0.1,0.4,0.3,0.8,0.4,1.1l-24.5,14.4l-14.7-6.8L272.2,569.4 z M263.7,570.3l7.9-0.8l-4.5,4.9l-3.7-1.7C263.6,571.9,263.7,571.1,263.7,570.3z M259.7,569.8l3-2.1c0.1,0.6,0.1,1.2,0.1,1.8 L259.7,569.8z M262.8,570.4c0,0.6-0.1,1.3-0.2,1.9l-3.3-1.5L262.8,570.4z M261.1,578.1c1-1.4,1.7-2.9,2.1-4.5l3.3,1.5l-8,8.7 l-1.5-1.8C258.5,581,259.9,579.7,261.1,578.1z M258.4,571.4l4,1.8c-0.4,1.5-1.1,3-2,4.4c-1.1,1.6-2.5,2.8-4,3.8l-2.7-3.2 L258.4,571.4z M253.2,578.7l0.1-0.2l2.6,3c-4.4,2.5-9.9,2.5-14.4-0.4l2.3-3.3L253.2,578.7z M303,549.1l5.5,8.6 c-2,1.8-3,4.5-2.5,7.2l-32.9,3.5l20.3-22.2C295.8,548.9,299.5,549.9,303,549.1z M302.7,548.5c-3.2,0.7-6.6-0.3-8.9-2.8l2-2.2 l5.2,2.4L302.7,548.5z M309.3,543.4c-0.7,1.4-1.8,2.6-3.2,3.6c-0.8,0.5-1.7,1-2.5,1.2l-1.7-2.6l5-3.4L309.3,543.4z M294.6,544.4 l-1,1.1c-0.1-0.1-0.1-0.2-0.2-0.2L294.6,544.4z M321.5,561.3l-2.6,0l-3.4-3.1l-4.5,1.4l-1.3-2c0.7-0.5,1.5-0.9,2.4-1.2 C316,555.1,320.3,557.3,321.5,561.3C321.5,561.2,321.5,561.3,321.5,561.3z M324.5,591.4l-5.9-12.5l26.5-15.2 c0.3,0.9,0.9,1.7,1.6,2.3L324.5,591.4z M292.2,623.6l-1.9,0.2c0.2-0.5,0.5-1,0.8-1.5L292.2,623.6z M291.3,622 c0.7-0.9,1.6-1.7,2.7-2.2c1.2-0.6,2.5-0.9,3.7-0.8l-0.1,2.2l-4.8,2.4v0l-0.1,0L291.3,622z M273.2,600l-0.6,0.2l-7.4-8.5 l16.4-9.6l13.3,6.1c-0.4,1.2-0.3,2.6,0.3,3.7l-0.1,0l0.1,0.3l0.1,0c0.5,0.8,1.2,1.5,2.1,1.9c0.5,0.3,1.1,0.4,1.6,0.5l-1.4,23.8 c-1.3,0-2.7,0.3-3.9,0.9c-1.1,0.6-2,1.3-2.8,2.3l-18.2-21.1l0.4-0.2L273.2,600z M216.1,630l-3.1-7.5l0,0l0.5-0.2l-0.1-0.2 l0.3-0.2l0.1,0.3l0.7-0.2l-0.1-0.3l-0.5,0.2l4.9-2.9l-0.2,0.2l0.5,0.6l0.3-0.2c-0.2-0.2-0.3-0.4-0.5-0.5l16.1-9.5l-6.4,7 l-0.5,0.2l0.1,0.2L216.1,630z M200.7,637.7l9.8,1.3l6-7.9l72.9-6.4c-0.4,1.8-0.3,3.6,0.6,5.4c1.9,3.9,6.8,5.4,10.8,3.4 c4-2,5.7-6.8,3.8-10.7l0.4-0.2l-0.2-0.3l-0.4,0.2c-0.9-1.6-2.2-2.7-3.8-3.4l15.3-17.5l10.8,7.9c-0.3,0.7-0.4,1.4-0.4,2.2 l-0.5,0.2l0.2,0.3l0.3-0.2c0.1,1.5,0.7,3,1.9,4.1c2.5,2.2,6.4,1.9,8.7-0.7c2.3-2.6,2.2-6.5-0.3-8.8c-0.9-0.8-2-1.3-3.1-1.4 l14.3-38.6c0.5,0.2,0.9,0.3,1.5,0.4c2.7,0.2,5.1-1.7,5.4-4.3c0.2-2.6-1.8-5-4.5-5.2c-2.2-0.2-4.3,1.1-5,3l-35.2-17.2 c1.5-3.1,1.4-6.9-0.6-9.8c-3-4.5-9.3-5.6-14-2.4c-4.6,3.1-5.9,9.2-3.1,13.7l-29.1,21.2c-0.8-3.3-2.8-6.4-5.8-8.5 c-6.6-4.7-15.8-3.1-20.4,3.5c-4.6,6.5-3.1,15.5,3.2,20.3l-27.9,40.4l-9.6-1.2l-6,8L200.7,637.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "291.7,593.2 291.8,593.6 291.1,593.8 291,593.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "293.8,592.5 293.9,592.8 293.2,593.1 293.1,592.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "294.8,592.1 294.9,592.4 294.2,592.7 294.1,592.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "292.7,592.8 292.9,593.2 292.2,593.4 292,593.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "283.5,596.2 283.6,596.6 282.9,596.8 282.8,596.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "278.3,598.1 278.4,598.5 277.8,598.7 277.6,598.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "275.2,599.3 275.3,599.6 274.6,599.9 274.5,599.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "277.3,598.5 277.4,598.9 276.7,599.1 276.6,598.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "274.2,599.7 274.3,600 273.6,600.3 273.5,599.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "276.2,598.9 276.4,599.2 275.7,599.5 275.6,599.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "287.6,594.7 287.7,595.1 287,595.3 286.9,595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "284.5,595.9 284.6,596.2 283.9,596.5 283.8,596.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "285.5,595.5 285.6,595.8 285,596.1 284.8,595.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.5,595.1 286.7,595.5 286,595.7 285.9,595.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "289.6,594 289.8,594.3 289.1,594.6 289,594.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "288.6,594.3 288.7,594.7 288,594.9 287.9,594.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "281.4,597 281.5,597.3 280.8,597.6 280.7,597.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "282.4,596.6 282.5,597 281.9,597.2 281.7,596.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "290.7,593.6 290.8,593.9 290.1,594.2 290,593.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "279.3,597.8 279.5,598.1 278.8,598.4 278.6,598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "280.4,597.4 280.5,597.7 279.8,598 279.7,597.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.8,434.6l66.7-31.1l-3,7.2l-0.2-0.2l-0.3,0.2c0.1,0.1,0.2,0.3,0.3,0.4l-3.9,9.3l-0.1,0.1l0,0.1 l-0.2,0.4l-0.2-0.2l-0.6,0.5l0.2,0.3l0.4-0.4l-3.8,9.2L273,456.1l-34.5-19.4C238.7,436,238.8,435.3,238.8,434.6z M238.3,433.8 l-2.5,1.2l-1.2-4.3l-5.3-1.2l-3.8,4l1.4,5.2l0.4,0.1l0,0l0,0l3.9,0.9l-1,2.6c-1.7-0.1-3.4-0.7-4.7-2c-2.9-2.8-3-7.6-0.1-10.7 c2.9-3.1,7.7-3.3,10.6-0.5C237.4,430.4,238.2,432.1,238.3,433.8z M230.5,442.7c0.5,0,1,0,1.5-0.1l1.7,25.3l-11.7-3.4 L230.5,442.7z M221.5,464.7l-4.3,10.9l-10.4-10.4c0.6-0.6,1.2-1.4,1.5-2.3c0.3-0.7,0.4-1.4,0.4-2L221.5,464.7z M208.4,460.5 l-1.5-0.4l0.4-0.4l-0.3-0.3l-0.4,0.4l-2.3-3l-4.1,0.6l-1.6,4l2.5,3.3l2.6-0.4l0,2.2c-1.1,0.2-2.2,0.2-3.3-0.3 c-2.9-1.2-4.3-4.6-3-7.6c1.2-3,4.5-4.5,7.5-3.4C207.1,456.2,208.4,458.3,208.4,460.5z M205.8,465.6c-0.4,0.2-0.8,0.5-1.2,0.6 l0-1.7L205.8,465.6z M206.7,460.4l1.7,0.5c0,0.7-0.1,1.4-0.4,2c-0.3,0.8-0.8,1.5-1.4,2.1l-1.2-1.2L206.7,460.4z M204.7,466.6 c0.5-0.2,1-0.4,1.4-0.7l10.7,10.7l-12.4,31.7l-0.2,0L204.7,466.6z M203.4,508.4l0,1.5l-2.6,0.7l-0.9,3.1l2.3,2.3l3.2-0.9 l0.7-2.4l1.6,0.2c0,2-1.4,3.8-3.5,4.3c-2.5,0.7-5-0.8-5.6-3.2c-0.6-2.4,0.9-4.9,3.4-5.5C202.4,508.4,202.9,508.4,203.4,508.4z  M208,512.6c0-0.2,0-0.3-0.1-0.5l21.7-7.8l0.1,0.2c2.6,3.5,7.7,4.1,11.3,1.4c0.8-0.6,1.4-1.3,1.9-2l7.8,6 c-0.7,0.6-1.4,1.3-2,2.1c-1.1,1.5-1.7,3.1-1.9,4.7L208,512.6z M247.5,517.2l2.7,0.3l2.5,6l6.7,0.6l4.1-5.6l-2.5-5.8l1.6-2.4 c3.9,3.1,4.7,8.8,1.6,13.1c-3.1,4.3-9,5.4-13.1,2.4C248.5,523.6,247.2,520.4,247.5,517.2z M282.7,478.9l-20.4,30.2 c-0.1-0.1-0.2-0.2-0.4-0.2l11.8-28.2l8-3.9C282,477.6,282.3,478.3,282.7,478.9z M283.8,479l2.8-4.1l6.2,6.3l9.6-2.5l2.6-9.6 l-6.6-6.7l1-3.9c7,2.2,11.2,9.6,9.2,16.9c-2,7.3-9.6,11.7-16.9,9.6C288.3,484,285.5,481.8,283.8,479z M294.7,430.5l16.4-19.7 l-1.3,5c-0.2,0-0.3-0.1-0.5-0.2l-0.1,0.3c0.2,0.1,0.4,0.1,0.5,0.2l-10.9,41.2c-5.6-1.3-11.3,0.8-14.7,5l-2.1-1.2L294.7,430.5z  M273.3,456.2l20.6-24.8l-12.3,29.5L273.3,456.2z M273.1,456.5l8.4,4.7l-4.6,11.1l-15.8-1.3L273.1,456.5z M231.9,442.1 c-0.4,0.1-0.8,0.1-1.3,0.1l0.8-2.1l0.4,1.3L231.9,442.1z M234.1,468.1l-1.7-25.1l6.6,22.5c-1.4,0.6-2.4,1.8-2.7,3.2L234.1,468.1 z M234.1,468.4l2.1,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.2,1.7,0.6,3.3,1.9,4.3l-3.3,3.9L234.1,468.4z M217.5,476l4.4-11.1l11.9,3.5 l0.6,9.5l-6.9,8.1L217.5,476z M204.3,508.7v-0.1l0.1,0L204.3,508.7z M204.7,508.7c0.9,0.3,1.6,0.8,2.2,1.6l-1.1,1.3l-1.5-1.5 v-0.3L204.7,508.7z M207.7,512.2c0,0.1,0.1,0.2,0.1,0.4l-0.9-0.1L207.7,512.2z M206.1,511.8l1-1.2c0.1,0.2,0.3,0.5,0.4,0.7 L206.1,511.8L206.1,511.8z M207.7,511.2c-0.1-0.3-0.3-0.6-0.4-0.9l19.9-23.4l5.7,5.6c-0.4,0.2-0.8,0.4-1.2,0.7 c-3.3,2.5-4.3,6.9-2.5,10.3L207.7,511.2z M243.1,502.8l-1.8-1.3l-0.5-4.8l2.1-1C244.2,497.9,244.2,500.6,243.1,502.8z  M259.9,471.9l-18,21.7c-1.5-1.3-3.3-2-5.2-2l2.5-17.4c0.4,0.2,0.9,0.3,1.4,0.4c2.6,0.3,4.9-1.4,5.4-3.9L259.9,471.9z  M236.5,468.8c0.3-1.4,1.3-2.5,2.5-3l0.4,1.4l-1.6,2L236.5,468.8z M238.2,473.3c-1.2-0.9-1.9-2.4-1.8-4c0-0.1,0-0.1,0-0.2 l1.3,0.4l1.3,2.8L238.2,473.3z M239.1,473.9l0.2-1.4l3,0.3l1.7-2.2l1.5,0.1c-0.5,2.3-2.6,3.9-5,3.6 C240.1,474.3,239.6,474.1,239.1,473.9z M238.5,473.5l0.4-0.5l-0.1,0.8C238.7,473.7,238.6,473.6,238.5,473.5z M234.7,478l3.6-4.2 c0.2,0.1,0.3,0.2,0.5,0.3l-2.5,17.5c-0.2,0-0.4,0-0.6,0.1L234.7,478z M233.7,492.2l-5.9-6l6.7-7.8l0.9,13.4 C234.7,491.8,234.2,491.9,233.7,492.2z M234.1,492.5c0.4-0.1,0.8-0.2,1.2-0.3l0.1,1.7L234.1,492.5z M235.7,492.2 c0.2,0,0.3,0,0.5-0.1l-0.3,2.1l0,0L235.7,492.2z M241.5,494l-1.6,2l-3.7-1.5l0.3-2.3C238.4,492.1,240.1,492.7,241.5,494z  M240.3,496l1.4-1.8c0.2,0.2,0.4,0.5,0.7,0.7L240.3,496z M229.6,503.4c-1.7-3.2-0.8-7.4,2.3-9.7c0.4-0.3,0.8-0.5,1.2-0.8 l1.9,1.9l-3.7,2.8l0.5,5L229.6,503.4z M244,466.8l0.2-0.2c0.9,0.8,1.4,2,1.4,3.2l-1.5-0.1l-1-2.2l0.5-0.5l-0.2-0.3l-0.5,0.5 l-2.6-0.3l-0.4-1.4c0.5-0.1,1.1-0.2,1.6-0.1c0.9,0.1,1.7,0.5,2.4,1l-0.2,0.2L244,466.8z M273.8,479.7l-30.9,15l0,0 c-0.2-0.3-0.5-0.6-0.8-0.9l18.2-21.9l16.1,1.3L273.8,479.7z M281.4,476l-7.2,3.5l2.6-6.2l4.1,0.3 C281,474.4,281.2,475.2,281.4,476z M285.3,475.1l-2.1,3c-0.3-0.5-0.5-1.1-0.7-1.7L285.3,475.1z M282.2,475.5 c-0.2-0.6-0.3-1.2-0.4-1.9l3.6,0.3L282.2,475.5z M281.3,467.7c-0.5,1.7-0.6,3.3-0.5,5l-3.6-0.3l4.6-11l2.1,1.2 C282.7,464.1,281.8,465.8,281.3,467.7z M286.1,473.1l-4.4-0.4c-0.1-1.6,0-3.2,0.4-4.8c0.5-1.8,1.4-3.5,2.5-4.9l3.6,2 L286.1,473.1z M288.4,464.5l-0.1,0.2l-3.5-2c3.2-3.9,8.5-5.8,13.7-4.5l-1,3.9L288.4,464.5z M251.6,509.4l-8.1-6.2 c1.3-2.4,1.3-5.3-0.1-7.6l29.8-14.5l-11.6,27.8C258.4,507.1,254.6,507.4,251.6,509.4z M252.1,509.8c2.8-1.8,6.3-2,9.2-0.4 l-1.2,2.8l-5.7-0.5L252.1,509.8z M247.6,516.8c0.2-1.5,0.8-3.1,1.8-4.4c0.6-0.8,1.2-1.5,2-2l2.4,1.9l-3.5,4.9L247.6,516.8z  M261.1,510.9l0.6-1.4c0.1,0.1,0.2,0.1,0.2,0.2L261.1,510.9z M230.1,504.2l2.5-0.9l4.2,1.8l3.8-2.8l1.9,1.5 c-0.5,0.7-1.1,1.4-1.8,1.9C237.4,508.1,232.6,507.5,230.1,504.2L230.1,504.2z M217.1,476.9l9.8,9.7L207.1,510 c-0.6-0.7-1.4-1.3-2.3-1.6L217.1,476.9z M236.6,435.6l1.8-0.8c0,0.5-0.1,1.1-0.3,1.6L236.6,435.6z M237.9,436.8 c-0.4,1.1-0.9,2.1-1.8,3c-0.9,1-2,1.7-3.2,2l-0.6-2.1l3.7-3.9v0l0.1,0L237.9,436.8z M262.5,451.2l0.5-0.4l9.8,5.5L260.6,471 l-14.6-1.2c0-1.3-0.6-2.5-1.5-3.4l0.1-0.1l-0.2-0.3l-0.1,0.1c-0.7-0.6-1.6-1-2.6-1.1c-0.6-0.1-1.2,0-1.7,0.1l-6.7-22.9 c1.2-0.4,2.4-1.2,3.4-2.2c0.9-0.9,1.5-2,1.9-3.1l24.2,13.6l-0.3,0.3L262.5,451.2z M306,403.5l5.5,6l0,0.1l-0.4,0.3l0.2,0.2 l-0.2,0.3l-0.2-0.2l-0.6,0.5l0.2,0.3l0.4-0.3l-3.6,4.4l0.1-0.3l-0.6-0.4l-0.2,0.3c0.2,0.1,0.4,0.2,0.6,0.4l-12,14.4l3.6-8.7 l0.4-0.3l-0.2-0.2L306,403.5z M317.9,391l-9.7,2.2l-2.9,9.5l-66.4,30.9c-0.2-1.8-0.9-3.5-2.3-4.9c-3.1-3-8.2-2.8-11.3,0.5 c-3.1,3.3-3.1,8.4,0,11.4l-0.3,0.4l0.3,0.2l0.3-0.4c1.3,1.2,3,1.8,4.7,1.9l-8.5,21.7l-12.8-3.8c0-0.8-0.1-1.5-0.4-2.2l0.4-0.4 l-0.3-0.2l-0.3,0.3c-0.6-1.4-1.7-2.6-3.2-3.2c-3.1-1.2-6.7,0.4-7.9,3.6c-1.3,3.2,0.2,6.9,3.3,8.1c1.1,0.5,2.3,0.5,3.4,0.3 l-0.4,41.2c-0.5,0-1,0-1.5,0.1c-2.6,0.7-4.3,3.4-3.6,5.9c0.7,2.5,3.4,4.1,6,3.4c2.2-0.6,3.6-2.5,3.7-4.6l38.9,4.1 c-0.4,3.5,1,6.9,3.9,9.1c4.4,3.2,10.7,2.1,14-2.5c3.3-4.5,2.5-10.7-1.8-14l20.2-29.9c1.9,2.8,4.8,5.1,8.3,6 c7.8,2.2,15.9-2.5,18-10.3c2.1-7.7-2.3-15.7-9.8-18l12.5-47.6l9.4-2.1l3-9.5L317.9,391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.5,407.3l-0.3,0.1c-0.1-0.2-0.2-0.4-0.3-0.7l0.3-0.1L300.5,407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.8,408.8l-0.4-0.6l0.3-0.2c0.1,0.2,0.2,0.4,0.4,0.6L300.8,408.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "301.6,410.1 301.2,409.4 301.5,409.2 301.9,409.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.9,397.3c0.1,0.2,0.1,0.5,0.1,0.7l-0.4,0l-0.1-0.7L330.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.8,385.6l0.1-0.3c0.2,0.1,0.5,0.2,0.7,0.3l-0.1,0.3L320.8,385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.1,386.2l0.2-0.3c0.2,0.1,0.4,0.2,0.6,0.4l-0.2,0.3C322.5,386.4,322.3,386.3,322.1,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M302.2,390.8l-0.3-0.2c0.1-0.2,0.3-0.4,0.5-0.6l0.3,0.2L302.2,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.1,398.7c0,0.2,0,0.5,0.1,0.7l-0.4,0c0-0.2,0-0.5-0.1-0.7L331.1,398.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.9,390.5c0.1,0.2,0.3,0.4,0.4,0.6l-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6L327.9,390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M328.7,391.8c0.1,0.2,0.2,0.4,0.4,0.6l-0.3,0.2l-0.4-0.6L328.7,391.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.3,386.9l0.2-0.3c0.2,0.1,0.4,0.3,0.6,0.4l-0.2,0.3L323.3,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.5,395.8l0.2,0.7l-0.3,0.1c-0.1-0.2-0.1-0.5-0.2-0.7L330.5,395.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M326.9,389.4c0.2,0.2,0.3,0.4,0.5,0.6l-0.3,0.2c-0.1-0.2-0.3-0.4-0.5-0.5L326.9,389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.5,387.7l0.2-0.3c0.2,0.1,0.4,0.3,0.6,0.5l-0.2,0.3C324.9,388,324.7,387.9,324.5,387.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.9,388.4c0.2,0.2,0.4,0.3,0.5,0.5l-0.3,0.3c-0.2-0.2-0.3-0.3-0.5-0.5L325.9,388.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.1,413.9l-0.2,0.3c-0.2-0.1-0.4-0.3-0.6-0.4l0.2-0.3C305.7,413.6,305.9,413.7,306.1,413.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.6,384.7l0.1-0.4l0.7,0.1l-0.1,0.4C318,384.8,317.8,384.7,317.6,384.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M316.1,384.5l0-0.4c0.2,0,0.5,0.1,0.7,0.1l0,0.4C316.6,384.6,316.4,384.5,316.1,384.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314.7,384.5l0-0.4c0.2,0,0.5,0,0.7,0l0,0.4H314.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M313.2,384.6l0-0.4c0.2,0,0.5-0.1,0.7-0.1l0,0.4L313.2,384.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.8,384.8l-0.1-0.4l0.7-0.1l0,0.4C312.3,384.7,312,384.7,311.8,384.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.2,400.2c0,0.2,0,0.5,0,0.8l-0.4,0c0-0.2,0-0.5,0-0.7L331.2,400.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.6,401.8c0-0.2,0-0.5,0-0.7l0.4,0c0,0.2,0,0.5,0,0.7L298.6,401.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M303.6,412.3c-0.2-0.2-0.4-0.3-0.5-0.5l0.3-0.3c0.2,0.2,0.3,0.3,0.5,0.5L303.6,412.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M310.4,385.1l-0.1-0.4c0.2-0.1,0.5-0.1,0.7-0.2l0.1,0.4C310.9,385,310.6,385.1,310.4,385.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M303.1,389.7l-0.3-0.2c0.2-0.2,0.3-0.4,0.5-0.5l0.3,0.2C303.5,389.3,303.3,389.5,303.1,389.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M306.5,386.9l-0.2-0.3c0.2-0.1,0.4-0.3,0.6-0.4l0.2,0.3C306.9,386.7,306.7,386.8,306.5,386.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330,395.2l-0.3-0.7l0.3-0.1c0.1,0.2,0.2,0.5,0.3,0.7L330,395.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.2,388.7l-0.2-0.3c0.2-0.2,0.4-0.3,0.6-0.5l0.2,0.3C304.5,388.3,304.3,388.5,304.2,388.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M305.3,387.7l-0.2-0.3c0.2-0.2,0.4-0.3,0.6-0.4l0.2,0.3C305.6,387.5,305.5,387.6,305.3,387.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M309,385.6l-0.1-0.4l0.7-0.2l0.1,0.3C309.5,385.4,309.3,385.5,309,385.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.4,393.9l-0.3-0.7l0.3-0.2c0.1,0.2,0.2,0.5,0.3,0.7L329.4,393.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M307.7,386.2l-0.2-0.3c0.2-0.1,0.4-0.2,0.7-0.3l0.1,0.3L307.7,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.2,401.7c0,0.2,0,0.5-0.1,0.8l-0.4-0.1c0-0.2,0-0.5,0.1-0.7L331.2,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M311.4,416.1l-0.1,0.4c-0.2,0-0.5-0.1-0.7-0.2l0.1-0.4L311.4,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M299.1,404.7c-0.1-0.2-0.1-0.5-0.2-0.7l0.4-0.1c0.1,0.2,0.1,0.5,0.2,0.7L299.1,404.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.8,403.2c0-0.2-0.1-0.5-0.1-0.7l0.4,0l0.1,0.7L298.8,403.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M312.8,416.4l-0.1,0.4l-0.7-0.1l0.1-0.4C312.3,416.3,312.5,416.4,312.8,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M315.7,416.5l0,0.4l-0.7,0v-0.4C315.2,416.6,315.4,416.5,315.7,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M317.1,416.4l0,0.4l-0.7,0.1l0-0.4C316.6,416.5,316.9,416.4,317.1,416.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M314.2,416.5l0,0.4c-0.2,0-0.5,0-0.7,0l0-0.4L314.2,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M320.2,385l-0.1,0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.5-0.1-0.7-0.2l0.1-0.4c0.2,0.1,0.5,0.1,0.7,0.2 C319.9,384.9,320,384.9,320.2,385z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.7,398.8c0-0.2,0.1-0.5,0.1-0.7l0.4,0c0,0.2-0.1,0.5-0.1,0.7L298.7,398.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.6,400.3c0-0.2,0-0.5,0-0.7l0.4,0c0,0.2,0,0.5,0,0.7H298.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M298.9,397.3c0-0.2,0.1-0.5,0.2-0.7l0.4,0.1c-0.1,0.2-0.1,0.5-0.2,0.7L298.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.1,394.6l-0.3-0.1c0.1-0.2,0.2-0.5,0.3-0.7l0.3,0.1C300.3,394.1,300.2,394.4,300.1,394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M300.7,393.3l-0.3-0.2c0.1-0.2,0.2-0.4,0.4-0.7l0.3,0.2C300.9,392.8,300.8,393.1,300.7,393.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M299.7,395.7l-0.1,0.2l-0.4-0.1l0.1-0.3c0-0.1,0.1-0.3,0.1-0.4l0.4,0.1 C299.8,395.4,299.7,395.6,299.7,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.4,392l-0.3-0.2l0.4-0.6l0.3,0.2C301.7,391.6,301.5,391.8,301.4,392z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M330.7,404.6c-0.1,0.2-0.1,0.5-0.2,0.7l-0.4-0.1c0.1-0.2,0.1-0.5,0.2-0.7L330.7,404.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.4,407.3l0.3,0.2l-0.3,0.7l-0.3-0.2C329.2,407.7,329.3,407.5,329.4,407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.9,409.8l0.3,0.2c-0.1,0.2-0.3,0.4-0.4,0.6l-0.3-0.2C327.6,410.2,327.8,410,327.9,409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M328.7,408.6l0.3,0.2c-0.1,0.2-0.2,0.4-0.4,0.6l-0.3-0.2C328.5,409,328.6,408.8,328.7,408.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327,410.9l0.3,0.2c-0.2,0.2-0.3,0.4-0.5,0.6l-0.3-0.2C326.7,411.3,326.9,411.1,327,410.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M304.9,413l-0.2,0.3c-0.2-0.2-0.4-0.3-0.6-0.5l0.2-0.3L304.9,413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331,403.2c0,0.2-0.1,0.5-0.1,0.7l-0.4-0.1c0-0.2,0.1-0.5,0.1-0.7L331,403.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M326,412l0.2,0.3c-0.2,0.2-0.4,0.3-0.5,0.5l-0.2-0.3L326,412z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.9,405.9l0.3,0.1c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3-0.1L329.9,405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M319.9,415.7l0.1,0.3c-0.2,0.1-0.5,0.1-0.7,0.2l-0.1-0.4C319.5,415.9,319.7,415.8,319.9,415.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325,413l0.2,0.3c-0.2,0.1-0.4,0.3-0.6,0.4l-0.2-0.3C324.6,413.3,324.8,413.1,325,413z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.8,413.8l0.2,0.3c-0.2,0.1-0.4,0.3-0.6,0.4l-0.2-0.3C323.4,414.1,323.6,414,323.8,413.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.6,415.2 308.5,415.6 307.8,415.3 308,414.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M321.3,415.2l0.2,0.3c-0.2,0.1-0.5,0.2-0.7,0.3l-0.1-0.3C320.8,415.4,321,415.3,321.3,415.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M318.5,416.1l0.1,0.3c-0.2,0.1-0.5,0.1-0.7,0.2l-0.1-0.4C318.1,416.2,318.3,416.2,318.5,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.6,414.6l0.2,0.3c-0.2,0.1-0.4,0.2-0.7,0.3l-0.2-0.3L322.6,414.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "307.9,412.9 307.7,412.7 308.2,412.2 308.5,412.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "247.3,464 247.1,463.7 247.7,463.2 247.9,463.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "245.6,465.4 245.4,465.1 246,464.6 246.2,464.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "244.8,466.1 244.6,465.8 245.1,465.3 245.4,465.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "246.5,464.7 246.2,464.4 246.8,463.9 247.1,464.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "308.7,412.2 308.5,412 309.1,411.5 309.3,411.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "309.6,411.5 309.3,411.2 309.9,410.8 310.1,411.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "304.5,415.8 304.3,415.5 304.9,415 305.1,415.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "301.2,418.6 300.9,418.3 301.5,417.9 301.7,418.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "300.3,419.3 300.1,419 300.6,418.6 300.9,418.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "299.5,420 299.2,419.8 299.8,419.3 300,419.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "306.5,413.6 306.8,413.9 306.2,414.4 306,414.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "302,417.9 301.8,417.6 302.3,417.2 302.6,417.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "307.4,412.9 307.6,413.2 307,413.7 306.8,413.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "305.4,415.1 305.1,414.8 305.7,414.3 305.9,414.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "303.7,416.5 303.5,416.2 304,415.7 304.2,416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "302.9,417.2 302.6,416.9 303.2,416.4 303.4,416.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "254.1,458.3 253.8,458 254.4,457.5 254.6,457.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "281.8,434.9 281.6,434.6 282.1,434.2 282.4,434.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "281,435.6 280.7,435.3 281.3,434.9 281.5,435.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "280.1,436.3 279.9,436 280.5,435.6 280.7,435.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 436.5,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -210.8402 268.1914)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 432.2,
    transform: "matrix(0.7593 -0.6508 0.6508 0.7593 -212.9199 289.2528)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "282.6,434.2 282.4,433.9 283,433.5 283.2,433.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "283.5,433.5 283.3,433.2 283.8,432.7 284.1,433  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.9,
    y: 440,
    transform: "matrix(0.7593 -0.6508 0.6508 0.7593 -220.2186 285.1074)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "274.2,441.3 274,441 274.6,440.5 274.8,440.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.4,
    y: 442.2,
    transform: "matrix(0.7835 -0.6214 0.6214 0.7835 -215.8206 265.237)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "285.2,432.1 285,431.8 285.5,431.3 285.7,431.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "273.4,442 273.2,441.7 273.7,441.2 274,441.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "277.6,438.5 277.4,438.2 277.9,437.7 278.2,438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "275.9,439.9 275.7,439.6 276.3,439.1 276.5,439.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "276.8,439.2 276.5,438.9 277.1,438.4 277.3,438.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "278.5,437.8 278.2,437.5 278.8,437 279,437.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.4,
    y: 424.4,
    transform: "matrix(0.7593 -0.6508 0.6508 0.7593 -205.6156 293.3981)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 425.8,
    transform: "matrix(0.7727 -0.6347 0.6347 0.7727 -204.0387 282.2175)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "294.4,424.3 294.2,424 294.8,423.5 295,423.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "292.8,425.7 292.5,425.4 293.1,424.9 293.3,425.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "295.3,423.6 295,423.3 295.6,422.8 295.8,423.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "297,422.2 296.7,421.9 297.3,421.4 297.5,421.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "296.1,422.9 295.9,422.6 296.4,422.1 296.7,422.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286.9,430.7 286.6,430.4 287.2,429.9 287.4,430.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 429.4,
    transform: "matrix(0.7593 -0.6508 0.6508 0.7593 -210.2609 290.7607)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "286,431.4 285.8,431.1 286.4,430.6 286.6,430.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "288.5,429.2 288.3,429 288.9,428.5 289.1,428.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "289.4,428.5 289.1,428.3 289.7,427.8 290,428.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "291.1,427.1 290.8,426.8 291.4,426.4 291.6,426.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 427.3,
    transform: "matrix(0.7474 -0.6644 0.6644 0.7474 -210.6342 300.8951)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.1,
    y: 454.2,
    transform: "matrix(0.7704 -0.6376 0.6376 0.7704 -230.3626 269.0954)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "270,444.8 269.8,444.6 270.4,444.1 270.6,444.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "269.2,445.5 269,445.3 269.5,444.8 269.8,445.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "270.9,444.1 270.6,443.8 271.2,443.4 271.4,443.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "271.7,443.4 271.5,443.1 272,442.7 272.3,442.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "268.4,446.3 268.1,446 268.7,445.5 268.9,445.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.6,
    y: 452.1,
    transform: "matrix(0.7727 -0.6347 0.6347 0.7727 -227.7564 268.4225)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "259.1,454.1 258.9,453.8 259.4,453.3 259.7,453.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "261.6,451.9 261.4,451.6 262,451.2 262.2,451.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "264.1,449.8 263.9,449.5 264.5,449 264.7,449.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "263.3,450.5 263.1,450.2 263.6,449.8 263.9,450  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "265,449.1 264.8,448.8 265.3,448.3 265.6,448.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 447.8,
    transform: "matrix(0.7474 -0.6644 0.6644 0.7474 -230.4475 289.882)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "267.5,447 267.3,446.7 267.9,446.2 268.1,446.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 447.1,
    transform: "matrix(0.7727 -0.6347 0.6347 0.7727 -223.2695 271.0339)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "260,453.3 259.7,453.1 260.3,452.6 260.5,452.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "250.7,461.1 250.5,460.9 251,460.4 251.3,460.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "253.2,459 253,458.7 253.6,458.3 253.8,458.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "252.4,459.7 252.1,459.4 252.7,459 252.9,459.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "251.5,460.4 251.3,460.1 251.9,459.7 252.1,460  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "249,462.6 248.8,462.3 249.3,461.8 249.6,462.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "249.9,461.8 249.6,461.6 250.2,461.1 250.4,461.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "255.7,456.9 255.5,456.6 256.1,456.1 256.3,456.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "254.9,457.6 254.7,457.3 255.2,456.8 255.5,457.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "248.2,463.3 247.9,463 248.5,462.5 248.7,462.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "257.4,455.5 257.2,455.2 257.8,454.7 258,455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "256.6,456.2 256.4,455.9 256.9,455.4 257.1,455.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "208.8,457.6 209.3,457 209.5,457.3 209,457.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.6,
    y: 456.5,
    transform: "matrix(0.6934 -0.7206 0.7206 0.6934 -264.6802 291.2831)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.3,
    y: 458.8,
    transform: "matrix(0.6931 -0.7208 0.7208 0.6931 -267.159 290.541)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "225.8,440.4 225.6,440.1 226.1,439.6 226.3,439.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "221.3,445.1 221,444.9 221.5,444.4 221.8,444.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "219,447.5 218.7,447.3 219.2,446.7 219.5,447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "219.7,446.7 219.5,446.5 220,445.9 220.2,446.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 449.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -254.3555 284.9564)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217.4,449.1 217.2,448.9 217.7,448.3 217.9,448.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "218.2,448.3 217.9,448.1 218.4,447.5 218.7,447.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.2,
    y: 445.4,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -250.4355 286.4952)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "222.8,443.6 222.5,443.3 223,442.8 223.3,443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "222,444.4 221.8,444.1 222.3,443.6 222.5,443.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.3,
    y: 439,
    transform: "matrix(0.6931 -0.7208 0.7208 0.6931 -247.0166 298.2119)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "223.5,442.8 223.3,442.5 223.8,442 224.1,442.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.7,
    y: 450.1,
    transform: "matrix(0.6936 -0.7203 0.7203 0.6936 -258.1805 293.5673)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.1,
    y: 454.9,
    transform: "matrix(0.6936 -0.7203 0.7203 0.6936 -263.0087 291.7249)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.1,454.7 211.8,454.4 212.3,453.9 212.6,454.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "224.3,442 224,441.7 224.6,441.2 224.8,441.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "210.6,456.2 210.3,456 210.8,455.5 211.1,455.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.6,
    y: 453.3,
    transform: "matrix(0.6936 -0.7203 0.7203 0.6936 -261.4008 292.3404)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 450.9,
    transform: "matrix(0.6931 -0.7208 0.7208 0.6931 -259.1012 293.6072)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.1,
    y: 451.7,
    transform: "matrix(0.6936 -0.7203 0.7203 0.6936 -259.7945 292.9523)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.4,
    y: 452.5,
    transform: "matrix(0.6931 -0.7208 0.7208 0.6931 -260.7138 292.9995)",
    className: "st5",
    width: 0.7,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "260.5,639.2 333,562.4 332.4,561.8 259.9,638.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "214,560.5 212.2,563.7 214,566.9 217.8,566.9 219.6,563.6 217.7,560.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221,563.6c0-2.8-2.4-5.1-5.2-5.1c-2.8,0-5.1,2.4-5.1,5.2c0,2.8,2.3,5.1,5.2,5.1 C218.8,568.8,221,566.5,221,563.6z M221.3,563.6c0,3-2.4,5.5-5.4,5.6c-3,0-5.5-2.4-5.5-5.4c0-3,2.4-5.5,5.4-5.6 C218.8,558.1,221.3,560.6,221.3,563.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "332.6,556.7 330.2,559.6 331.6,563.1 335.3,563.6 337.6,560.7 336.2,557.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339,560.9c0.4-2.8-1.5-5.4-4.3-5.9c-2.8-0.4-5.4,1.5-5.8,4.3c-0.4,2.8,1.5,5.5,4.3,5.9 C336,565.7,338.6,563.7,339,560.9z M339.3,561c-0.4,3-3.2,5.1-6.2,4.6c-3-0.4-5.1-3.2-4.6-6.2c0.4-3,3.2-5.1,6.2-4.6 C337.7,555.1,339.8,558,339.3,561z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.6,597.6 209.1,598.8 208.4,602.4 211.2,604.9 214.7,603.7 215.4,600  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M215.8,604.6c1.9-2.1,1.7-5.4-0.5-7.3c-2.1-1.9-5.4-1.7-7.2,0.5s-1.7,5.4,0.4,7.3S213.9,606.8,215.8,604.6 z M216,604.9c-2,2.3-5.5,2.5-7.7,0.5c-2.3-2-2.5-5.5-0.5-7.8c2-2.3,5.5-2.5,7.7-0.5C217.8,599.1,218,602.6,216,604.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "248.4,538.4 246.2,539.6 246.2,542.1 248.3,543.5 250.5,542.2 250.6,539.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.3,542.7c1-1.7,0.5-3.8-1.2-4.8c-1.6-1-3.8-0.5-4.8,1.2c-1,1.7-0.5,3.8,1.2,4.8 C248.2,544.9,250.3,544.4,251.3,542.7z M251.5,542.9c-1.1,1.8-3.3,2.3-5.1,1.2s-2.3-3.4-1.2-5.1c1.1-1.8,3.4-2.3,5.1-1.2 C252.1,538.8,252.6,541.1,251.5,542.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "217.1,565.4 216.4,565.8 256,637.4 256.7,637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "248.2,541.3 255.9,638.5 256.2,638.5 248.5,541.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "216.9,562.1 247.5,541.5 247,540.8 216.4,561.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.7,599.5 215.2,565.9 214.1,565.8 211.6,599.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "326.4,467.3 321,470.2 320.8,476.4 326,479.6 331.4,476.7 331.6,470.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M333.4,478c2.4-4,1.2-9.3-2.8-11.7c-4-2.5-9.2-1.2-11.7,2.8c-2.5,4-1.2,9.2,2.7,11.7 C325.7,483.2,331,482,333.4,478z M333.9,478.3c-2.6,4.3-8.2,5.6-12.4,2.9c-4.2-2.6-5.6-8.3-2.9-12.5c2.6-4.3,8.2-5.6,12.4-2.9 C335.2,468.4,336.5,474,333.9,478.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "329,434.2 327.6,434.9 327.5,436.5 328.9,437.3 330.2,436.6 330.3,435  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.7,436.9c0.6-1,0.3-2.3-0.6-3c-1-0.6-2.3-0.3-3,0.7c-0.6,1-0.4,2.3,0.6,3 C328.8,438.2,330.1,437.9,330.7,436.9z M330.9,437c-0.7,1.1-2.1,1.4-3.2,0.7c-1.1-0.7-1.4-2.1-0.7-3.2c0.7-1.1,2.1-1.4,3.2-0.7 C331.2,434.5,331.5,435.9,330.9,437z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "307,425.2 305.7,426.6 306.3,428.4 308.1,428.9 309.4,427.5 308.9,425.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M310.2,427.7c0.3-1.4-0.5-2.9-2-3.2c-1.4-0.4-2.9,0.5-3.2,2c-0.4,1.4,0.5,2.9,1.9,3.2 C308.4,430,309.8,429.1,310.2,427.7z M310.3,427.7c-0.4,1.5-1.9,2.5-3.4,2.1c-1.5-0.4-2.5-1.9-2.1-3.4c0.4-1.5,1.9-2.5,3.4-2.1 C309.8,424.6,310.7,426.2,310.3,427.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "346.1,434.5 345.1,434.4 344.5,435.3 344.9,436.2 346,436.3 346.6,435.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.1,436.7c0.7-0.3,1-1.2,0.7-2c-0.3-0.7-1.2-1-1.9-0.7c-0.7,0.3-1,1.2-0.7,2 C344.5,436.7,345.4,437,346.1,436.7z M346.2,436.8c-0.8,0.4-1.7,0-2.1-0.8c-0.4-0.8,0-1.7,0.8-2.1c0.8-0.4,1.7,0,2.1,0.7 C347.3,435.5,347,436.4,346.2,436.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "327.4,469.5 308,428 307.7,428.2 327.1,469.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "326.4,478.5 297.8,521.7 297.9,522 326.6,478.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "329,436.7 328.6,436.6 326.1,470.9 326.4,470.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "355.7,452.9 354.3,452.3 353,453.2 353.2,454.7 354.6,455.4 355.9,454.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M354.7,456c1.2-0.1,2-1.2,1.9-2.4c-0.1-1.2-1.2-2-2.4-1.9c-1.2,0.1-2,1.2-1.9,2.4 C352.5,455.2,353.5,456.1,354.7,456z M354.7,456.1c-1.3,0.1-2.4-0.8-2.5-2c-0.1-1.3,0.8-2.4,2-2.6c1.3-0.1,2.4,0.8,2.5,2 C356.9,454.8,356,456,354.7,456.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "378.5,449.4 376.9,449.2 376,450.4 376.6,451.9 378.1,452.1 379.1,450.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.4,452.6c1.1-0.5,1.6-1.7,1.2-2.8c-0.5-1.1-1.7-1.6-2.8-1.2c-1.1,0.5-1.6,1.7-1.2,2.8 C376,452.6,377.3,453.1,378.4,452.6z M378.4,452.8c-1.2,0.5-2.5-0.1-3-1.2c-0.5-1.2,0.1-2.5,1.2-3c1.2-0.5,2.5,0.1,3,1.2 C380.1,450.9,379.6,452.3,378.4,452.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "353.8,454.4 353.6,454.1 328.6,472.5 328.8,472.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "345.4,435.5 325.5,469.3 325.7,469.4 345.5,435.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "333.3,510.8 334.4,509.8 334.1,508.2 332.6,507.8 331.4,508.8 331.8,510.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M330.9,508.7c-0.4,1.1,0.3,2.3,1.4,2.7c1.1,0.4,2.3-0.3,2.7-1.4c0.3-1.1-0.3-2.4-1.4-2.7 C332.4,506.9,331.2,507.5,330.9,508.7z M330.7,508.6c0.4-1.2,1.6-1.9,2.9-1.5s1.9,1.7,1.5,2.9c-0.4,1.2-1.6,1.9-2.8,1.5 C331,511.1,330.4,509.8,330.7,508.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "349,511.2 350.6,509.7 350.1,507.6 348.1,507 346.5,508.5 347,510.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.7,508.2c-0.5,1.6,0.4,3.3,2,3.8c1.6,0.5,3.3-0.4,3.7-2c0.5-1.6-0.4-3.3-2-3.8 C347.9,505.7,346.2,506.6,345.7,508.2z M345.5,508.2c0.5-1.7,2.3-2.7,4-2.1c1.7,0.5,2.7,2.3,2.1,4c-0.5,1.7-2.3,2.7-4,2.1 C346,511.7,345,509.9,345.5,508.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "297.1,522.7 298.7,522.8 299.5,521.4 298.7,520 297.1,519.9 296.3,521.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M296.8,519.4c-1.1,0.6-1.4,2-0.8,3c0.6,1.1,2,1.5,3,0.9c1.1-0.6,1.5-2,0.9-3.1 C299.2,519.2,297.9,518.8,296.8,519.4z M296.7,519.3c1.1-0.6,2.6-0.2,3.2,0.9c0.6,1.2,0.2,2.6-0.9,3.3 c-1.1,0.7-2.6,0.2-3.2-0.9C295.2,521.4,295.6,519.9,296.7,519.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "338.5,496.2 340,496.2 340.8,494.8 340,493.5 338.4,493.5 337.7,494.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.1,493c-1,0.6-1.4,1.9-0.7,3c0.6,1,1.9,1.4,2.9,0.8c1-0.6,1.3-1.9,0.7-3 C340.5,492.7,339.1,492.4,338.1,493z M338,492.8c1.1-0.7,2.5-0.3,3.2,0.8c0.6,1.1,0.3,2.5-0.8,3.2c-1.1,0.6-2.5,0.3-3.1-0.8 C336.6,494.9,337,493.5,338,492.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "316.7,515.2 317.8,515 318.1,514 317.4,513.2 316.4,513.4 316,514.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M316.1,513.1c-0.6,0.5-0.7,1.5-0.1,2.1c0.5,0.6,1.4,0.7,2.1,0.1c0.6-0.5,0.7-1.5,0.1-2.1 C317.6,512.7,316.7,512.6,316.1,513.1z M316,513.1c0.7-0.6,1.6-0.5,2.2,0.2c0.6,0.6,0.5,1.6-0.1,2.2s-1.6,0.5-2.2-0.1 C315.3,514.6,315.4,513.6,316,513.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "338.5,530.5 339.4,529.8 339.2,528.8 338.2,528.4 337.4,529.1 337.6,530.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M337,529c-0.3,0.8,0.1,1.6,0.9,1.9c0.8,0.3,1.6-0.1,1.9-0.9c0.3-0.8-0.1-1.6-0.9-1.9 C338.1,527.8,337.3,528.2,337,529z M336.9,529c0.3-0.8,1.2-1.2,2-1c0.8,0.3,1.2,1.2,0.9,2c-0.3,0.8-1.2,1.2-2,1 C337,530.7,336.6,529.8,336.9,529z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "332.6,508.5 333,508.4 325.8,476.9 325.4,477  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "317.2,514.1 326.7,477.5 326.6,477.4 317.1,514.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "309.2,427.2 309.1,427.5 327.9,436.4 328,436.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "344.9,435.2 329.6,436.5 329.7,436.8 344.9,435.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "345.9,435.9 345.6,436 354.4,452.9 354.7,452.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "345.5,435.5 345.5,435.6 377.1,451.1 377.1,451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "377.2,450.1 354.9,452.9 354.9,453.2 377.2,450.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "332.3,509.8 317.5,514.1 317.6,514.5 332.4,510.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "325.2,478 324.8,478.4 338.7,494.6 339,494.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "338.7,495.4 333.5,508.5 333.9,508.7 339.2,495.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "339.7,495.3 339.4,495.5 348.3,507.8 348.6,507.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "348.1,508.3 333.4,509.7 333.4,510.1 348.1,508.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "333.2,509.9 333.1,509.9 338.2,529.1 338.3,529.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "347.4,509.6 338.7,529.4 338.9,529.5 347.5,509.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "317,514 298.9,521.4 299,521.6 317.1,514.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.5,427.9c0.2,0,0.4,0,0.6,0.1l-0.1,0.3c-0.2,0-0.4-0.1-0.5-0.1L248.5,427.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.9,433.3l-0.2-0.2c0.1-0.1,0.2-0.3,0.3-0.5l0.2,0.2L236.9,433.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.3,434.2L236,434l0.3-0.5l0.2,0.1C236.5,433.9,236.4,434,236.3,434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.8,435.2l-0.3-0.1c0.1-0.2,0.2-0.3,0.3-0.5l0.2,0.1L235.8,435.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "235.3,436.2 235.1,436.1 235.3,435.6 235.5,435.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "237.9,432 237.6,432.4 237.3,432.2 237.7,431.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M249.6,428.1l0.5,0.1l-0.1,0.3c-0.2-0.1-0.3-0.1-0.5-0.1L249.6,428.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "235.1,443.8 234.9,443.9 234.7,443.4 235,443.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235,437.3l-0.3-0.1c0-0.2,0.1-0.4,0.2-0.6l0.3,0.1L235,437.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "234.9,442.8 234.6,442.8 234.5,442.3 234.8,442.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.6,440.6l-0.3,0V440l0.3,0C234.6,440.2,234.6,440.4,234.6,440.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.7,441.7l-0.3,0c0-0.2,0-0.4-0.1-0.6l0.3,0C234.7,441.3,234.7,441.5,234.7,441.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.7,439.5l-0.3,0c0-0.2,0-0.4,0.1-0.6l0.3,0C234.7,439.1,234.7,439.3,234.7,439.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234.8,438.4l-0.3-0.1c0-0.2,0.1-0.4,0.1-0.6l0.3,0.1C234.8,438,234.8,438.2,234.8,438.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.5,446.9l-0.2,0.2c-0.1-0.2-0.2-0.3-0.3-0.5l0.2-0.1C236.3,446.5,236.4,446.7,236.5,446.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M248.9,452.7c-0.2,0-0.4,0.1-0.6,0.1l0-0.3l0.5-0.1L248.9,452.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250,452.4c-0.2,0.1-0.4,0.1-0.6,0.1l-0.1-0.3c0.2,0,0.4-0.1,0.5-0.1L250,452.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M245.5,452.8c-0.2,0-0.4,0-0.6-0.1l0-0.3c0.2,0,0.4,0.1,0.5,0.1L245.5,452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.1,451.7c-0.2,0.1-0.3,0.2-0.5,0.2l-0.1-0.3l0.5-0.2L252.1,451.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.4,452.6c-0.2,0-0.4-0.1-0.6-0.1l0.1-0.3l0.5,0.1L244.4,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.9,450.3l0.2,0.2c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1-0.2C253.6,450.5,253.8,450.4,253.9,450.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.5,444.9l-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5l0.3-0.1C235.4,444.5,235.4,444.7,235.5,444.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "255.6,448.8 255.8,449 255.4,449.4 255.2,449.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.8,449.6l0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.4l-0.2-0.2L254.8,449.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "243.3,452.4 242.8,452.2 242.9,451.9 243.4,452.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "253,450.9 253.1,451.1 252.6,451.4 252.5,451.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.7,428.4c0.2,0,0.4,0.1,0.5,0.2l-0.1,0.3c-0.2-0.1-0.3-0.1-0.5-0.2L250.7,428.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.8,448.6l-0.2,0.2c-0.1-0.1-0.2-0.3-0.4-0.4l0.2-0.2C237.6,448.4,237.7,448.5,237.8,448.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "237.1,447.8 236.9,447.9 236.6,447.5 236.8,447.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M235.9,445.9l-0.2,0.1c-0.1-0.2-0.2-0.4-0.2-0.5l0.2-0.1L235.9,445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.3,450.3c-0.2-0.1-0.3-0.2-0.4-0.4l0.2-0.2c0.1,0.1,0.3,0.2,0.4,0.3L239.3,450.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241.2,451.5l-0.5-0.3l0.1-0.2c0.2,0.1,0.3,0.2,0.5,0.3L241.2,451.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.2,451c-0.1-0.1-0.3-0.2-0.5-0.3l0.2-0.2l0.5,0.3L240.2,451z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.2,452c-0.2-0.1-0.4-0.1-0.5-0.2l0.1-0.2l0.5,0.2L242.2,452z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "238.6,449.4 238.4,449.6 238,449.2 238.2,449  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.1,452.1c-0.2,0.1-0.4,0.1-0.5,0.2l-0.1-0.3c0.2-0.1,0.3-0.1,0.5-0.2L251.1,452.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "254.6,430.9 254.4,430.8 254.6,430.6 254.8,430.7 255,431 254.9,431.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M253.7,429.9c0.2,0.1,0.3,0.2,0.5,0.3l-0.2,0.2c-0.2-0.1-0.3-0.2-0.5-0.3L253.7,429.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255.3,431.5l0.2-0.2l0.4,0.4l-0.2,0.2C255.5,431.8,255.4,431.7,255.3,431.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M251.7,428.8c0.2,0.1,0.3,0.2,0.5,0.2l-0.1,0.2c-0.2-0.1-0.3-0.2-0.5-0.2L251.7,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.3,434.2l0.2-0.1c0.1,0.2,0.2,0.3,0.3,0.5l-0.2,0.1C257.5,434.5,257.4,434.3,257.3,434.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256,432.4l0.2-0.2c0.1,0.1,0.2,0.3,0.3,0.4l-0.2,0.2L256,432.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246.2,428.1l0-0.3c0.2,0,0.4,0,0.6,0v0.3L246.2,428.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M240.3,429.6l0.1,0.2c-0.2,0.1-0.3,0.2-0.5,0.3l-0.1-0.2C240,429.8,240.2,429.7,240.3,429.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.8,435.1l0.3-0.1c0.1,0.2,0.1,0.3,0.2,0.5l-0.2,0.1L257.8,435.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M239.6,430.5c-0.1,0.1-0.3,0.2-0.4,0.3l-0.2-0.2l0.4-0.3L239.6,430.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "256.7,433.2 256.9,433.1 257.2,433.5 257,433.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M241.3,429.1l0.1,0.3c-0.2,0.1-0.3,0.2-0.5,0.2l-0.1-0.2L241.3,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M242.4,428.6l0.1,0.3l-0.5,0.2l-0.1-0.2C242,428.8,242.2,428.7,242.4,428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.6,428.3c-0.2,0-0.4,0.1-0.5,0.1l-0.1-0.3c0.2,0,0.4-0.1,0.6-0.1L244.6,428.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M243.5,428.6c-0.2,0.1-0.4,0.1-0.5,0.2l-0.1-0.3l0.5-0.2L243.5,428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.2,436.2l0.3-0.1c0.1,0.2,0.1,0.4,0.2,0.5l-0.3,0.1C258.4,436.5,258.3,436.3,258.2,436.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.5,443.8l0.3,0.1c0,0.2-0.1,0.4-0.2,0.5l-0.3-0.1C258.4,444.2,258.4,444,258.5,443.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "257.7,445.9 257.9,446 257.6,446.5 257.4,446.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.1,444.9l0.3,0.1c-0.1,0.2-0.1,0.4-0.2,0.5l-0.2-0.1C258,445.2,258,445,258.1,444.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.7,442.7l0.3,0l-0.1,0.6l-0.3-0.1C258.7,443.1,258.7,442.9,258.7,442.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M257.1,446.8l0.2,0.1c-0.1,0.2-0.2,0.3-0.3,0.5l-0.2-0.2C256.9,447.1,257,447,257.1,446.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M252.7,429.3l0.5,0.3l-0.1,0.2c-0.2-0.1-0.3-0.2-0.5-0.3L252.7,429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.9,441.6l0.3,0c0,0.2,0,0.4-0.1,0.6l-0.3,0L258.9,441.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M256.1,448.6l-0.2-0.2l0.2-0.2l0.3-0.4l0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5 C256.3,448.4,256.2,448.5,256.1,448.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "259,440.5 259.2,440.5 259.2,441.1 259,441.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M247.2,452.6l0.5,0l0,0.3c-0.2,0-0.4,0-0.6,0L247.2,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M246.1,452.6c0.2,0,0.4,0,0.6,0v0.3l-0.6,0L246.1,452.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.6,437.2l0.3-0.1c0.1,0.2,0.1,0.4,0.1,0.6l-0.3,0.1C258.7,437.6,258.6,437.4,258.6,437.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.8,438.3l0.3,0l0.1,0.6l-0.3,0C258.9,438.7,258.8,438.5,258.8,438.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.9,439.4l0.3,0c0,0.2,0,0.4,0,0.6l-0.3,0L258.9,439.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "215.9,511.3 213.9,509.5 211.4,510.3 210.8,512.9 212.7,514.7 215.3,513.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M212.5,515.7c2,0.5,4-0.8,4.5-2.8c0.5-2-0.8-4-2.8-4.5c-2-0.5-4,0.8-4.5,2.8 C209.2,513.3,210.5,515.3,212.5,515.7z M212.4,516c-2.1-0.5-3.5-2.6-3-4.8s2.6-3.5,4.8-3c2.1,0.5,3.4,2.6,3,4.8 C216.7,515.1,214.5,516.5,212.4,516z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "214.8,483.9 212,481.3 208.5,482.4 207.6,486.1 210.3,488.6 213.9,487.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M210,490c2.8,0.6,5.6-1.1,6.2-3.9c0.6-2.8-1.1-5.6-3.9-6.3c-2.8-0.6-5.6,1.1-6.2,3.9 C205.5,486.6,207.2,489.4,210,490z M209.9,490.4c-3-0.7-4.8-3.7-4.1-6.7c0.7-3,3.7-4.8,6.6-4.1c3,0.7,4.8,3.7,4.1,6.7 C215.9,489.2,212.9,491.1,209.9,490.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "240.5,572.8 240.4,570 237.9,568.7 235.5,570.2 235.7,573 238.2,574.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234.8,573.6c1.2,1.8,3.6,2.3,5.3,1.1c1.8-1.2,2.3-3.6,1.1-5.4c-1.2-1.8-3.6-2.3-5.3-1.1 S233.6,571.8,234.8,573.6z M234.6,573.8c-1.2-1.9-0.7-4.5,1.2-5.7c1.9-1.2,4.5-0.7,5.7,1.2c1.2,1.9,0.7,4.5-1.2,5.7 C238.4,576.2,235.8,575.7,234.6,573.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "225.4,539.5 224.9,537.7 223.1,537.3 221.8,538.6 222.3,540.3 224.1,540.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.8,540.8c1,1,2.6,1,3.6,0c1-1,1-2.6,0-3.6c-1-1-2.6-1-3.6,0C220.8,538.2,220.8,539.8,221.8,540.8z  M221.7,540.9c-1-1-1-2.8,0-3.8c1.1-1,2.8-1,3.8,0c1,1.1,1,2.8,0,3.8C224.4,542,222.7,542,221.7,540.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "249.1,499.9 247.8,498.6 246.1,499 245.6,500.8 246.8,502.1 248.6,501.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M246.6,502.8c1.3,0.4,2.7-0.4,3.1-1.7c0.4-1.3-0.4-2.8-1.7-3.1c-1.3-0.4-2.7,0.4-3.1,1.7 C244.5,501,245.3,502.4,246.6,502.8z M246.6,502.9c-1.4-0.4-2.3-1.9-1.8-3.3c0.4-1.4,1.9-2.3,3.3-1.9c1.4,0.4,2.3,1.9,1.8,3.4 C249.5,502.5,248,503.4,246.6,502.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "214.2,513.1 223.4,538.3 223.9,538.1 214.8,512.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "209.9,485.9 214,511.2 214.6,511.2 210.4,485.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "214.3,511.5 214.4,511.8 246.7,500.7 246.6,500.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "212.2,486.9 247.2,499.7 247.3,499.5 212.3,486.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "223.2,539.1 238.1,569.8 238.3,569.7 223.4,539  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "253.1,603.7 259.9,604.9 264.3,599.6 262,593.1 255.1,591.9 250.7,597.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M254.2,589.4c-4.9,1.8-7.5,7.4-5.7,12.3c1.8,5,7.3,7.5,12.2,5.7c4.9-1.8,7.5-7.4,5.6-12.3 C264.7,590.1,259.2,587.6,254.2,589.4z M254,588.8c5.3-1.9,11.1,0.8,13.1,6.1c1.9,5.3-0.8,11.2-6,13.1 c-5.3,2-11.1-0.8-13.1-6.1C246.1,596.6,248.8,590.7,254,588.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "261.2,599.6 365.2,616.5 365.3,615.6 261.3,598.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "299.5,516.6 295.8,516.9 294.3,520.3 296.4,523.3 300.1,523 301.6,519.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M300.9,524.2c2.3-1.6,2.9-4.9,1.2-7.2c-1.6-2.3-4.8-2.9-7.1-1.2c-2.3,1.6-2.9,4.9-1.2,7.2 C295.4,525.2,298.6,525.8,300.9,524.2z M301.1,524.5c-2.5,1.7-5.9,1.1-7.6-1.4c-1.7-2.5-1.1-5.9,1.3-7.7 c2.5-1.7,5.9-1.1,7.6,1.3C304.2,519.3,303.6,522.7,301.1,524.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "270.4,492.5 265.3,492.9 263.1,497.7 266.1,501.9 271.2,501.4 273.4,496.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M272.4,503.1c3.2-2.3,4-6.8,1.7-10c-2.3-3.2-6.7-4-10-1.8c-3.2,2.3-4,6.8-1.7,10 C264.7,504.6,269.1,505.4,272.4,503.1z M272.6,503.5c-3.4,2.4-8.2,1.6-10.6-1.9c-2.4-3.5-1.6-8.2,1.9-10.7 c3.4-2.4,8.2-1.6,10.6,1.9C276.9,496.2,276.1,501,272.6,503.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "268.4,536.4 265.4,534.2 262,535.6 261.5,539.3 264.5,541.6 267.9,540.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M264.3,543c2.8,0.3,5.4-1.7,5.7-4.5c0.4-2.8-1.6-5.4-4.5-5.7c-2.8-0.4-5.4,1.7-5.7,4.5 C259.5,540.1,261.5,542.6,264.3,543z M264.3,543.3c-3-0.4-5.1-3.1-4.8-6.1s3.1-5.2,6.1-4.8c3,0.4,5.1,3.1,4.8,6.1 S267.3,543.7,264.3,543.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "337.1,532.7 334.9,531.5 332.7,532.9 332.9,535.5 335.1,536.6 337.2,535.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.2,537.6c1.9-0.1,3.4-1.8,3.3-3.7c-0.1-1.9-1.7-3.4-3.7-3.3c-1.9,0.1-3.4,1.8-3.3,3.7 C331.6,536.2,333.3,537.7,335.2,537.6z M335.2,537.8c-2,0.1-3.8-1.5-3.9-3.5c-0.1-2.1,1.5-3.8,3.5-3.9c2-0.1,3.8,1.5,3.9,3.5 C338.8,535.9,337.2,537.7,335.2,537.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "318.4,471.7 315.9,471.8 314.7,474 316,476.2 318.5,476 319.7,473.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M319.1,476.9c1.6-1,2.1-3.2,1.1-4.8c-1-1.6-3.2-2.1-4.8-1.1c-1.6,1-2.1,3.2-1.1,4.8 C315.3,477.4,317.4,477.9,319.1,476.9z M319.2,477.1c-1.7,1.1-4,0.6-5.1-1.2c-1.1-1.7-0.6-4,1.2-5.1c1.7-1.1,4-0.6,5.1,1.2 C321.4,473.7,320.9,476,319.2,477.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "297.3,522 296.5,521.6 260.1,594.9 260.9,595.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "334.6,534.2 259.2,595.5 259.4,595.7 334.8,534.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "299.8,519.9 334,533.7 334.3,532.9 300.1,519.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "259.9,594.6 261.1,594.7 265.7,539.1 264.5,539.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "266.8,537.6 295.8,520.7 295.2,519.7 266.2,536.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "264.8,536.2 265.6,536.2 266.8,500 266,500  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "268,499.4 297.7,518.4 298.2,517.8 268.4,498.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "298.3,518.4 298.6,518.5 317,474.9 316.7,474.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "271.2,497.9 316.4,473.5 316.3,473.2 271,497.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "250.5,583.3 247.7,579.8 243.4,580.7 241.8,585 244.6,588.5 248.9,587.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M243.9,590.2c3.2,1.2,6.7-0.6,7.9-3.8c1.2-3.3-0.4-7-3.5-8.1c-3.2-1.2-6.7,0.5-7.9,3.8 C239.2,585.3,240.8,589,243.9,590.2z M243.8,590.6c-3.4-1.3-5.1-5.2-3.8-8.7c1.3-3.5,5.1-5.4,8.5-4.1c3.4,1.2,5.1,5.1,3.8,8.7 C251,590,247.2,591.8,243.8,590.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "261.9,553.2 258.9,551.5 256,553.4 256.1,556.9 259.1,558.6 262,556.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M259.1,560c2.6-0.1,4.6-2.3,4.6-5c-0.1-2.7-2.2-4.9-4.8-4.8c-2.6,0.1-4.6,2.3-4.6,5 C254.4,557.9,256.6,560,259.1,560z M259.1,560.3c-2.8,0.1-5.1-2.2-5.1-5.1c-0.1-2.9,2.1-5.3,4.9-5.3c2.8-0.1,5.1,2.2,5.1,5.1 S261.9,560.2,259.1,560.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "193.2,630.7 199.4,578.1 198.6,578.3 192.4,630.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "244.3,516.5 244,513.8 241.4,512.8 239.2,514.6 239.6,517.3 242.1,518.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.7,517.9c1.3,1.6,3.6,1.9,5.3,0.5c1.7-1.3,2-3.7,0.8-5.3c-1.3-1.6-3.7-1.9-5.3-0.6 C237.8,513.9,237.5,516.3,238.7,517.9z M238.5,518.1c-1.3-1.7-1-4.3,0.8-5.7c1.8-1.4,4.3-1.1,5.7,0.6c1.3,1.7,1,4.3-0.8,5.7 C242.4,520.1,239.9,519.8,238.5,518.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "257.6,553.9 242.2,517.1 241.5,517.4 256.9,554.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "242.2,517.1 241.9,517.1 243.9,581.7 244.2,581.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M247.5,580.6l-0.3-0.1l0.2-0.6l0.3,0.1L247.5,580.6z M247.8,579.7l-0.3-0.1l0.2-0.6l0.3,0.1L247.8,579.7z  M248.1,578.9l-0.3-0.1l0.2-0.6l0.3,0.1L248.1,578.9z M248.5,578l-0.3-0.1l0.2-0.6l0.3,0.1L248.5,578z M248.8,577.1l-0.3-0.1 l0.2-0.6l0.3,0.1L248.8,577.1z M249.1,576.3l-0.3-0.1l0.2-0.6l0.3,0.1L249.1,576.3z M249.4,575.4l-0.3-0.1l0.2-0.6l0.3,0.1 L249.4,575.4z M249.8,574.6l-0.3-0.1l0.2-0.6l0.3,0.1L249.8,574.6z M250.1,573.7l-0.3-0.1l0.2-0.6l0.3,0.1L250.1,573.7z  M250.4,572.9l-0.3-0.1l0.2-0.6l0.3,0.1L250.4,572.9z M250.7,572l-0.3-0.1l0.2-0.6l0.3,0.1L250.7,572z M251.1,571.2l-0.3-0.1 l0.2-0.6l0.3,0.1L251.1,571.2z M251.4,570.3l-0.3-0.1l0.2-0.6l0.3,0.1L251.4,570.3z M251.7,569.5l-0.3-0.1l0.2-0.6l0.3,0.1 L251.7,569.5z M252,568.6l-0.3-0.1l0.2-0.6l0.3,0.1L252,568.6z M252.3,567.8l-0.3-0.1l0.2-0.6l0.3,0.1L252.3,567.8z  M252.7,566.9l-0.3-0.1l0.2-0.6l0.3,0.1L252.7,566.9z M253,566l-0.3-0.1l0.2-0.6l0.3,0.1L253,566z M253.3,565.2l-0.3-0.1 l0.2-0.6l0.3,0.1L253.3,565.2z M253.6,564.3l-0.3-0.1l0.2-0.6l0.3,0.1L253.6,564.3z M254,563.5l-0.3-0.1l0.2-0.6l0.3,0.1 L254,563.5z M254.3,562.6l-0.3-0.1l0.2-0.6l0.3,0.1L254.3,562.6z M254.6,561.8l-0.3-0.1l0.2-0.6l0.3,0.1L254.6,561.8z  M254.9,560.9l-0.3-0.1l0.2-0.6l0.3,0.1L254.9,560.9z M255.2,560.1L255,560l0.2-0.6l0.3,0.1L255.2,560.1z M255.6,559.2 l-0.3-0.1l0.2-0.6l0.3,0.1L255.6,559.2z M255.9,558.4l-0.3-0.1l0.2-0.6l0.3,0.1L255.9,558.4z M256.2,557.5l-0.3-0.1l0.2-0.6 l0.3,0.1L256.2,557.5z M256.5,556.6l-0.3-0.1l0.2-0.6l0.3,0.1L256.5,556.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "242.9,584.8 242.4,584.3 197.8,634.4 198.4,634.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "243.5,585.2 203.1,574.7 203.1,575 243.4,585.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "240.7,516 240.4,516 196.1,565 196.4,564.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 240.1,
    y1: 515.5,
    x2: 198.4,
    y2: 634.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M446.2,496.2l-73.3-6.4l5.2,5.7l0.1-0.3l0.3,0.1c0,0.2-0.1,0.3-0.2,0.5l6.8,7.4l0.1,0.1l0,0.1l0.3,0.3 l0.1-0.3l0.7,0.3l-0.1,0.3l-0.5-0.2l6.7,7.3l28.9,16.9l25.9-30C446.8,497.6,446.5,496.9,446.2,496.2z M446.4,495.3l2.7,0.2 l-0.4-4.5l4.5-2.9l5,2.5l0.4,5.4l-0.3,0.2l0,0h0l-3.4,2.2l1.8,2.1c1.6-0.6,3-1.8,3.8-3.5c1.8-3.7,0.2-8.2-3.6-10.1 c-3.8-1.9-8.4-0.5-10.2,3.2C446.1,491.8,446,493.7,446.4,495.3z M456.8,501.1c-0.5,0.2-1,0.3-1.5,0.4l7,24.4l9.9-7.2 L456.8,501.1z M472.7,518.7l7.7,8.8l6.3-13.3c-0.8-0.4-1.6-0.9-2.2-1.6c-0.5-0.5-0.8-1.1-1.1-1.8L472.7,518.7z M483.6,510.2 l1.3-0.9l-0.5-0.2l0.2-0.3l0.5,0.2l1.1-3.6l4.1-0.8l2.8,3.2l-1.2,4l-2.6,0.5l0.8,2.1c1.1-0.1,2.1-0.6,3-1.3 c2.3-2.1,2.5-5.8,0.3-8.2c-2.2-2.4-5.8-2.7-8.1-0.6C483.4,505.7,482.9,508.1,483.6,510.2z M487.7,514.2c0.4,0.1,0.9,0.2,1.3,0.2 l-0.6-1.6L487.7,514.2z M485.1,509.5l-1.4,1c0.2,0.6,0.6,1.2,1.1,1.8c0.6,0.7,1.3,1.2,2.1,1.5l0.7-1.6L485.1,509.5z  M489.1,514.7c-0.5,0-1.1-0.1-1.6-0.2l-6.5,13.7l22.4,25.5l0.1-0.1L489.1,514.7z M504.5,553.6l0.5,1.4l2.7-0.2l1.9,2.7l-1.4,3 l-3.3,0.3l-1.5-2.1l-1.4,0.7c0.7,1.8,2.6,3.1,4.7,2.9c2.5-0.2,4.5-2.4,4.2-4.9c-0.2-2.5-2.5-4.3-5-4.1 C505.4,553.3,504.9,553.4,504.5,553.6z M501.5,559.1c0-0.2-0.1-0.3-0.1-0.5l-23,0.1c0,0.1,0,0.2-0.1,0.2 c-1.3,4.2-5.8,6.5-10.1,5.2c-0.9-0.3-1.8-0.7-2.5-1.3l-5.3,8.3c0.9,0.3,1.7,0.7,2.5,1.3c1.5,1,2.6,2.3,3.4,3.8L501.5,559.1z  M465.9,576.9l-2.4,1.2l-0.4,6.5l-6.1,2.8l-5.7-3.9l0.4-6.3l-2.3-1.7c-2.6,4.2-1.4,9.9,2.9,12.8c4.4,3,10.3,2,13.1-2.3 C467.2,583.3,467.3,579.8,465.9,576.9z M420,553l29.4,21.4l0.2-0.3L429,551.6l-8.8-0.9C420.1,551.4,420.1,552.2,420,553z  M418.9,553.4l-4-2.9l-3.7,8.1l-9.9,0.9l-5.7-8.2l3.9-8.6l-2.3-3.3c-5.9,4.5-7.2,12.9-3,19c4.4,6.2,13,7.7,19.1,3.3 C416.4,559.6,418.2,556.6,418.9,553.4z M392.3,511.5l-22.1-13l2.9,4.2c0.1-0.1,0.3-0.2,0.4-0.3l0.2,0.3 c-0.1,0.1-0.3,0.2-0.4,0.4l24.2,35.1c4.8-3.2,10.9-3.2,15.5-0.3l1.6-1.9L392.3,511.5z M421.1,528.4l-27.8-16.3l21.5,23.5 L421.1,528.4z M421.4,528.6l-6.3,7.3l8.1,8.8l14.4-6.6L421.4,528.6z M455.2,501c0.4-0.1,0.8-0.2,1.2-0.3l-1.5-1.7l0.1,1.3 L455.2,501z M462,526.1l-6.9-24.1l1.4,23.4c1.5,0.1,2.8,0.8,3.7,2.1L462,526.1z M462.1,526.5l-1.8,1.3c0,0.1,0.1,0.1,0.1,0.2 c0.8,1.5,0.6,3.3-0.3,4.6l4.4,2.5L462.1,526.5z M480.3,527.9l-7.8-9l-10,7.3l2.6,9.2l9.2,5.3L480.3,527.9z M503.7,554.1l0-0.1 l0,0L503.7,554.1z M503.4,554.2c-0.7,0.6-1.2,1.3-1.5,2.2l1.4,0.8l0.9-1.9l-0.1-0.3L503.4,554.2z M501.8,558.6 c0,0.1,0,0.2,0.1,0.4l0.8-0.4L501.8,558.6z M503.1,557.6l-1.4-0.8c0,0.3-0.1,0.5-0.1,0.8L503.1,557.6L503.1,557.6z M501.4,557.7 c0-0.3,0-0.7,0.1-1l-26.6-15.2l-3.4,7.2c0.4,0.1,0.9,0.1,1.3,0.3c3.9,1.2,6.3,5,5.8,8.8L501.4,557.7z M465.3,561.9l1.2-1.9 l-1.2-4.6l-2.3-0.2C462.5,557.7,463.5,560.2,465.3,561.9z M439,538.5l24.3,14.2c0.9-1.7,2.5-3,4.3-3.6l-8.2-15.5 c-0.4,0.3-0.7,0.6-1.2,0.8c-2.3,1.1-5.1,0.3-6.4-1.8L439,538.5z M459.9,527.6c-0.8-1.2-2-1.9-3.4-2l0.1,1.4l2.1,1.4L459.9,527.6 z M459.9,532.5c0.8-1.3,1-2.9,0.3-4.4c0-0.1-0.1-0.1-0.1-0.2l-1.1,0.8l-0.3,3.1L459.9,532.5z M459.2,533.3l-0.7-1.3l-2.8,1.4 l-2.3-1.5l-1.4,0.6c1.2,2,3.8,2.7,5.9,1.7C458.5,534,458.9,533.7,459.2,533.3z M459.7,532.8l-0.6-0.3l0.4,0.7 C459.6,533,459.6,532.9,459.7,532.8z M464.7,535.6l-4.8-2.7c-0.1,0.2-0.2,0.3-0.4,0.5l8.3,15.6c0.2-0.1,0.4-0.1,0.6-0.2 L464.7,535.6z M470.5,548.6l3.6-7.6l-8.9-5.1l3.7,12.9C469.4,548.7,469.9,548.6,470.5,548.6z M470.3,549.1c-0.4,0-0.9,0-1.3,0.1 l0.5,1.6L470.3,549.1z M468.6,549.3l-0.5,0.1l1,1.9l0,0L468.6,549.3z M463.7,553l2.2,1.3l3-2.7l-1.1-2 C466.1,550.2,464.6,551.4,463.7,553z M465.5,554.5l-2-1.2c-0.1,0.3-0.3,0.6-0.4,0.9L465.5,554.5z M478.1,557.8 c0.5-3.6-1.7-7.2-5.4-8.3c-0.5-0.1-0.9-0.2-1.4-0.3l-1.1,2.4l4.4,1.3l1.2,4.9L478.1,557.8z M452.3,528.3l-0.3-0.1 c-0.5,1.1-0.7,2.3-0.3,3.5l1.4-0.6l0.2-2.4l-0.7-0.2l0.1-0.4l0.7,0.2l2.3-1.2l-0.1-1.5c-0.5,0.1-1,0.2-1.5,0.4 c-0.8,0.4-1.5,1-1.9,1.8l0.2,0.1L452.3,528.3z M428.6,550.6l34.1,3.6c0.1-0.4,0.3-0.8,0.4-1.1l-24.5-14.4l-14.7,6.8L428.6,550.6 z M420.1,549.7l7.9,0.8l-4.5-4.9l-3.7,1.7C420,548.1,420.1,548.9,420.1,549.7z M416.2,550.2l2.9,2.1c0.1-0.6,0.1-1.2,0.1-1.8 L416.2,550.2z M419.2,549.6c0-0.6-0.1-1.3-0.2-1.9l-3.3,1.5L419.2,549.6z M417.5,541.9c1,1.4,1.7,2.9,2.1,4.5l3.3-1.5l-8-8.7 l-1.5,1.8C414.9,539,416.3,540.3,417.5,541.9z M414.8,548.6l4-1.8c-0.4-1.5-1.1-3-2-4.4c-1.1-1.6-2.5-2.8-4-3.8l-2.7,3.2 L414.8,548.6z M409.7,541.4l0.1,0.2l2.6-3c-4.4-2.5-10-2.5-14.4,0.4l2.3,3.3L409.7,541.4z M459.5,570.9l5.5-8.6 c-2-1.8-3-4.5-2.5-7.2l-32.9-3.5l20.3,22.2C452.3,571.1,456,570.1,459.5,570.9z M459.1,571.5c-3.2-0.7-6.6,0.3-8.9,2.8l2,2.2 l5.2-2.4L459.1,571.5z M465.8,576.6c-0.7-1.4-1.8-2.6-3.2-3.6c-0.8-0.5-1.7-1-2.5-1.2l-1.7,2.6l5,3.4L465.8,576.6z M451,575.6 l-1-1.1c-0.1,0.1-0.1,0.2-0.2,0.2L451,575.6z M477.9,558.7l-2.6,0l-3.4,3.1l-4.5-1.4l-1.3,2c0.7,0.5,1.5,0.9,2.4,1.2 C472.5,564.9,476.7,562.7,477.9,558.7C477.9,558.8,477.9,558.7,477.9,558.7z M480.9,528.6l-5.9,12.5l26.5,15.2 c0.3-0.9,0.9-1.7,1.6-2.3L480.9,528.6z M448.7,496.5l-1.9-0.2c0.2,0.5,0.5,1,0.8,1.5L448.7,496.5z M447.8,498 c0.7,0.9,1.6,1.7,2.7,2.2c1.2,0.6,2.5,0.9,3.7,0.8l-0.1-2.1l-4.8-2.4v0l-0.1,0L447.8,498z M429.6,520l-0.5-0.2l-7.4,8.5 l16.4,9.6l13.3-6.1c-0.4-1.2-0.3-2.6,0.3-3.7l-0.1,0l0.1-0.3l0.1,0c0.5-0.8,1.2-1.5,2.1-1.9c0.5-0.3,1.1-0.4,1.6-0.5l-1.4-23.8 c-1.3,0-2.7-0.3-3.9-0.9c-1.1-0.6-2.1-1.4-2.8-2.3l-18.2,21l0.4,0.2L429.6,520z M372.6,490l-3.1,7.5l0,0l0.5,0.2l-0.1,0.2 l0.3,0.2l0.1-0.3l0.7,0.2l-0.1,0.3l-0.5-0.2l4.9,2.9l-0.2-0.2l0.5-0.6l0.3,0.2c-0.1,0.2-0.3,0.4-0.5,0.5l16.1,9.5l-6.4-7 l-0.5-0.2l0.1-0.2L372.6,490z M357.1,482.3l9.9-1.3l6,7.9l72.9,6.4c-0.4-1.8-0.3-3.6,0.5-5.4c1.9-3.9,6.8-5.4,10.8-3.4 c4,2,5.7,6.8,3.8,10.7l0.4,0.2l-0.2,0.3l-0.5-0.2c-0.9,1.6-2.2,2.7-3.8,3.4l15.3,17.5l10.8-7.9c-0.3-0.7-0.4-1.4-0.4-2.2 l-0.5-0.2l0.2-0.3l0.3,0.2c0.1-1.5,0.7-3,1.9-4.1c2.5-2.2,6.4-1.9,8.7,0.7c2.3,2.6,2.2,6.5-0.3,8.8c-0.9,0.8-2,1.3-3.1,1.4 l14.3,38.6c0.4-0.2,0.9-0.3,1.4-0.4c2.7-0.2,5.1,1.7,5.4,4.3c0.2,2.6-1.8,5-4.5,5.2c-2.2,0.2-4.3-1.1-5-3l-35.2,17.2 c1.5,3.1,1.4,6.9-0.6,9.8c-3.1,4.5-9.3,5.6-14,2.4c-4.6-3.1-5.9-9.2-3.1-13.7L419.7,554c-0.8,3.3-2.8,6.4-5.8,8.5 c-6.6,4.7-15.8,3.1-20.4-3.5c-4.6-6.5-3.1-15.5,3.2-20.3l-27.9-40.4l-9.6,1.2l-6-8L357.1,482.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379,491.7l0.4,0c0-0.2,0.1-0.5,0.1-0.7l-0.4,0C379,491.2,379,491.5,379,491.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.2,493.2c0-0.2,0.1-0.5,0.1-0.7l-0.4-0.1l-0.1,0.7L379.2,493.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.8,494.7c0.1-0.2,0.1-0.5,0.2-0.7l-0.3-0.1c-0.1,0.2-0.1,0.5-0.2,0.7L378.8,494.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.6,478.2l-0.2-0.3c-0.2,0.2-0.4,0.3-0.5,0.5l0.2,0.3L352.6,478.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.6,479.2l-0.3-0.2c-0.2,0.2-0.3,0.4-0.5,0.5l0.3,0.2C351.2,479.6,351.4,479.4,351.6,479.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.8,476.8l0.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.4l-0.2,0.3C371.4,476.5,371.6,476.6,371.8,476.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M350.6,480.3l-0.3-0.2c-0.2,0.2-0.3,0.4-0.4,0.6l0.3,0.2L350.6,480.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M349.8,481.5l-0.3-0.2c-0.1,0.2-0.3,0.4-0.4,0.6l0.3,0.2C349.5,481.9,349.6,481.7,349.8,481.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.7,482.6c-0.1,0.2-0.2,0.4-0.3,0.7l0.3,0.1c0.1-0.2,0.2-0.4,0.3-0.6L348.7,482.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376,499.8l0.3,0.2c0.1-0.2,0.3-0.4,0.4-0.6l-0.3-0.2C376.2,499.4,376.1,499.6,376,499.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.3,476.3l-0.2-0.3c-0.2,0.1-0.4,0.2-0.6,0.4l0.2,0.3C354.9,476.5,355.1,476.4,355.3,476.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.6,475.6l-0.2-0.3l-0.7,0.3l0.2,0.3C356.1,475.8,356.4,475.7,356.6,475.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M357.9,475.1l-0.1-0.4c-0.2,0.1-0.5,0.2-0.7,0.3l0.1,0.3C357.5,475.2,357.7,475.1,357.9,475.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359.3,474.6l-0.1-0.3c-0.2,0.1-0.5,0.1-0.7,0.2l0.1,0.4L359.3,474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.7,474.4l-0.1-0.4c-0.2,0-0.5,0.1-0.7,0.1l0.1,0.3C360.3,474.4,360.5,474.4,360.7,474.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.9,485.8c-0.1-0.2-0.1-0.5-0.2-0.7l-0.4,0.1c0.1,0.2,0.1,0.5,0.2,0.7L378.9,485.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M377.8,497.4c0.1-0.2,0.2-0.5,0.3-0.7l-0.3-0.1l-0.3,0.7L377.8,497.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M362.2,474.2l0-0.4c-0.2,0-0.5,0-0.7,0.1l0,0.4C361.7,474.3,361.9,474.2,362.2,474.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M370.5,476l0.2-0.3c-0.2-0.1-0.4-0.2-0.7-0.3l-0.2,0.3C370.1,475.8,370.3,475.9,370.5,476z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.5,474.6l0.1-0.4l-0.7-0.1l-0.1,0.4C366,474.5,366.3,474.5,366.5,474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M369.2,475.4l0.1-0.3l-0.7-0.3l-0.1,0.3C368.8,475.2,369,475.3,369.2,475.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367.9,474.9l0.1-0.4c-0.2-0.1-0.5-0.1-0.7-0.2l-0.1,0.4C367.4,474.8,367.6,474.8,367.9,474.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,474.2l0-0.4h-0.7v0.4C363.1,474.2,363.4,474.2,363.6,474.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365.1,474.3l0-0.4c-0.2,0-0.5-0.1-0.7-0.1l0,0.4C364.6,474.3,364.8,474.3,365.1,474.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.2,496.9c0.1,0.2,0.2,0.5,0.3,0.7l0.3-0.2c-0.1-0.2-0.2-0.4-0.3-0.6L348.2,496.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M371.8,503.7l0.2,0.3c0.2-0.1,0.4-0.3,0.6-0.4l-0.2-0.3C372.2,503.4,372,503.6,371.8,503.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.4,488.8c0-0.2-0.1-0.5-0.1-0.7l-0.4,0.1l0.1,0.7L379.4,488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M379.2,487.3c0-0.2-0.1-0.5-0.1-0.7l-0.4,0.1c0.1,0.2,0.1,0.5,0.1,0.7L379.2,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M370.5,504.4l0.2,0.3c0.2-0.1,0.4-0.2,0.6-0.4l-0.2-0.3C370.9,504.2,370.7,504.3,370.5,504.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M367.9,505.6l0.1,0.4c0.2-0.1,0.5-0.1,0.7-0.2l-0.1-0.3C368.3,505.4,368.1,505.5,367.9,505.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.5,505.9l0.1,0.4c0.2-0.1,0.5-0.1,0.7-0.2l-0.1-0.4L366.5,505.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M369.2,505.1l0.1,0.3c0.2-0.1,0.4-0.2,0.7-0.3l-0.2-0.3L369.2,505.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.9,477.4l0.2,0.3l0.3-0.3c0.2-0.1,0.4-0.3,0.6-0.4l-0.2-0.3c-0.2,0.1-0.4,0.3-0.6,0.4L352.9,477.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M377.8,483.1c-0.1-0.2-0.2-0.4-0.4-0.7l-0.3,0.2c0.1,0.2,0.2,0.4,0.3,0.6L377.8,483.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.4,484.4c-0.1-0.2-0.2-0.5-0.3-0.7l-0.3,0.1c0.1,0.2,0.2,0.5,0.3,0.7L378.4,484.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M377.1,481.8l-0.4-0.6l-0.3,0.2c0.1,0.2,0.3,0.4,0.4,0.6L377.1,481.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M375.1,479.6l0.3-0.2c-0.2-0.2-0.3-0.4-0.5-0.5l-0.3,0.2C374.8,479.2,374.9,479.4,375.1,479.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M374.1,478.6l0.2-0.3c-0.2-0.2-0.4-0.3-0.6-0.5l-0.2,0.3C373.7,478.2,373.9,478.4,374.1,478.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "375.8,480.5 376,480.7 376.3,480.5 376.1,480.3 375.8,479.9 375.5,480.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373,477.6l0.2-0.3c-0.2-0.1-0.4-0.3-0.6-0.4l-0.2,0.3C372.6,477.3,372.8,477.5,373,477.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M349.7,499.5c0.1,0.2,0.3,0.4,0.4,0.6l0.3-0.2c-0.1-0.2-0.3-0.4-0.4-0.6L349.7,499.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.8,501.5l-0.3,0.3c0.2,0.2,0.4,0.3,0.5,0.5l0.2-0.3C352.2,501.9,352,501.7,351.8,501.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M354,503.4l-0.2,0.3l0.6,0.4l0.2-0.3C354.4,503.7,354.2,503.5,354,503.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M352.9,502.5l-0.2,0.3c0.2,0.2,0.4,0.3,0.6,0.5l0.2-0.3C353.3,502.8,353.1,502.7,352.9,502.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.3,504.2l-0.2,0.3c0.2,0.1,0.4,0.2,0.7,0.4l0.2-0.3C355.7,504.4,355.5,504.3,355.3,504.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.8,498.5l0.3,0.2c0.1-0.2,0.2-0.4,0.4-0.6l-0.3-0.2C377,498.1,376.9,498.3,376.8,498.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.9,498.3c0.1,0.2,0.2,0.4,0.4,0.6l0.3-0.2c-0.1-0.2-0.2-0.4-0.4-0.6L348.9,498.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.5,504.8l-0.1,0.3c0.2,0.1,0.5,0.2,0.7,0.3l0.1-0.4C357,505,356.8,504.9,356.5,504.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "350.9,500.5 350.6,500.7 351.1,501.3 351.3,501  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,506.3l0,0.4c0.2,0,0.5,0,0.8,0l0-0.4C364.1,506.2,363.8,506.3,363.6,506.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M357.9,505.4l-0.1,0.4c0.2,0.1,0.5,0.2,0.7,0.2l0.1-0.3L357.9,505.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359.3,505.8l-0.1,0.4c0.2,0.1,0.5,0.1,0.7,0.2l0.1-0.4C359.7,505.9,359.5,505.9,359.3,505.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M374,501.9l0.3,0.3l0.5-0.5l-0.3-0.3C374.4,501.6,374.2,501.8,374,501.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M362.1,506.2l0,0.4c0.2,0,0.5,0,0.7,0l0-0.4C362.6,506.3,362.4,506.3,362.1,506.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365,506.2l0,0.4l0.7-0.1l-0.1-0.4C365.5,506.1,365.3,506.1,365,506.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.7,506.1l0,0.4l0.7,0.1l0-0.4C361.2,506.1,360.9,506.1,360.7,506.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "373.9,499.5 374.1,499.2 373.4,498.9 373.2,499.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "448.1,526.8 448.3,526.5 447.6,526.2 447.5,526.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "450.2,527.6 450.3,527.2 449.6,527 449.5,527.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "451.2,527.9 451.4,527.6 450.7,527.3 450.5,527.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "449.2,527.2 449.3,526.8 448.6,526.6 448.5,526.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "372.9,499.1 373,498.8 372.4,498.5 372.2,498.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "371.9,498.8 372,498.4 371.3,498.2 371.2,498.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "378.1,501 378.2,500.7 377.5,500.4 377.4,500.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "382.2,502.6 382.3,502.2 381.6,502 381.5,502.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "383.2,502.9 383.3,502.6 382.7,502.3 382.5,502.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "384.2,503.3 384.4,503 383.7,502.7 383.6,503.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "375.5,499.7 375.3,500 376,500.3 376.1,499.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "381.2,502.2 381.3,501.8 380.6,501.6 380.5,501.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "374.4,499.3 374.3,499.6 375,499.9 375.1,499.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "377,500.7 377.2,500.3 376.5,500.1 376.3,500.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "379.1,501.4 379.2,501.1 378.5,500.8 378.4,501.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "380.1,501.8 380.2,501.4 379.6,501.2 379.4,501.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "439.9,523.8 440,523.4 439.3,523.2 439.2,523.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "405.9,511.3 406,510.9 405.3,510.7 405.2,511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "406.9,511.6 407,511.3 406.4,511 406.2,511.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "408,512 408.1,511.7 407.4,511.4 407.3,511.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "409,512.4 409.1,512.1 408.4,511.8 408.3,512.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "402.8,510.1 402.9,509.8 402.2,509.5 402.1,509.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "404.9,510.9 405,510.5 404.3,510.3 404.2,510.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "403.8,510.5 404,510.2 403.3,509.9 403.1,510.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "414.1,514.3 414.3,513.9 413.6,513.7 413.5,514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "415.2,514.7 415.3,514.3 414.6,514.1 414.5,514.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "417.2,515.4 417.4,515.1 416.7,514.8 416.5,515.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "401.8,509.7 401.9,509.4 401.2,509.1 401.1,509.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "416.2,515.1 416.3,514.7 415.6,514.5 415.5,514.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "411,513.2 411.2,512.8 410.5,512.6 410.4,512.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "413.1,513.9 413.2,513.6 412.5,513.3 412.4,513.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "412.1,513.5 412.2,513.2 411.5,512.9 411.4,513.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "410,512.8 410.1,512.4 409.5,512.2 409.3,512.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "391.5,506 391.6,505.6 390.9,505.4 390.8,505.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "393.5,506.7 393.6,506.4 393,506.1 392.8,506.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "390.4,505.6 390.6,505.2 389.9,505 389.8,505.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "392.5,506.3 392.6,506 391.9,505.7 391.8,506.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "389.4,505.2 389.5,504.9 388.8,504.6 388.7,505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "387.3,504.4 387.5,504.1 386.8,503.8 386.6,504.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "388.4,504.8 388.5,504.5 387.8,504.2 387.7,504.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "399.7,509 399.8,508.6 399.1,508.4 399,508.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "398.7,508.6 398.8,508.3 398.1,508 398,508.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "400.7,509.4 400.9,509 400.2,508.8 400,509.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "397.6,508.2 397.8,507.9 397.1,507.6 397,508  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "396.6,507.9 396.7,507.5 396,507.3 395.9,507.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "394.5,507.1 394.7,506.7 394,506.5 393.9,506.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "395.6,507.5 395.7,507.1 395,506.9 394.9,507.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "434.7,521.9 434.9,521.5 434.2,521.3 434.1,521.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "420.3,516.6 420.4,516.2 419.8,516 419.6,516.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "421.3,516.9 421.5,516.6 420.8,516.3 420.7,516.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "419.3,516.2 419.4,515.8 418.7,515.6 418.6,515.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.3,515.8 418.4,515.5 417.7,515.2 417.6,515.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "422.4,517.3 422.5,517 421.8,516.7 421.7,517.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "431.6,520.7 431.8,520.4 431.1,520.1 431,520.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "433.7,521.5 433.8,521.1 433.1,520.9 433,521.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "430.6,520.4 430.8,520 430.1,519.8 429.9,520.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "427.5,519.2 427.7,518.9 427,518.6 426.9,519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "428.6,519.6 428.7,519.3 428,519 427.9,519.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "426.5,518.8 426.6,518.5 425.9,518.2 425.8,518.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "425.5,518.5 425.6,518.1 424.9,517.9 424.8,518.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423.4,517.7 423.5,517.4 422.9,517.1 422.7,517.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.4,518.1 424.6,517.7 423.9,517.5 423.8,517.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "432.7,521.1 432.8,520.8 432.1,520.5 432,520.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "444,525.3 444.1,524.9 443.5,524.7 443.3,525  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "440.9,524.1 441,523.8 440.4,523.5 440.2,523.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "442,524.5 442.1,524.2 441.4,523.9 441.3,524.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "443,524.9 443.1,524.6 442.4,524.3 442.3,524.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "446.1,526 446.2,525.7 445.5,525.4 445.4,525.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "445,525.7 445.2,525.3 444.5,525.1 444.4,525.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "437.8,523 438,522.7 437.3,522.4 437.1,522.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "438.9,523.4 439,523 438.3,522.8 438.2,523.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "447.1,526.4 447.2,526.1 446.5,525.8 446.4,526.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "435.8,522.2 435.9,521.9 435.2,521.7 435.1,522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "436.8,522.6 436.9,522.3 436.2,522 436.1,522.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "482.2,507.6 481.6,507.3 481.4,507.6 482.1,507.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "481.2,507.1 480.6,506.8 480.4,507.1 481.1,507.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "483.5,508.2 483.4,508.6 484,508.9 484.2,508.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "460.4,497.3 460.5,496.9 459.9,496.6 459.7,496.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "466.3,500.2 466.5,499.8 465.8,499.5 465.6,499.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "469.3,501.6 469.4,501.3 468.8,501 468.6,501.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "468.3,501.1 468.4,500.8 467.8,500.5 467.6,500.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "472.2,503.1 472.4,502.7 471.7,502.4 471.6,502.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "471.2,502.6 471.4,502.3 470.7,501.9 470.6,502.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.8,
    y: 501.4,
    transform: "matrix(0.4363 -0.8998 0.8998 0.4363 -186.5663 705.785)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "467.3,500.7 467.5,500.3 466.8,500 466.6,500.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "464.3,499.2 464.5,498.9 463.8,498.5 463.7,498.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.9,
    y: 499,
    transform: "matrix(0.4363 -0.8998 0.8998 0.4363 -187.1589 699.979)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "459.4,496.8 459.6,496.5 458.9,496.1 458.8,496.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "463.3,498.7 463.5,498.4 462.9,498.1 462.7,498.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "473.2,503.6 473.4,503.2 472.7,502.9 472.5,503.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "479.1,506.5 479.3,506.1 478.6,505.8 478.5,506.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "478.1,506 478.3,505.7 477.6,505.3 477.5,505.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "462.4,498.2 462.5,497.9 461.9,497.6 461.7,497.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "480.1,507 480.3,506.6 479.6,506.3 479.5,506.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "477.1,505.5 477.3,505.2 476.6,504.9 476.5,505.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "474.2,504 474.4,503.7 473.7,503.4 473.5,503.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "475.2,504.5 475.3,504.2 474.7,503.9 474.5,504.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "476.2,505 476.3,504.7 475.7,504.4 475.5,504.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M395.3,685.4l66.7,31.1l-3-7.2l-0.2,0.2l-0.3-0.2c0.1-0.1,0.2-0.3,0.3-0.4l-3.9-9.3l-0.1-0.1l0.1-0.1 l-0.2-0.4l-0.2,0.2l-0.6-0.5l0.2-0.3l0.4,0.4l-3.8-9.2l-21.4-25.8L395,683.3C395.1,684,395.3,684.7,395.3,685.4z M394.8,686.2 l-2.5-1.2l-1.2,4.3l-5.3,1.2l-3.8-4l1.4-5.2l0.3-0.1l0,0v0l3.9-0.9l-1-2.6c-1.7,0.1-3.4,0.7-4.8,2c-2.9,2.8-3,7.6,0,10.7 c2.9,3.1,7.7,3.3,10.6,0.5C393.9,689.6,394.6,688,394.8,686.2z M386.9,677.3c0.5,0,1,0,1.5,0.1l1.7-25.3l-11.7,3.4L386.9,677.3z  M377.9,655.3l-4.3-10.9l-10.4,10.4c0.6,0.6,1.2,1.4,1.5,2.3c0.3,0.7,0.4,1.3,0.4,2L377.9,655.3z M364.8,659.5l-1.5,0.5l0.4,0.4 l-0.3,0.3l-0.4-0.4l-2.3,3l-4.1-0.7l-1.6-4l2.5-3.3l2.6,0.4l0-2.2c-1.1-0.2-2.2-0.2-3.2,0.3c-2.9,1.2-4.3,4.6-3.1,7.6 c1.2,3,4.6,4.5,7.5,3.4C363.5,663.9,364.8,661.8,364.8,659.5z M362.3,654.4c-0.4-0.2-0.7-0.5-1.1-0.6l0,1.7L362.3,654.4z  M363.1,659.6l1.7-0.5c0-0.7-0.1-1.4-0.4-2c-0.3-0.8-0.9-1.5-1.5-2.1l-1.2,1.2L363.1,659.6z M361.1,653.4c0.5,0.2,1,0.4,1.4,0.7 l10.7-10.7l-12.4-31.7l-0.2,0L361.1,653.4z M359.8,611.6l0-1.5l-2.6-0.7l-0.9-3.2l2.3-2.3l3.2,0.9l0.7,2.5l1.6-0.2 c0-2-1.4-3.8-3.5-4.3c-2.5-0.7-5,0.8-5.6,3.2c-0.6,2.4,0.9,4.9,3.4,5.5C358.9,611.6,359.3,611.6,359.8,611.6z M364.5,607.4 c0,0.2-0.1,0.3-0.1,0.5l21.7,7.8l0.1-0.2c2.6-3.5,7.6-4.2,11.3-1.4c0.8,0.6,1.4,1.3,1.9,2l7.8-6c-0.7-0.6-1.4-1.3-2-2.1 c-1.1-1.5-1.7-3.1-1.9-4.7L364.5,607.4z M404,602.8l2.7-0.3l2.5-6l6.7-0.6l4.1,5.6l-2.5,5.8l1.6,2.4c3.9-3,4.7-8.9,1.6-13.1 c-3.1-4.3-9-5.4-13.1-2.4C404.9,596.4,403.6,599.6,404,602.8z M439.1,641.1l-20.4-30.2c-0.1,0.1-0.2,0.2-0.4,0.2l11.8,28.2 l8,3.9C438.4,642.5,438.7,641.7,439.1,641.1z M440.2,641l2.8,4.1l6.2-6.3l9.6,2.5l2.6,9.6l-6.6,6.7l1,3.9 c7.1-2.2,11.2-9.6,9.2-16.9c-2-7.3-9.6-11.7-16.9-9.6C444.8,636,442,638.2,440.2,641z M451.1,689.5l16.4,19.7l-1.3-5 c-0.2,0-0.3,0.1-0.5,0.2l-0.1-0.3c0.2-0.1,0.4-0.1,0.5-0.2l-10.9-41.2c-5.6,1.3-11.3-0.8-14.7-5l-2.1,1.2L451.1,689.5z  M429.7,663.8l20.6,24.8L438,659.1L429.7,663.8z M429.5,663.5l8.4-4.7l-4.6-11.1l-15.8,1.3L429.5,663.5z M388.4,677.9 c-0.4-0.1-0.8-0.1-1.3-0.1l0.8,2.1l0.4-1.3L388.4,677.9z M390.5,652l-1.7,25.1l6.6-22.5c-1.4-0.6-2.4-1.8-2.7-3.2L390.5,652z  M390.5,651.6l2.1-0.6c0-0.1,0-0.2,0-0.2c-0.2-1.7,0.6-3.3,1.9-4.3l-3.3-3.9L390.5,651.6z M373.9,644l4.3,11.1l11.9-3.5l0.6-9.5 l-6.9-8.1L373.9,644z M360.7,611.3v0.1l0,0L360.7,611.3z M361.1,611.3c0.9-0.3,1.6-0.8,2.2-1.6l-1.1-1.3l-1.5,1.5v0.3 L361.1,611.3z M364.1,607.8c0-0.1,0-0.2,0.1-0.4l-0.9,0.1L364.1,607.8z M362.5,608.2l1,1.2c0.1-0.2,0.3-0.5,0.4-0.7L362.5,608.2 L362.5,608.2z M364.2,608.8c-0.1,0.3-0.3,0.6-0.4,0.9l19.9,23.4l5.7-5.6c-0.4-0.2-0.8-0.4-1.2-0.7c-3.3-2.5-4.3-6.8-2.5-10.3 L364.2,608.8z M399.5,617.2l-1.8,1.3l-0.5,4.8l2.1,1C400.6,622.1,400.6,619.4,399.5,617.2z M416.3,648.1l-18-21.7 c-1.5,1.3-3.3,2-5.2,2l2.5,17.4c0.4-0.2,0.9-0.3,1.4-0.4c2.6-0.3,4.9,1.4,5.4,3.9L416.3,648.1z M393,651.2 c0.3,1.4,1.3,2.5,2.5,3l0.4-1.4l-1.5-2L393,651.2z M394.6,646.7c-1.2,0.9-1.9,2.4-1.8,4c0,0.1,0,0.1,0,0.2l1.3-0.4l1.3-2.8 L394.6,646.7z M395.6,646.1l0.2,1.4l3-0.3l1.7,2.2l1.5-0.1c-0.5-2.3-2.6-3.9-5-3.6C396.5,645.8,396,645.9,395.6,646.1z  M394.9,646.5l0.4,0.5l-0.1-0.8C395.1,646.3,395,646.4,394.9,646.5z M391.2,642l3.5,4.2c0.1-0.1,0.3-0.2,0.5-0.3l-2.5-17.5 c-0.2,0-0.4,0-0.6-0.1L391.2,642z M390.1,627.9l-5.9,5.9l6.6,7.8l0.9-13.4C391.2,628.2,390.6,628.1,390.1,627.9z M390.5,627.5 c0.4,0.1,0.8,0.2,1.2,0.3l0.1-1.7L390.5,627.5z M392.1,627.8c0.2,0,0.3,0,0.5,0.1l-0.3-2.1l0,0L392.1,627.8z M398,626.1l-1.6-2 l-3.7,1.5l0.3,2.3C394.8,627.9,396.6,627.3,398,626.1z M396.8,624l1.5,1.8c0.2-0.2,0.5-0.5,0.6-0.7L396.8,624z M386.1,616.6 c-1.7,3.2-0.8,7.4,2.3,9.7c0.4,0.3,0.8,0.5,1.2,0.8l1.9-1.9l-3.7-2.8l0.5-5L386.1,616.6z M400.4,653.2l0.2,0.2 c0.9-0.8,1.4-2,1.5-3.2l-1.5,0.1l-1,2.2l0.5,0.5l-0.2,0.3l-0.5-0.5l-2.6,0.3l-0.4,1.4c0.5,0.1,1,0.2,1.6,0.1 c0.9-0.1,1.7-0.5,2.4-1l-0.2-0.2L400.4,653.2z M430.2,640.3l-30.8-15l0,0c-0.2,0.3-0.5,0.6-0.8,0.9l18.2,21.9l16.1-1.3 L430.2,640.3z M437.9,644.1l-7.2-3.5l2.6,6.2l4.1-0.3C437.4,645.6,437.6,644.8,437.9,644.1z M441.8,645l-2.1-3 c-0.3,0.5-0.5,1.1-0.7,1.7L441.8,645z M438.7,644.5c-0.2,0.6-0.3,1.2-0.4,1.9l3.6-0.3L438.7,644.5z M437.7,652.3 c-0.5-1.7-0.6-3.3-0.5-5l-3.6,0.3l4.6,11l2.1-1.2C439.1,655.9,438.2,654.2,437.7,652.3z M442.5,646.9l-4.4,0.4 c-0.1,1.6,0,3.2,0.4,4.8c0.5,1.9,1.4,3.5,2.5,4.9l3.6-2L442.5,646.9z M444.9,655.5l-0.1-0.2l-3.5,2c3.2,3.9,8.5,5.8,13.7,4.5 l-1-3.9L444.9,655.5z M408,610.6l-8.1,6.2c1.3,2.4,1.3,5.3-0.1,7.7l29.8,14.5L418,611.3C414.9,612.9,411,612.6,408,610.6z  M408.5,610.2c2.8,1.8,6.3,2,9.3,0.4l-1.2-2.8l-5.7,0.5L408.5,610.2z M404,603.2c0.2,1.5,0.8,3.1,1.8,4.4c0.6,0.8,1.2,1.5,2,2 l2.4-1.9l-3.5-4.9L404,603.2z M417.5,609.2l0.6,1.4c0.1,0,0.2-0.1,0.2-0.2L417.5,609.2z M386.6,615.8l2.5,0.9l4.2-1.8l3.8,2.8 l1.9-1.5c-0.5-0.7-1.1-1.4-1.8-2C393.8,611.9,389,612.5,386.6,615.8L386.6,615.8z M373.6,643.1l9.8-9.7L363.5,610 c-0.6,0.7-1.4,1.3-2.3,1.6L373.6,643.1z M393,684.4l1.8,0.8c0-0.5-0.1-1.1-0.3-1.6L393,684.4z M394.4,683.2 c-0.4-1.1-0.9-2.1-1.8-3c-0.9-1-2-1.7-3.2-2.1l-0.6,2.1l3.7,3.9v0l0.1,0L394.4,683.2z M418.9,668.8l0.4,0.4l9.8-5.5L417,649 l-14.6,1.2c0,1.3-0.6,2.5-1.5,3.4l0.1,0.1l-0.2,0.3l-0.1-0.1c-0.7,0.6-1.6,1-2.6,1.1c-0.6,0.1-1.2,0-1.7-0.1l-6.7,22.9 c1.3,0.4,2.4,1.2,3.4,2.2c0.9,0.9,1.5,2,1.9,3.1l24.2-13.6l-0.3-0.3L418.9,668.8z M462.4,716.5l5.5-6l0,0l-0.4-0.3l0.2-0.2 l-0.2-0.3l-0.2,0.2l-0.6-0.5l0.2-0.3l0.4,0.3l-3.6-4.4l0.1,0.3l-0.6,0.4l-0.2-0.3c0.2-0.1,0.4-0.2,0.6-0.4l-11.9-14.4l3.6,8.7 l0.4,0.3l-0.2,0.2L462.4,716.5z M474.3,729l-9.7-2.2l-2.9-9.5l-66.4-30.9c-0.2,1.8-1,3.5-2.3,4.8c-3.1,3-8.2,2.8-11.3-0.5 c-3.1-3.3-3.1-8.4,0-11.4l-0.3-0.3l0.3-0.2l0.3,0.3c1.3-1.2,3-1.8,4.7-1.9l-8.5-21.7l-12.8,3.8c0,0.8-0.1,1.5-0.4,2.2l0.4,0.4 l-0.3,0.2l-0.3-0.3c-0.6,1.4-1.7,2.6-3.2,3.2c-3.1,1.2-6.7-0.4-8-3.6c-1.3-3.2,0.2-6.9,3.3-8.1c1.1-0.5,2.3-0.5,3.4-0.3 l-0.4-41.2c-0.5,0-1,0-1.5-0.2c-2.6-0.7-4.3-3.3-3.6-5.9c0.7-2.6,3.4-4.1,6-3.4c2.2,0.6,3.6,2.5,3.7,4.6l38.9-4.1 c-0.4-3.4,1-6.9,3.9-9c4.4-3.2,10.7-2.1,14,2.5c3.3,4.5,2.4,10.7-1.8,14l20.2,29.9c1.9-2.9,4.8-5.1,8.3-6 c7.8-2.2,15.9,2.5,18,10.3c2.1,7.7-2.3,15.7-9.8,18l12.6,47.6l9.4,2.1l3,9.5L474.3,729z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "415.7,471.8 420.5,476.8 418.6,483.4 411.9,485.1 407.1,480.2 409,473.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M404.6,480.8c-1.3-5.1,1.8-10.4,6.9-11.6c5.1-1.3,10.3,1.8,11.6,7c1.3,5.1-1.8,10.4-6.9,11.6 C411,489.1,405.9,485.9,404.6,480.8z M404,481c1.4,5.5,6.9,8.8,12.3,7.4c5.4-1.4,8.7-6.9,7.4-12.4c-1.4-5.5-6.9-8.8-12.3-7.4 C405.9,469.9,402.6,475.5,404,481z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "416.9,480.8 489.5,557.6 488.9,558.2 416.3,481.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "370.4,559.5 368.6,556.3 370.5,553.1 374.2,553.1 376,556.4 374.1,559.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.4,556.4c0,2.8-2.4,5.1-5.2,5.1c-2.8,0-5.1-2.4-5.1-5.2c0-2.9,2.4-5.1,5.2-5.1 C375.2,551.2,377.5,553.5,377.4,556.4z M377.8,556.4c0-3-2.4-5.5-5.4-5.6c-3,0-5.5,2.4-5.5,5.4c0,3,2.4,5.5,5.4,5.6 C375.2,561.9,377.7,559.4,377.8,556.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "489,563.3 486.7,560.4 488,556.9 491.7,556.4 494,559.3 492.7,562.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M495.4,559.1c0.4,2.8-1.5,5.4-4.3,5.9c-2.8,0.4-5.4-1.5-5.8-4.3c-0.4-2.8,1.5-5.5,4.3-5.9 C492.4,554.3,495,556.3,495.4,559.1z M495.8,559.1c-0.4-3-3.2-5.1-6.2-4.6c-3,0.4-5.1,3.2-4.6,6.2c0.4,3,3.2,5.1,6.2,4.6 C494.1,564.9,496.2,562.1,495.8,559.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "369.1,522.4 365.6,521.3 364.8,517.6 367.6,515.1 371.1,516.3 371.9,520  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M372.2,515.4c1.9,2.1,1.7,5.4-0.5,7.3s-5.4,1.7-7.2-0.5c-1.9-2.1-1.7-5.4,0.5-7.3S370.3,513.2,372.2,515.4 z M372.5,515.1c-2-2.3-5.5-2.5-7.7-0.5c-2.3,2-2.5,5.5-0.5,7.8c2,2.3,5.5,2.5,7.7,0.5C374.2,520.9,374.5,517.4,372.5,515.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "404.9,581.6 402.6,580.4 402.6,577.9 404.7,576.6 407,577.8 407,580.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M407.8,577.3c1,1.6,0.5,3.8-1.2,4.8c-1.6,1-3.8,0.5-4.8-1.2c-1-1.7-0.5-3.8,1.2-4.8 C404.6,575.1,406.8,575.6,407.8,577.3z M408,577.1c-1-1.8-3.3-2.3-5.1-1.2c-1.7,1.1-2.3,3.4-1.2,5.1c1.1,1.8,3.4,2.3,5.1,1.2 C408.5,581.2,409,578.9,408,577.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "373.6,554.6 372.9,554.2 412.4,482.6 413.2,483  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "404.6,578.7 412.3,481.5 412.7,481.5 405,578.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "373.3,557.9 403.9,578.5 403.5,579.2 372.8,558.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "412.1,482.6 412.8,483.5 369.8,518.7 369.1,517.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "369.1,520.5 371.7,554.1 370.5,554.2 368,520.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "482.8,641.5 454.2,598.3 454.4,598 483,641.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "453.5,597.3 455.1,597.2 456,598.6 455.2,600.1 453.5,600.1 452.7,598.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M453.2,600.6c-1.1-0.6-1.5-2-0.9-3c0.6-1.1,2-1.5,3-0.9c1.1,0.6,1.5,2,0.9,3S454.3,601.2,453.2,600.6z  M453.2,600.8c1.1,0.6,2.6,0.2,3.2-0.9c0.6-1.2,0.2-2.6-0.9-3.3c-1.1-0.7-2.6-0.2-3.2,0.9C451.6,598.6,452,600.1,453.2,600.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "495,589.5 495.8,590.2 495.6,591.2 494.6,591.6 493.8,590.9 494,589.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M493.4,591c-0.3-0.8,0.1-1.6,0.9-1.9c0.8-0.3,1.6,0.1,1.9,0.9c0.3,0.8-0.1,1.6-0.9,1.9 C494.5,592.2,493.7,591.8,493.4,591z M493.3,591c0.3,0.8,1.2,1.2,2,1c0.8-0.3,1.2-1.2,0.9-2c-0.3-0.8-1.2-1.2-2-1 C493.5,589.3,493,590.2,493.3,591z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "489.6,610.1 489.5,610.1 494.6,590.9 494.7,590.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "503.9,610.4 495.2,590.6 495.3,590.5 504,610.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "473.5,606 455.3,598.6 455.4,598.4 473.5,605.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "396.9,547.2 396.8,550 394.3,551.3 392,549.8 392.1,547 394.6,545.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M391.2,546.4c1.2-1.8,3.6-2.3,5.3-1.1c1.8,1.2,2.3,3.6,1.1,5.4s-3.6,2.3-5.3,1.1 C390.5,550.6,390,548.2,391.2,546.4z M391,546.2c-1.2,1.9-0.7,4.5,1.2,5.7c1.9,1.2,4.5,0.7,5.7-1.2c1.2-1.9,0.7-4.5-1.2-5.7 S392.2,544.3,391,546.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "381.8,580.5 381.3,582.3 379.6,582.7 378.3,581.5 378.8,579.7 380.5,579.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.2,579.2c1-1,2.6-1,3.6,0c1,1,1,2.6,0,3.6c-1,1-2.6,1-3.6,0C377.3,581.8,377.3,580.2,378.2,579.2z  M378.1,579.1c-1.1,1-1,2.8,0,3.8c1,1,2.8,1,3.8,0c1-1.1,1-2.8,0-3.8C380.9,578,379.2,578,378.1,579.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "370.7,606.9 379.8,581.7 380.3,581.9 371.2,607.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "379.6,580.9 394.5,550.2 394.7,550.4 379.8,581  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "409.6,516.3 416.4,515.1 420.8,520.4 418.4,527 411.6,528.1 407.2,522.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M410.7,530.6c-4.9-1.8-7.5-7.3-5.7-12.3c1.8-5,7.3-7.5,12.2-5.7c4.9,1.8,7.5,7.3,5.7,12.3 C421.1,529.9,415.6,532.5,410.7,530.6z M410.5,531.2c5.2,2,11.1-0.8,13.1-6.1c1.9-5.3-0.8-11.2-6-13.1 c-5.3-2-11.1,0.8-13.1,6.1C402.5,523.4,405.2,529.3,410.5,531.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "352.1,452.9 355.8,452.3 358.2,455.1 357,458.6 353.3,459.3 350.9,456.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.8,460.7c-2.7-0.9-4.1-3.9-3.1-6.6c0.9-2.7,3.9-4.1,6.5-3.1c2.7,0.9,4.1,3.9,3.1,6.6 C358.4,460.2,355.5,461.6,352.8,460.7z M352.7,461c2.9,1,6-0.5,7-3.4c1-2.9-0.5-6-3.4-7c-2.8-1-6,0.5-7,3.4 C348.4,456.8,349.9,460,352.7,461z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "417.6,520.4 521.6,503.5 521.8,504.4 417.8,521.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "355.7,457.5 356.3,457 411.2,517.6 410.6,518.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "456,603.4 452.3,603.1 450.7,599.7 452.8,596.7 456.5,597 458.1,600.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M457.4,595.8c2.3,1.6,2.9,4.9,1.2,7.2c-1.6,2.3-4.8,2.9-7.1,1.2c-2.3-1.6-2.9-4.9-1.2-7.2 C451.8,594.8,455,594.2,457.4,595.8z M457.5,595.6c-2.5-1.7-5.9-1.1-7.6,1.4c-1.7,2.5-1.1,5.9,1.3,7.7c2.5,1.7,5.9,1.1,7.6-1.4 C460.6,600.7,460,597.3,457.5,595.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "526.1,507.2 522.4,507.4 520.3,504.3 521.9,501 525.6,500.7 527.7,503.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M526.2,499.4c2.5,1.2,3.6,4.3,2.4,6.9c-1.2,2.6-4.3,3.6-6.9,2.4c-2.5-1.2-3.6-4.3-2.4-6.9 C520.6,499.3,523.7,498.2,526.2,499.4z M526.4,499.1c-2.7-1.3-6-0.2-7.3,2.5c-1.3,2.7-0.2,6,2.5,7.4c2.7,1.3,6,0.2,7.3-2.5 C530.2,503.7,529.1,500.4,526.4,499.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "424.8,583.6 421.8,585.8 418.4,584.4 418,580.7 420.9,578.4 424.3,579.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M420.8,577c2.8-0.3,5.4,1.7,5.7,4.5c0.4,2.8-1.7,5.4-4.5,5.7c-2.8,0.4-5.4-1.7-5.7-4.5 C416,579.9,418,577.4,420.8,577z M420.7,576.7c-3,0.4-5.1,3.1-4.8,6.1c0.4,3,3.1,5.2,6.1,4.8c3-0.4,5.1-3.1,4.8-6.1 C426.4,578.5,423.7,576.3,420.7,576.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "493.5,587.3 491.3,588.5 489.2,587.1 489.3,584.6 491.6,583.4 493.7,584.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M491.6,582.4c1.9,0.1,3.4,1.8,3.3,3.7c-0.1,1.9-1.7,3.4-3.7,3.3c-1.9-0.1-3.4-1.8-3.3-3.7 C488,583.8,489.7,582.3,491.6,582.4z M491.6,582.2c-2-0.1-3.8,1.5-3.9,3.5c-0.1,2,1.5,3.8,3.5,3.9c2,0.1,3.8-1.5,3.9-3.5 C495.3,584.1,493.7,582.3,491.6,582.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "453.7,598.1 453,598.4 416.6,525.1 417.3,524.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "491,585.8 415.6,524.5 415.8,524.3 491.2,585.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "456.3,600.1 490.4,586.4 490.8,587.1 456.6,600.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "416.4,525.4 417.5,525.3 422.1,580.9 421,581  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "423.2,582.5 452.2,599.3 451.7,600.3 422.6,583.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "421.2,583.8 422,583.8 423.2,620 422.4,620  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "407,536.7 404.2,540.2 399.8,539.3 398.2,535 401,531.5 405.4,532.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M400.4,529.8c3.2-1.2,6.7,0.6,7.9,3.9c1.2,3.3-0.4,7-3.5,8.1c-3.1,1.2-6.7-0.5-7.9-3.9 C395.6,534.7,397.2,531,400.4,529.8z M400.2,529.4c-3.4,1.2-5.1,5.1-3.8,8.7c1.3,3.5,5.1,5.4,8.5,4.1c3.4-1.2,5.1-5.1,3.8-8.7 C407.4,530,403.6,528.2,400.2,529.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "418.4,566.8 415.4,568.5 412.5,566.6 412.6,563.1 415.5,561.4 418.4,563.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.6,560c2.6,0.1,4.6,2.3,4.6,5c-0.1,2.7-2.2,4.8-4.8,4.8c-2.6-0.1-4.6-2.3-4.6-5 C410.8,562.1,413,560,415.6,560z M415.6,559.7c-2.8-0.1-5.1,2.2-5.1,5.1c-0.1,2.9,2.1,5.3,4.9,5.3s5.1-2.2,5.1-5.1 C420.5,562.2,418.4,559.8,415.6,559.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "349.6,489.3 355.8,541.9 355.1,541.8 348.9,489.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "414,566.1 398.6,602.9 397.9,602.6 413.3,565.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "398.6,602.9 398.3,602.9 400.3,538.3 400.6,538.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M403.9,539.4l-0.3,0.1l0.2,0.6l0.3-0.1L403.9,539.4z M404.3,540.3l-0.3,0.1l0.2,0.6l0.3-0.1L404.3,540.3z  M404.6,541.2l-0.3,0.1l0.2,0.6l0.3-0.1L404.6,541.2z M404.9,542l-0.3,0.1l0.2,0.6l0.3-0.1L404.9,542z M405.2,542.9L405,543 l0.2,0.6l0.3-0.1L405.2,542.9z M405.5,543.7l-0.3,0.1l0.2,0.6l0.3-0.1L405.5,543.7z M405.9,544.6l-0.3,0.1l0.2,0.6l0.3-0.1 L405.9,544.6z M406.2,545.4l-0.3,0.1l0.2,0.6l0.3-0.1L406.2,545.4z M406.5,546.3l-0.3,0.1l0.2,0.6l0.3-0.1L406.5,546.3z  M406.9,547.1l-0.3,0.1l0.2,0.6l0.3-0.1L406.9,547.1z M407.2,548l-0.3,0.1l0.2,0.6l0.3-0.1L407.2,548z M407.5,548.8l-0.3,0.1 l0.2,0.6l0.3-0.1L407.5,548.8z M407.8,549.7l-0.3,0.1l0.2,0.6l0.3-0.1L407.8,549.7z M408.1,550.5l-0.3,0.1l0.2,0.6l0.3-0.1 L408.1,550.5z M408.5,551.4l-0.3,0.1l0.2,0.6l0.3-0.1L408.5,551.4z M408.8,552.3l-0.3,0.1l0.2,0.6l0.3-0.1L408.8,552.3z  M409.1,553.1l-0.3,0.1l0.2,0.6l0.3-0.1L409.1,553.1z M409.4,554l-0.3,0.1l0.2,0.6l0.3-0.1L409.4,554z M409.8,554.8l-0.3,0.1 l0.2,0.6l0.3-0.1L409.8,554.8z M410.1,555.7l-0.3,0.1l0.2,0.6l0.3-0.1L410.1,555.7z M410.4,556.5l-0.3,0.1l0.2,0.6l0.3-0.1 L410.4,556.5z M410.7,557.4l-0.3,0.1l0.2,0.6l0.3-0.1L410.7,557.4z M411,558.2l-0.3,0.1l0.2,0.6l0.3-0.1L411,558.2z  M411.4,559.1l-0.3,0.1l0.2,0.6l0.3-0.1L411.4,559.1z M411.7,559.9l-0.3,0.1l0.2,0.6l0.3-0.1L411.7,559.9z M412,560.8l-0.3,0.1 l0.2,0.6l0.3-0.1L412,560.8z M412.3,561.7l-0.3,0.1l0.2,0.6l0.3-0.1L412.3,561.7z M412.6,562.5l-0.3,0.1l0.2,0.6l0.3-0.1 L412.6,562.5z M413,563.4l-0.3,0.1l0.2,0.6l0.3-0.1L413,563.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "399.4,535.2 398.8,535.7 354.2,485.6 354.8,485.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "399.9,534.8 359.6,545.3 359.5,545 399.9,534.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "397.1,604 396.8,604 352.5,555 352.8,555.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 396.6,
    y1: 604.5,
    x2: 354.8,
    y2: 485.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M697.1,561l47.7,56.4l0.3-7.8l-0.3,0.1l-0.2-0.3c0.2-0.1,0.3-0.2,0.5-0.2l0.4-10.1l-0.1-0.2l0.1,0l0-0.4 l-0.2,0.1L745,598l0.3-0.1l0.2,0.5l0.4-10l-8.6-32.5l-39.6,3C697.6,559.7,697.4,560.4,697.1,561z M696.3,561.5l-1.8-2.1 l-2.9,3.4l-5.3-1.2l-1.8-5.3l3.5-4.1l0.3,0.1l0,0l0,0l3.9,0.9l0.2-2.8c-1.6-0.7-3.4-0.8-5.2-0.2c-3.9,1.3-5.9,5.7-4.6,9.7 c1.4,4,5.6,6.2,9.5,4.9C694.1,564.3,695.5,563,696.3,561.5z M692.9,550.1c0.5,0.2,0.9,0.5,1.3,0.8l12.2-22.3l-12.1-1.8 L692.9,550.1z M694,526.3l0.7-11.7l-13.9,5c0.3,0.8,0.5,1.7,0.4,2.7c0,0.7-0.2,1.4-0.5,2L694,526.3z M680.3,524.6l-1.6-0.2 l0.2,0.5l-0.3,0.1l-0.2-0.6l-3.4,1.8l-3.5-2.3l0.2-4.3l3.7-1.9l2.2,1.5l0.9-2c-0.9-0.7-1.9-1.1-3.1-1.1c-3.1-0.2-5.8,2.4-6,5.6 c-0.2,3.2,2.2,6,5.4,6.2C677.2,528,679.3,526.7,680.3,524.6z M680.1,518.9c-0.2-0.4-0.5-0.7-0.8-1l-0.7,1.6L680.1,518.9z  M678.7,524l1.8,0.3c0.3-0.6,0.4-1.3,0.5-2c0-0.9-0.1-1.8-0.4-2.5l-1.6,0.6L678.7,524z M679.5,517.5c0.4,0.4,0.7,0.8,1,1.3 l14.3-5.2l2.1-34l-0.2,0L679.5,517.5z M695.9,479l0.6-1.4l-2.1-1.7l0.5-3.2l3.1-1.1l2.6,2.1l-0.4,2.5l1.5,0.5 c0.8-1.8,0.3-4-1.3-5.4c-2-1.6-4.9-1.4-6.5,0.5c-1.6,1.9-1.3,4.8,0.7,6.5C695.1,478.6,695.5,478.8,695.9,479z M701.9,477.2 c-0.1,0.2-0.2,0.3-0.3,0.4l16.5,16.2c0.1,0,0.1-0.1,0.2-0.1c3.9-2.1,8.7-0.5,10.9,3.5c0.5,0.9,0.8,1.8,0.9,2.7l9.7-2.1 c-0.4-0.8-0.7-1.7-0.9-2.7c-0.3-1.8-0.2-3.5,0.3-5.1L701.9,477.2z M739.9,489.7l2.6,0.9l4.8-4.4l6.4,2.3l1.3,6.8l-4.7,4.3 l0.5,2.8c4.9-1.1,8-6.1,7-11.2c-1-5.2-5.9-8.7-11-7.7C743.5,484.2,740.9,486.7,739.9,489.7z M755.8,539.3l-5.9-36l-0.4,0.1 l-1.2,30.5l5.7,6.9C754.6,540.2,755.2,539.7,755.8,539.3z M756.8,539.7l0.8,4.8l8.4-3.1l7.7,6.3l-1.7,9.8l-8.9,3.3l-0.7,4 c7.4,1,14.2-4,15.5-11.4c1.3-7.5-3.8-14.6-11.3-15.9C763.1,537,759.6,537.9,756.8,539.7z M746.3,588.3l6.6,24.8l0.9-5 c-0.2,0-0.4,0-0.5-0.1l0-0.4c0.2,0,0.4,0,0.6,0.1l7.5-42c-5.7-1.2-10-5.4-11.3-10.8l-2.5,0.2L746.3,588.3z M737.7,555.9 l8.3,31.2l1.2-32L737.7,555.9z M737.6,555.5l9.6-0.7l0.5-12l-15-5.5L737.6,555.5z M694,551.3c-0.3-0.3-0.7-0.5-1.1-0.7l-0.1,2.3 l0.9-1L694,551.3z M706.9,528.6l-12.1,22l15.5-17.6c-1-1.1-1.4-2.6-1.1-4.1L706.9,528.6z M707,528.3l2.2,0.3 c0-0.1,0-0.2,0.1-0.2c0.5-1.6,1.9-2.7,3.5-3.1l-1.4-4.9L707,528.3z M695.1,514.4l-0.7,11.9l12.3,1.9l4.6-8.4l-2.9-10.2 L695.1,514.4z M696.9,479.1l-0.1,0.1l0,0L696.9,479.1z M697.2,479.3c0.9,0.1,1.9-0.1,2.7-0.5l-0.5-1.6l-2,0.7l-0.1,0.3 L697.2,479.3z M701.4,477.4c0.1-0.1,0.2-0.2,0.2-0.3l-0.8-0.3L701.4,477.4z M699.8,477.1l0.4,1.5c0.2-0.1,0.4-0.3,0.6-0.5 L699.8,477.1L699.8,477.1z M701.1,478.3c-0.2,0.2-0.5,0.4-0.8,0.6l8.2,29.6l7.5-2.7c-0.3-0.4-0.5-0.7-0.8-1.1 c-2-3.6-1-8,2.1-10.4L701.1,478.3z M729.8,500.8l-2.2,0.5l-2.4,4.1l1.5,1.8C728.7,505.8,729.8,503.3,729.8,500.8z M732,536 l-7.3-27.3c-1.9,0.6-3.9,0.4-5.6-0.4l-5,16.8c0.5,0,1,0.1,1.5,0.2c2.5,0.8,3.9,3.4,3.3,5.8L732,536z M709.4,529 c-0.3,1.4,0.1,2.8,1,3.8l0.9-1.1l-0.5-2.5L709.4,529z M712.8,525.5c-1.5,0.3-2.8,1.4-3.3,2.9c0,0.1,0,0.1,0,0.2l1.3,0.2l2.4-2 L712.8,525.5z M714,525.4l-0.4,1.4l2.9,1l0.6,2.7l1.4,0.5c0.5-2.2-0.8-4.6-3.1-5.4C715,525.5,714.5,525.5,714,525.4z  M713.2,525.5l0.2,0.7l0.2-0.7C713.5,525.4,713.3,525.5,713.2,525.5z M711.7,519.9l1.5,5.3c0.2,0,0.4-0.1,0.6-0.1l5.1-17 c-0.2-0.1-0.3-0.2-0.5-0.3L711.7,519.9z M716.7,506.6l-7.9,2.9l2.8,9.9l6.5-11.8C717.5,507.3,717.1,507,716.7,506.6z  M717.2,506.4c0.3,0.3,0.6,0.6,1,0.8l0.8-1.5L717.2,506.4z M718.5,507.4l0.4,0.2l0.6-2.1l0,0L718.5,507.4z M724.6,508.2 l-0.7-2.5l-4-0.2l-0.7,2.2C720.9,508.6,722.8,508.8,724.6,508.2z M724.4,505.9l0.6,2.2c0.3-0.1,0.6-0.2,0.9-0.4L724.4,505.9z  M717.7,494.7c-2.9,2.2-3.8,6.3-2,9.8c0.2,0.4,0.5,0.8,0.8,1.2l2.5-0.9l-2.2-4.1l2.6-4.3L717.7,494.7z M715.4,533.9l0.1,0.3 c1.1-0.4,2.1-1.2,2.7-2.3l-1.5-0.5l-1.8,1.6l0.3,0.6l-0.3,0.2l-0.3-0.6l-2.5-0.8l-1,1.1c0.4,0.3,0.9,0.6,1.4,0.8 c0.9,0.3,1.8,0.3,2.6,0.1l-0.1-0.2L715.4,533.9z M748,534.8l-21.8-26.7c-0.4,0.2-0.7,0.4-1.1,0.5l7.3,27.6l15.3,5.6L748,534.8z  M753.4,541.4l-5.1-6.2l-0.2,6.7l3.8,1.4C752.3,542.7,752.8,542,753.4,541.4z M756.6,543.9l-0.6-3.6c-0.5,0.4-0.9,0.8-1.4,1.2 L756.6,543.9z M754,542.1c-0.4,0.5-0.8,1-1.2,1.5l3.5,1.3L754,542.1z M749.8,548.8c0.3-1.7,0.9-3.3,1.7-4.7l-3.4-1.2l-0.5,11.9 l2.4-0.2C749.5,552.8,749.5,550.8,749.8,548.8z M756.4,546l-4.1-1.5c-0.8,1.4-1.4,2.9-1.6,4.5c-0.3,1.9-0.2,3.8,0.2,5.5l4.2-0.3 L756.4,546z M754.9,554.8l0-0.2l-4,0.3c1.3,4.9,5.3,8.8,10.6,9.9l0.7-4L754.9,554.8z M740.3,498.5l-10,2.2 c0.1,2.7-1,5.3-3.3,6.9l21.1,25.8l1.1-30.1C745.6,503.5,742.2,501.6,740.3,498.5z M740.9,498.4c1.8,2.8,4.9,4.5,8.3,4.3l0.1-3 l-5.4-2L740.9,498.4z M739.8,490.1c-0.5,1.5-0.6,3.1-0.2,4.8c0.2,1,0.5,1.9,0.9,2.7l3-0.7l-1.2-5.9L739.8,490.1z M749.6,501.2 l0,1.5c0.1,0,0.2,0,0.3,0L749.6,501.2z M718.5,494.2l1.9,1.9l4.6,0.2l2.3,4.2l2.4-0.5c-0.1-0.9-0.4-1.7-0.8-2.5 C726.8,493.6,722.2,492.2,718.5,494.2C718.6,494.1,718.5,494.2,718.5,494.2z M695.2,513.4l13-4.7l-8.2-29.6 c-0.8,0.4-1.8,0.6-2.8,0.5L695.2,513.4z M695.5,559.1l1.2,1.5c0.2-0.5,0.4-1,0.5-1.6L695.5,559.1z M697.2,558.6 c0.1-1.1,0-2.3-0.3-3.5c-0.4-1.3-1.2-2.4-2-3.2l-1.4,1.6l1.7,5.1l0,0l0.1,0.1L697.2,558.6z M725.7,555.9l0.2,0.5l11.3-0.9 l-4.9-18.5l-13.8-5.1c-0.6,1.2-1.6,2.1-2.8,2.5l0,0.1l-0.3,0.2l-0.1-0.1c-0.9,0.2-1.9,0.2-2.8-0.1c-0.6-0.2-1.1-0.5-1.5-0.8 l-15.8,17.9c1,0.9,1.7,2.1,2.2,3.4c0.4,1.2,0.5,2.4,0.4,3.6l27.8-2.1l-0.2-0.4L725.7,555.9z M745.2,617.6l7.5-3.1v-0.1l-0.2-0.5 l0.2-0.1l-0.1-0.4l-0.3,0.1L752,613l0.3-0.2l0.2,0.5l-1.5-5.5l0,0.3l-0.7,0.1l0-0.4c0.2,0,0.5,0,0.7-0.1l-4.8-18.1l-0.4,9.5 l0.2,0.5l-0.2,0.1L745.2,617.6z M750.8,634l-7.9-6.1l1.3-9.8l-47.5-56.1c-0.9,1.6-2.4,2.8-4.2,3.4c-4.1,1.4-8.7-0.9-10.1-5.2 c-1.4-4.3,0.7-8.9,4.8-10.3l-0.2-0.5l0.4-0.1l0.2,0.5c1.7-0.5,3.5-0.4,5.1,0.2l1.4-23.2l-13.3-2c-0.3,0.7-0.8,1.3-1.3,1.8 l0.2,0.5l-0.3,0.1l-0.1-0.3c-1.1,1-2.6,1.6-4.3,1.5c-3.4-0.2-5.9-3.1-5.7-6.6c0.2-3.5,3.1-6.2,6.4-6c1.2,0.1,2.3,0.5,3.2,1.2 l17-37.6c-0.5-0.2-0.9-0.4-1.3-0.8c-2.1-1.8-2.5-4.8-0.8-6.9c1.7-2,4.8-2.3,6.9-0.5c1.8,1.4,2.3,3.8,1.5,5.7l37.2,12.7 c1.1-3.3,3.8-5.9,7.4-6.6c5.4-1.1,10.6,2.6,11.7,8.2c1.1,5.5-2.3,10.8-7.5,11.9l5.8,35.6c2.9-1.8,6.5-2.6,10.1-2 c8,1.3,13.4,8.9,12.1,16.9c-1.3,7.9-8.7,13.2-16.6,12.2l-8.6,48.5l7.7,5.9l-1.3,9.9L750.8,634z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "717.2,537.9 716.9,538.1 717.2,538.7 717.6,538.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "716.3,535.9 716,536.1 716.3,536.7 716.6,536.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "715.8,534.9 715.5,535.1 715.8,535.7 716.2,535.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "716.8,536.9 716.5,537.1 716.8,537.7 717.1,537.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "746.3,599.8 745.9,600 746.2,600.6 746.6,600.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "721,545.9 720.7,546.1 721,546.7 721.3,546.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "736.4,578.9 736.1,579 736.4,579.7 736.8,579.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "736,577.9 735.6,578 736,578.7 736.3,578.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "735.5,576.9 735.2,577 735.5,577.7 735.8,577.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "735,575.9 734.7,576 735,576.7 735.3,576.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "737.8,581.8 737.5,582 737.8,582.7 738.2,582.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "736.9,579.8 736.6,580 736.9,580.7 737.2,580.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "737.4,580.8 737,581 737.3,581.7 737.7,581.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "732.7,570.9 732.4,571 732.7,571.7 733,571.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "732.2,569.9 731.9,570 732.2,570.7 732.5,570.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "731.3,567.9 731,568 731.3,568.7 731.6,568.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "738.3,582.9 738,583 738.3,583.7 738.6,583.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "731.8,568.9 731.4,569 731.7,569.7 732.1,569.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "734.1,573.9 733.8,574 734.1,574.7 734.4,574.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "733.2,571.9 732.8,572 733.1,572.7 733.5,572.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "733.6,572.9 733.3,573 733.6,573.7 734,573.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "734.6,574.9 734.2,575 734.5,575.7 734.9,575.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "743,592.8 742.7,593 743,593.7 743.3,593.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "742.1,590.8 741.7,591 742,591.7 742.4,591.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "743.5,593.8 743.1,594 743.4,594.7 743.8,594.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "742.5,591.8 742.2,592 742.5,592.7 742.8,592.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "743.9,594.8 743.6,595 743.9,595.7 744.2,595.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "744.9,596.8 744.5,597 744.8,597.7 745.2,597.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "744.4,595.8 744.1,596 744.4,596.6 744.7,596.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "739.2,584.8 738.9,585 739.2,585.7 739.6,585.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "739.7,585.8 739.4,586 739.7,586.7 740,586.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "738.8,583.8 738.5,584 738.8,584.7 739.1,584.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "740.2,586.8 739.8,587 740.2,587.7 740.5,587.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "740.7,587.8 740.3,588 740.6,588.7 741,588.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "741.6,589.8 741.3,590 741.6,590.7 741.9,590.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "741.1,588.8 740.8,589 741.1,589.7 741.4,589.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "723.3,550.9 723,551.1 723.3,551.7 723.7,551.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "729.9,564.9 729.5,565 729.9,565.7 730.2,565.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "729.4,563.9 729.1,564 729.4,564.7 729.7,564.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "730.4,565.9 730,566 730.3,566.7 730.7,566.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "730.8,566.9 730.5,567 730.8,567.7 731.1,567.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "729,562.9 728.6,563 728.9,563.7 729.3,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "724.7,553.9 724.4,554.1 724.7,554.7 725,554.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "723.8,551.9 723.5,552.1 723.8,552.7 724.1,552.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "725.2,554.9 724.9,555 725.2,555.7 725.5,555.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "726.6,557.9 726.3,558 726.6,558.7 726.9,558.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "726.2,556.9 725.8,557 726.1,557.7 726.5,557.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "727.1,558.9 726.8,559 727.1,559.7 727.4,559.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "727.5,559.9 727.2,560 727.5,560.7 727.9,560.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "728.5,561.9 728.2,562 728.5,562.7 728.8,562.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "728,560.9 727.7,561 728,561.7 728.3,561.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "724.3,552.9 723.9,553.1 724.3,553.7 724.6,553.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "719.1,541.9 718.8,542.1 719.1,542.7 719.4,542.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "720.5,544.9 720.2,545.1 720.5,545.7 720.8,545.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "720.1,543.9 719.7,544.1 720,544.7 720.4,544.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "719.6,542.9 719.3,543.1 719.6,543.7 719.9,543.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "718.2,539.9 717.9,540.1 718.2,540.7 718.5,540.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "718.7,540.9 718.3,541.1 718.6,541.7 719,541.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "721.9,547.9 721.6,548.1 721.9,548.7 722.2,548.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "721.5,546.9 721.1,547.1 721.4,547.7 721.8,547.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "717.7,538.9 717.4,539.1 717.7,539.7 718,539.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "722.9,549.9 722.5,550.1 722.8,550.7 723.2,550.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "722.4,548.9 722.1,549.1 722.4,549.7 722.7,549.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "679.4,527.5 679.6,528.1 680,528 679.8,527.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "679.8,528.5 680,529.2 680.3,529.1 680.1,528.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "678.9,526.1 679.3,525.9 679,525.3 678.7,525.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "687.7,550.3 687.3,550.4 687.6,551.1 688,550.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "685.5,544 685.2,544.1 685.4,544.8 685.8,544.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "684.5,540.9 684.1,541 684.3,541.7 684.7,541.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "684.8,541.9 684.5,542 684.7,542.7 685,542.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "683.4,537.7 683,537.9 683.3,538.6 683.6,538.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "683.7,538.8 683.4,538.9 683.6,539.6 684,539.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "684.1,539.8 683.7,540 684,540.6 684.3,540.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "685.2,543 684.8,543.1 685.1,543.8 685.4,543.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "686.2,546.1 685.9,546.2 686.2,546.9 686.5,546.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "685.9,545 685.5,545.2 685.8,545.9 686.1,545.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "688.1,551.3 687.7,551.4 688,552.1 688.3,552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "686.6,547.1 686.3,547.2 686.5,547.9 686.8,547.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "683,536.7 682.7,536.8 682.9,537.5 683.2,537.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "680.8,530.5 680.5,530.6 680.7,531.3 681.1,531.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "681.2,531.5 680.8,531.6 681.1,532.3 681.4,532.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "687,548.2 686.6,548.3 686.9,549 687.2,548.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "680.5,529.4 680.1,529.5 680.4,530.2 680.7,530.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "681.5,532.5 681.2,532.7 681.5,533.4 681.8,533.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "682.6,535.7 682.3,535.8 682.5,536.5 682.9,536.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "682.3,534.6 681.9,534.7 682.2,535.4 682.5,535.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "681.9,533.6 681.6,533.7 681.8,534.4 682.2,534.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M866.8,462.5l-25.7-69.3l-2.9,7.2l0.3,0l0,0.4c-0.2,0-0.3,0-0.5,0l-3.8,9.4l0,0.1l-0.1,0l-0.2,0.4l0.3,0 l0.1,0.7l-0.4,0l0-0.6l-3.7,9.2l-2.9,33.5l38.2,10.6C865.9,463.6,866.3,463,866.8,462.5z M867.7,462.3l1,2.6l3.9-2.2l4.6,2.9 l-0.1,5.6l-4.7,2.7l-0.3-0.2h0v0l-3.4-2.2l-1.1,2.5c1.3,1.2,2.9,1.9,4.8,1.9c4.1,0.1,7.5-3.3,7.6-7.6c0.1-4.3-3.2-7.8-7.3-7.9 C870.8,460.5,869,461.2,867.7,462.3z M867,474.2c-0.4-0.3-0.7-0.7-1-1.1L847,489.9l10.8,5.8L867,474.2z M857.9,496.2l-4.7,10.8 l14.7,0c0-0.9,0.1-1.8,0.5-2.7c0.3-0.7,0.7-1.2,1.1-1.8L857.9,496.2z M870.2,502.5l1.4,0.8v-0.6h0.4l0,0.6l3.8-0.5l2.5,3.4 l-1.7,3.9l-4.1,0.6l-1.6-2.2l-1.5,1.6c0.6,0.9,1.4,1.7,2.5,2.1c2.9,1.2,6.3-0.2,7.5-3.3c1.3-3,0-6.5-2.9-7.7 C874.2,500.3,871.8,500.9,870.2,502.5z M868.5,507.9c0.1,0.4,0.2,0.9,0.4,1.2l1.2-1.2H868.5z M871.5,503.6l-1.6-0.8 c-0.5,0.5-0.8,1.1-1.1,1.7c-0.4,0.8-0.5,1.7-0.5,2.5l1.7,0L871.5,503.6z M868.5,509.5c-0.2-0.5-0.4-1-0.5-1.5l-15.2,0 l-13.5,31.3l0.1,0.1L868.5,509.5z M840,540.1l-1.1,1.1l1.4,2.3l-1.6,2.9l-3.3,0l-1.7-2.9l1.2-2.2l-1.2-1 c-1.4,1.4-1.7,3.7-0.6,5.5c1.3,2.2,4.1,3,6.3,1.7c2.1-1.3,2.8-4.1,1.5-6.3C840.7,540.8,840.4,540.4,840,540.1z M833.8,539.8 c0.1-0.1,0.3-0.2,0.4-0.3l-10-20.8l-0.2,0.1c-4.3,0.7-8.4-2.5-9-7c-0.2-1-0.1-1.9,0-2.8l-9.8-1.3c0.1,0.9,0.1,1.9-0.1,2.9 c-0.3,1.8-1,3.4-2,4.7L833.8,539.8z M802.4,515.1l-2.1-1.7l-6,2.5l-5.2-4.3l1.1-6.9l5.9-2.4l0.5-2.8c-5-0.6-9.6,3-10.4,8.2 c-0.8,5.3,2.6,10.2,7.7,11C797.1,519,800.3,517.6,802.4,515.1z M804.2,463l-6.7,35.9c0.1,0,0.3,0.1,0.4,0.1l11.5-28.4l-3-8.4 C805.7,462.6,805,462.8,804.2,463z M803.4,462.3l0.9-4.8l-8.9,0.1l-5.1-8.6l4.9-8.7l9.4-0.1l2-3.5c-6.6-3.4-14.8-1-18.4,5.5 c-3.8,6.6-1.4,15.1,5.2,18.8C796.7,462.7,800.2,463,803.4,462.3z M829.8,420.1l2.2-25.6l-2.6,4.4c0.2,0.1,0.3,0.2,0.5,0.2 l-0.2,0.3c-0.2-0.1-0.3-0.2-0.5-0.2l-21.3,37c4.9,3,7.5,8.5,7,14l2.4,0.7L829.8,420.1z M826.9,453.5l2.8-32.2l-12,29.7 L826.9,453.5z M826.9,453.9l-9.3-2.6l-4.5,11.2l12.2,10.3L826.9,453.9z M866.4,472.7c0.2,0.4,0.5,0.7,0.8,1l0.9-2.1l-1.2,0.7 L866.4,472.7z M846.6,489.7l18.9-16.6l-20.5,11.3c0.5,1.4,0.5,2.9-0.3,4.2L846.6,489.7z M846.3,490l-1.9-1 c-0.1,0.1-0.1,0.1-0.1,0.2c-1.1,1.3-2.7,1.9-4.3,1.7l-0.4,5.1L846.3,490z M852.8,507.1l4.7-11l-10.9-5.9l-7.2,6.3l-0.8,10.6 L852.8,507.1z M839.2,539.7L839.2,539.7l0-0.1L839.2,539.7z M838.9,539.4c-0.8-0.4-1.8-0.6-2.7-0.4l-0.1,1.7l2.1,0l0.2-0.2 L838.9,539.4z M834.3,539.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.7,0.5L834.3,539.8z M835.8,540.6l0.1-1.6c-0.3,0.1-0.5,0.1-0.8,0.3 L835.8,540.6L835.8,540.6z M835,539c0.3-0.1,0.6-0.2,0.9-0.3l2.4-30.7l-8,0c0.1,0.4,0.2,0.9,0.3,1.3c0.6,4.1-1.8,7.9-5.5,9 L835,539z M815.7,508.1l2.2,0.3l3.7-3l-0.8-2.2C818.3,503.8,816.4,505.7,815.7,508.1z M825.5,474.2l-2.5,28.2 c2,0.1,3.8,1,5.1,2.3l10.5-14.1c-0.4-0.2-0.9-0.4-1.3-0.7c-2-1.6-2.5-4.5-1.1-6.5L825.5,474.2z M844.3,488.5 c0.7-1.2,0.8-2.6,0.3-3.9l-1.3,0.7l-0.3,2.5L844.3,488.5z M840,490.6c1.5,0.2,3.1-0.4,4.1-1.6c0-0.1,0.1-0.1,0.1-0.2l-1.2-0.6 l-2.9,1.1L840,490.6z M838.8,490.3l0.9-1.2l-2.4-1.9l0.4-2.8l-1.2-1c-1.3,1.9-0.9,4.6,1,6.1C838,489.9,838.4,490.1,838.8,490.3z  M839.6,490.5l0.1-0.7l-0.5,0.6C839.3,490.4,839.5,490.5,839.6,490.5z M839.2,496.3l0.4-5.5c-0.2,0-0.4-0.1-0.6-0.1l-10.6,14.3 c0.1,0.1,0.2,0.3,0.4,0.5L839.2,496.3z M829.9,507.1l8.4,0l0.8-10.3l-10,8.9C829.4,506.1,829.7,506.6,829.9,507.1z M829.3,507.1 c-0.2-0.4-0.4-0.8-0.7-1.1l-1.3,1.1L829.3,507.1z M828.5,505.7c-0.1-0.1-0.2-0.3-0.3-0.4l-1.3,1.7l0,0L828.5,505.7z M823,502.8 l-0.2,2.5l3.7,1.5l1.4-1.9C826.6,503.7,824.9,502.9,823,502.8z M822.5,505.1l0.2-2.3c-0.3,0-0.6,0-1,0.1L822.5,505.1z  M824.9,517.9c3.5-1.1,5.8-4.7,5.2-8.5c-0.1-0.5-0.2-1-0.3-1.4H827l0.7,4.6l-3.9,3.2L824.9,517.9z M840.4,481.8l0-0.3 c-1.2,0-2.4,0.4-3.3,1.2l1.2,1l2.2-0.8l-0.1-0.7l0.4,0l0,0.7l2,1.6l1.3-0.7c-0.3-0.5-0.6-0.9-1.1-1.2c-0.7-0.6-1.6-0.9-2.4-1 l0,0.3L840.4,481.8z M810.1,469.9l11.4,32.5v0c0.4,0,0.8-0.1,1.2-0.1l2.5-28.4l-12.4-10.5L810.1,469.9z M807.3,461.8l2.7,7.5 l2.5-6.2l-3.1-2.6C808.7,461,808,461.4,807.3,461.8z M805.1,458.4l-0.7,3.6c0.6-0.2,1.2-0.4,1.7-0.7L805.1,458.4z M807,460.9 c0.6-0.3,1.1-0.6,1.6-1l-2.8-2.4L807,460.9z M813.2,456.1c-0.8,1.5-1.9,2.8-3.2,3.9l2.8,2.3l4.5-11l-2.3-0.6 C814.7,452.5,814.2,454.3,813.2,456.1z M806,456.5l3.4,2.8c1.2-1,2.2-2.3,3.1-3.7c1-1.7,1.5-3.5,1.7-5.2l-4-1.1L806,456.5z  M810.3,448.7l-0.1,0.2l3.9,1.1c0.4-5.1-2-10.1-6.5-12.9l-2,3.5L810.3,448.7z M805,506.7l10.2,1.3c0.8-2.6,2.8-4.7,5.4-5.4 l-11-31.4l-11.3,28C801.7,500.2,804.2,503.1,805,506.7z M804.3,506.6c-0.8-3.2-3.1-5.9-6.3-6.9l-1.1,2.8l4.4,3.7L804.3,506.6z  M802.6,514.8c0.9-1.2,1.6-2.8,1.9-4.4c0.1-1,0.2-1.9,0-2.8l-3-0.4l-0.9,6L802.6,514.8z M797.1,501l0.5-1.4 c-0.1,0-0.2,0-0.3-0.1L797.1,501z M824,518.2l-1.2-2.4l-4.3-1.8l-0.7-4.7l-2.4-0.3c-0.2,0.9-0.2,1.8-0.1,2.7 C816,515.9,819.8,518.8,824,518.2L824,518.2z M852.5,508l-13.8,0l-2.3,30.6c0.9-0.1,1.9,0,2.8,0.5L852.5,508z M867.7,464.9 L867,463c-0.4,0.4-0.7,0.9-1,1.4L867.7,464.9z M865.9,464.7c-0.5,1-0.8,2.2-0.8,3.4c0,1.3,0.3,2.6,0.8,3.7l1.9-1.1l0.1-5.4h0 l0-0.1L865.9,464.7z M838.2,457.6l-0.1-0.6l-10.9-3l-1.7,19l11.2,9.5c0.9-0.9,2.2-1.4,3.5-1.4l0-0.1l0.4,0l0,0.2 c0.9,0.1,1.8,0.4,2.6,1.1c0.5,0.4,0.8,0.8,1.1,1.3l20.9-11.5c-0.6-1.2-0.9-2.5-0.9-4c0-1.3,0.3-2.5,0.8-3.5l-26.8-7.5l0,0.5 L838.2,457.6z M840.8,392.9l-8.1,0.4l0,0l0,0.5l-0.3,0l0,0.4l0.3,0l0.1,0.7l-0.4,0l0-0.5l-0.5,5.7l0.1-0.3l0.7,0.2l-0.1,0.3 c-0.2-0.1-0.5-0.1-0.7-0.2l-1.6,18.7l3.5-8.8l0-0.5l0.2,0L840.8,392.9z M841.2,375.6l5.4,8.4l-4.6,8.8l25.6,69 c1.4-1.2,3.2-1.8,5.1-1.8c4.4,0.1,7.8,3.8,7.7,8.4c-0.1,4.5-3.7,8.1-8,8.1l0,0.5H872l0-0.5c-1.8-0.1-3.4-0.8-4.7-1.9l-9.2,21.4 l11.8,6.4c0.5-0.5,1.1-0.9,1.8-1.3v-0.5l0.4,0v0.4c1.4-0.6,3-0.6,4.5,0c3.1,1.3,4.5,5,3.1,8.2c-1.3,3.2-5,4.8-8,3.5 c-1.1-0.5-2-1.3-2.6-2.2l-28.8,29.6c0.4,0.3,0.7,0.7,1,1.2c1.4,2.4,0.7,5.4-1.6,6.7c-2.3,1.3-5.3,0.5-6.7-1.8 c-1.1-2-0.8-4.4,0.6-5.9l-30.7-24.6c-2.2,2.7-5.6,4.2-9.2,3.7c-5.4-0.8-9.1-6.1-8.2-11.7c0.9-5.5,5.8-9.4,11.1-8.7l6.6-35.5 c-3.3,0.7-7,0.2-10.2-1.6c-7.1-4-9.6-13-5.6-20.1c3.9-7,12.7-9.5,19.7-5.8l24.6-42.7l-5.2-8.2l4.6-8.9L841.2,375.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "701.6,600 701.7,593 707.8,589.6 713.7,593.2 713.6,600.1 707.6,603.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M715.9,601.4c-2.7,4.5-8.6,6.1-13.1,3.4c-4.5-2.7-6.1-8.6-3.4-13.1c2.7-4.6,8.6-6.1,13.1-3.4 C717.1,591,718.6,596.9,715.9,601.4z M716.5,601.8c2.9-4.9,1.3-11.1-3.6-14c-4.9-2.9-11.1-1.3-14,3.6c-2.9,4.9-1.3,11.1,3.6,14 C707.3,608.2,713.6,606.6,716.5,601.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "707.1,592.7 709.5,486.8 710.3,486.8 707.9,592.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "795.8,569.6 794.8,573.2 791.2,574.2 788.6,571.5 789.5,567.9 793.2,567  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M788.6,566.9c2-2,5.3-2,7.3,0c2,2,2,5.3-0.1,7.3c-2,2-5.3,2-7.3,0C786.5,572.2,786.5,568.9,788.6,566.9z  M788.3,566.7c-2.2,2.1-2.2,5.6-0.1,7.8c2.1,2.2,5.6,2.2,7.8,0.1c2.2-2.1,2.2-5.6,0.1-7.8C794,564.5,790.5,564.5,788.3,566.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "713.9,483 713.5,486.7 710,488.3 707,486 707.5,482.3 710.9,480.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M706.3,481.5c1.7-2.3,4.9-2.8,7.2-1.1c2.3,1.7,2.8,4.9,1.1,7.2c-1.7,2.3-4.9,2.8-7.2,1.1 C705.1,487,704.6,483.8,706.3,481.5z M706,481.3c-1.8,2.4-1.3,5.9,1.2,7.7c2.5,1.8,5.9,1.3,7.7-1.2c1.8-2.5,1.3-5.9-1.2-7.7 C711.3,478.3,707.8,478.8,706,481.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "770.6,596.9 772.2,600.3 770.2,603.4 766.5,603.2 764.8,599.8 766.8,596.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M763.4,599.8c0.2-2.8,2.6-5,5.5-4.9c2.8,0.2,5,2.6,4.8,5.4c-0.2,2.8-2.6,5-5.5,4.9 C765.4,605,763.2,602.6,763.4,599.8z M763,599.7c-0.2,3,2.1,5.6,5.2,5.8c3,0.2,5.7-2.1,5.8-5.2c0.2-3-2.1-5.6-5.2-5.8 C765.8,594.4,763.2,596.7,763,599.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "786.8,529.6 787.5,532 785.7,533.8 783.3,533.2 782.6,530.8 784.3,529  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M781.6,530.6c0.4-1.9,2.3-3.1,4.2-2.6c1.9,0.5,3,2.3,2.6,4.2c-0.5,1.9-2.3,3-4.2,2.6 C782.3,534.4,781.2,532.5,781.6,530.6z M781.4,530.5c-0.5,2,0.8,4,2.8,4.5c2,0.5,4-0.8,4.5-2.8c0.5-2-0.8-4-2.8-4.5 C783.9,527.3,781.9,528.5,781.4,530.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "790.1,570.9 790.3,571.7 711.5,594.6 711.3,593.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "784.8,531.8 710.8,595.5 710.6,595.2 784.6,531.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "792.6,568.7 785.3,532.4 786.1,532.3 793.4,568.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "711.8,594.9 711.9,593.7 767.4,599.1 767.3,600.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "769.2,598.3 791.1,572.6 792,573.3 770,599  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "781.3,423.8 783.1,429.7 778.8,434.2 772.9,432.9 771.1,427 775.3,422.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M768.8,426.5c1.1-4.6,5.6-7.5,10.2-6.4c4.6,1,7.4,5.6,6.4,10.2c-1.1,4.6-5.6,7.4-10.2,6.4 C770.6,435.6,767.7,431,768.8,426.5z M768.2,426.3c-1.1,4.9,1.9,9.8,6.8,10.9c4.9,1.1,9.8-1.9,10.9-6.8 c1.1-4.9-1.9-9.8-6.8-10.9S769.3,421.4,768.2,426.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M799.6,399.2c0.2-1.2,1.4-1.9,2.6-1.7c1.2,0.2,1.9,1.4,1.7,2.6c-0.2,1.2-1.4,1.9-2.6,1.7 C800.1,401.5,799.3,400.4,799.6,399.2z M799.5,399.2c-0.3,1.2,0.5,2.5,1.8,2.7c1.2,0.3,2.5-0.5,2.7-1.8 c0.3-1.2-0.5-2.5-1.8-2.7C800.9,397.1,799.7,397.9,799.5,399.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "790.3,386.6 791.2,387.2 791,388.3 790,388.6 789.2,388 789.4,386.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M788.8,388.1c-0.3-0.8,0.1-1.6,0.9-1.9c0.8-0.3,1.6,0.1,1.9,0.9c0.3,0.8-0.1,1.6-0.9,1.9 C789.9,389.3,789.1,388.9,788.8,388.1z M788.7,388.1c0.3,0.8,1.2,1.2,2,0.9c0.8-0.3,1.2-1.2,0.9-2c-0.3-0.8-1.2-1.2-2-0.9 C788.8,386.4,788.4,387.3,788.7,388.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "779,424.7 822.1,408.9 822.2,409.3 779.1,425.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "773.3,431.8 763.4,482.8 763,482.8 773,431.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "801,400.2 801.3,400.4 779,426.6 778.7,426.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "770.5,392.8 772,393.4 772.2,394.9 771,395.9 769.5,395.4 769.3,393.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M769.1,395.7c-0.7-0.9-0.6-2.3,0.3-3c0.9-0.8,2.3-0.6,3,0.3s0.6,2.3-0.3,3 C771.2,396.8,769.8,396.7,769.1,395.7z M769,395.8c0.8,1,2.2,1.1,3.2,0.4c1-0.8,1.2-2.3,0.4-3.2c-0.8-1-2.3-1.1-3.2-0.3 C768.3,393.4,768.2,394.8,769,395.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "756.8,374.3 758,375.2 757.8,376.8 756.4,377.4 755.1,376.4 755.3,374.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M754.6,376.7c-0.5-1.1,0-2.4,1.2-2.8c1.1-0.5,2.4,0.1,2.8,1.1c0.5,1.1,0,2.4-1.2,2.8 C756.3,378.3,755,377.8,754.6,376.7z M754.4,376.7c0.5,1.2,1.9,1.7,3,1.2c1.2-0.5,1.7-1.9,1.2-3c-0.5-1.2-1.8-1.7-3-1.2 C754.5,374.2,753.9,375.5,754.4,376.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "770.8,395.3 771.1,395.2 776,426 775.7,426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "790.2,387.8 780.5,425.9 780.3,425.8 790.1,387.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "745.7,449.9 745.6,448.4 747,447.5 748.3,448.3 748.4,449.8 747.1,450.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M748.9,450.1c-0.6,1.1-1.9,1.5-2.9,0.9c-1-0.6-1.5-1.9-0.9-2.9c0.6-1,1.9-1.5,2.9-0.9 C749.1,447.7,749.5,449,748.9,450.1z M749,450.2c0.6-1.1,0.2-2.5-1-3.1c-1.1-0.6-2.5-0.2-3.1,1c-0.6,1.1-0.2,2.5,1,3.1 C747.1,451.7,748.5,451.3,749,450.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "734.2,439.1 734.1,436.9 735.9,435.7 737.8,436.7 737.9,438.9 736.1,440.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M738.7,439.3c-0.8,1.5-2.6,2-4.1,1.3c-1.5-0.8-2-2.6-1.2-4.1c0.8-1.5,2.6-2,4.1-1.3 C738.9,436,739.4,437.8,738.7,439.3z M738.8,439.4c0.8-1.6,0.2-3.5-1.3-4.3c-1.6-0.8-3.5-0.2-4.3,1.3c-0.8,1.6-0.2,3.5,1.3,4.3 C736,441.6,738,441,738.8,439.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "763.1,484 761.9,482.9 762.3,481.3 763.9,480.9 765.1,482 764.7,483.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M765.7,481.8c0.3,1.2-0.3,2.4-1.5,2.8c-1.2,0.3-2.4-0.3-2.8-1.5c-0.3-1.2,0.3-2.4,1.5-2.8 C764.1,479.9,765.3,480.6,765.7,481.8z M765.8,481.8c-0.4-1.3-1.7-2-3-1.6c-1.3,0.4-2,1.7-1.6,3c0.4,1.3,1.7,2,3,1.6 C765.4,484.4,766.2,483,765.8,481.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "752.3,435.8 751.2,434.7 751.6,433.2 753.1,432.8 754.2,433.9 753.8,435.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M754.8,433.8c0.3,1.1-0.4,2.3-1.6,2.6c-1.2,0.3-2.3-0.4-2.6-1.6c-0.3-1.1,0.4-2.3,1.6-2.6 C753.3,431.9,754.5,432.6,754.8,433.8z M755,433.8c-0.3-1.2-1.6-2-2.8-1.7c-1.2,0.3-2,1.6-1.7,2.8s1.6,2,2.8,1.7 C754.5,436.2,755.3,435,755,433.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "754.4,464.8 753.8,463.9 754.2,462.9 755.3,462.9 755.9,463.7 755.4,464.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M756.3,463.7c0.1,0.8-0.5,1.5-1.4,1.6s-1.5-0.5-1.6-1.4s0.6-1.5,1.4-1.6 C755.5,462.3,756.2,462.9,756.3,463.7z M756.4,463.7c-0.1-0.9-0.8-1.5-1.7-1.4c-0.9,0.1-1.5,0.8-1.4,1.7 c0.1,0.9,0.8,1.5,1.7,1.5C755.8,465.3,756.5,464.6,756.4,463.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "728,460.2 727.9,459.1 728.8,458.5 729.8,459 729.9,460 729,460.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M730.2,460.2c-0.3,0.7-1.2,1.1-2,0.7c-0.7-0.4-1-1.2-0.7-2c0.3-0.7,1.2-1.1,2-0.7 C730.2,458.6,730.6,459.5,730.2,460.2z M730.3,460.3c0.4-0.8,0-1.7-0.8-2.1c-0.8-0.4-1.7,0-2.1,0.8s0,1.7,0.8,2.1 C729,461.4,730,461,730.3,460.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "747.8,448.7 747.6,448.4 775,431.1 775.1,431.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "754.9,463.6 773.9,430.8 774,430.9 755,463.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "790.8,387.9 800.7,399.6 800.4,399.9 790.5,388.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "789.5,387.7 789.6,388 771.4,393.8 771.3,393.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "790.1,387.7 790,387.8 756.6,376.5 756.6,376.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "757.2,375.7 771.1,393.5 770.8,393.7 756.9,375.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "747.1,449.9 754.6,463.4 754.3,463.6 746.8,450  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "774.6,432.3 774.6,432.8 753.3,434.6 753.2,434.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "752.7,435.1 747.2,448.2 746.8,448 752.2,434.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "752,434.4 752.1,434.7 737.1,437.1 737,436.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "736.9,437.7 746.4,449.1 746.1,449.3 736.6,437.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "746.4,449.3 746.5,449.4 729.3,459.5 729.2,459.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "736.4,439.1 728.7,459.3 728.5,459.3 736.3,439  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "755,463.7 762.7,481.8 762.6,481.9 754.9,463.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "768.2,559.6 770.3,557.7 772.9,558.6 773.5,561.3 771.4,563.2 768.8,562.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M771.7,564.3c-2.1,0.5-4.2-0.9-4.6-3c-0.5-2.1,0.9-4.2,3-4.6c2.1-0.5,4.2,0.9,4.6,3 C775.1,561.7,773.8,563.8,771.7,564.3z M771.7,564.5c2.2-0.5,3.7-2.7,3.2-4.9c-0.5-2.2-2.7-3.6-4.9-3.2 c-2.2,0.5-3.7,2.7-3.2,4.9C767.3,563.6,769.5,565,771.7,564.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "804.2,547.9 772,559.2 772,559 804.2,547.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "737.4,572.7 731.7,568.7 732.3,561.8 738.6,558.9 744.3,562.8 743.7,569.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M746.7,561.7c2.2,4.8,0.1,10.5-4.7,12.8c-4.8,2.2-10.5,0.2-12.7-4.6c-2.2-4.8-0.1-10.5,4.7-12.8 C738.7,554.8,744.5,556.9,746.7,561.7z M747.2,561.4c-2.4-5.1-8.5-7.3-13.6-4.9c-5.1,2.4-7.3,8.5-5,13.6 c2.4,5.1,8.5,7.3,13.6,4.9C747.4,572.6,749.6,566.5,747.2,561.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "734.5,564.1 648.5,502.5 648.9,501.8 735,563.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "734.3,652.5 733.5,652.5 737.1,570.6 738,570.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "765.7,477.9 768.1,480.7 766.8,484.2 763.2,484.9 760.8,482.1 762,478.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M759.4,482.3c-0.5-2.8,1.4-5.5,4.2-6c2.8-0.5,5.5,1.4,6,4.2c0.5,2.8-1.4,5.5-4.2,6 C762.5,487,759.9,485.1,759.4,482.3z M759,482.4c0.5,3,3.4,5,6.4,4.4c3-0.5,5-3.4,4.5-6.4c-0.5-3-3.4-5-6.4-4.4 S758.5,479.4,759,482.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "803.5,481.3 806.8,485.3 805,490.2 799.9,491.1 796.6,487.2 798.3,482.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M794.6,487.5c-0.7-3.9,1.9-7.7,5.8-8.4c3.9-0.7,7.6,1.9,8.3,5.8c0.7,3.9-1.9,7.6-5.8,8.4 C799,494,795.3,491.4,794.6,487.5z M794.1,487.6c0.7,4.2,4.7,6.9,8.9,6.2c4.1-0.8,6.9-4.8,6.2-8.9c-0.7-4.2-4.7-6.9-8.9-6.2 C796.2,479.4,793.4,483.4,794.1,487.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "647.8,496.8 650.7,499.2 650,502.9 646.4,504.1 643.6,501.7 644.3,498  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M642.3,502.1c-0.9-2.7,0.5-5.6,3.2-6.6c2.7-0.9,5.6,0.5,6.6,3.2c0.9,2.7-0.5,5.6-3.2,6.6 C646.2,506.2,643.2,504.8,642.3,502.1z M641.9,502.3c1,2.9,4.2,4.4,7,3.4c2.9-1,4.4-4.2,3.4-7c-1-2.9-4.2-4.4-7-3.4 C642.5,496.2,640.9,499.4,641.9,502.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "774,514 777.6,514.6 779,518 776.8,521 773.1,520.4 771.7,517  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M772.2,521.6c-2.2-1.8-2.7-5-0.9-7.2c1.7-2.2,5-2.7,7.2-0.9c2.2,1.7,2.7,5,0.9,7.2 C777.7,522.9,774.4,523.3,772.2,521.6z M772,521.9c2.4,1.9,5.9,1.4,7.7-1c1.9-2.4,1.4-5.9-1-7.7c-2.4-1.9-5.9-1.4-7.7,1 C769.2,516.5,769.6,520,772,521.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "727.5,462.8 730,463.5 730.5,466 728.6,467.7 726.2,466.9 725.7,464.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M725.5,467.6c-1.3-1.4-1.2-3.6,0.3-4.9c1.4-1.3,3.7-1.2,4.9,0.2c1.3,1.4,1.2,3.6-0.2,4.9 C729,469.1,726.8,469,725.5,467.6z M725.3,467.7c1.4,1.5,3.7,1.6,5.3,0.3c1.5-1.4,1.6-3.8,0.3-5.3c-1.4-1.5-3.8-1.6-5.3-0.3 C724,463.9,723.9,466.2,725.3,467.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "783.9,432.6 785.6,434.5 784.9,436.9 782.4,437.5 780.7,435.6 781.5,433.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M779.8,435.8c-0.4-1.9,0.8-3.8,2.6-4.2c1.9-0.4,3.8,0.8,4.2,2.6c0.4,1.9-0.8,3.8-2.6,4.2 C782.1,438.9,780.2,437.7,779.8,435.8z M779.5,435.9c0.5,2,2.5,3.3,4.5,2.8c2-0.5,3.2-2.5,2.8-4.5c-0.5-2-2.5-3.3-4.5-2.8 C780.3,431.9,779.1,433.9,779.5,435.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "763.5,483.3 764.3,483.6 738.6,561.5 737.8,561.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "728.3,465.6 738.9,562.5 738.5,562.6 728,465.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "763.2,480 729.1,465.6 729.4,464.9 763.5,479.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "738.9,561.4 738,560.6 773.9,517.9 774.8,518.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "774.3,516 765.5,483.4 766.6,483.1 775.4,515.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "776.7,516.4 776.1,515.9 800.7,489.3 801.3,489.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "800.3,488 765.7,480.5 765.8,479.7 800.5,487.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "765.3,480.1 765,479.9 782.6,435.9 782.9,436  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "799.1,484.6 784,435.3 784.3,435.2 799.4,484.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "753.6,560 758,559.5 760.6,563.2 758.7,567.4 754.2,567.9 751.7,564.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M753.5,569.5c-3.1-1.4-4.4-5.2-2.9-8.4c1.5-3.2,5.2-4.7,8.2-3.3c3.1,1.4,4.4,5.1,2.9,8.3 C760.2,569.5,756.6,570.9,753.5,569.5z M753.3,569.9c3.3,1.5,7.2-0.1,8.8-3.5c1.6-3.4,0.1-7.4-3.1-8.9 c-3.3-1.5-7.2,0.1-8.8,3.5C748.6,564.4,750,568.4,753.3,569.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "766.7,530.6 770,531.4 770.8,534.8 768.2,537.3 764.9,536.4 764.1,533  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M763.9,537.3c-1.8-1.9-1.7-4.9,0.3-6.8c2-1.9,5-1.9,6.8,0s1.7,4.9-0.3,6.8 C768.8,539.2,765.7,539.2,763.9,537.3z M763.7,537.5c1.9,2,5.2,2,7.3,0s2.2-5.3,0.3-7.3c-1.9-2-5.2-2-7.2,0 C761.9,532.3,761.8,535.5,763.7,537.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "761.1,634.2 793.7,592.5 794.2,593.1 761.6,634.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 767.9,
    y: 526.4,
    transform: "matrix(0.9236 -0.3834 0.3834 0.9236 -141.7705 342.3327)",
    className: "st5",
    width: 40,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "806.2,518.9 806.4,519.1 759.4,563.6 759.2,563.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M757.7,560.2l0.3,0.1l0.2-0.6l-0.3-0.1L757.7,560.2z M758.1,559.4l0.3,0.1l0.2-0.6l-0.3-0.1L758.1,559.4z  M758.4,558.5l0.3,0.1l0.2-0.6l-0.3-0.1L758.4,558.5z M758.8,557.7l0.3,0.1l0.3-0.6l-0.3-0.1L758.8,557.7z M759.2,556.8 l0.3,0.1l0.2-0.6l-0.3-0.1L759.2,556.8z M759.6,556l0.3,0.1l0.2-0.6l-0.3-0.1L759.6,556z M759.9,555.2l0.3,0.1l0.2-0.6 l-0.3-0.1L759.9,555.2z M760.3,554.3l0.3,0.1l0.3-0.6l-0.3-0.1L760.3,554.3z M760.7,553.5l0.3,0.1l0.2-0.6l-0.3-0.1 L760.7,553.5z M761,552.7l0.3,0.1l0.2-0.6l-0.3-0.1L761,552.7z M761.4,551.8l0.3,0.1l0.2-0.6l-0.3-0.1L761.4,551.8z M761.8,551 l0.3,0.1l0.2-0.6l-0.3-0.1L761.8,551z M762.2,550.2l0.3,0.1l0.2-0.6l-0.3-0.1L762.2,550.2z M762.5,549.3l0.3,0.1l0.2-0.5 l-0.3-0.1L762.5,549.3z M762.9,548.5l0.3,0.1l0.2-0.6l-0.3-0.1L762.9,548.5z M763.3,547.7l0.3,0.1l0.2-0.6l-0.3-0.1 L763.3,547.7z M763.7,546.8l0.3,0.1l0.2-0.6l-0.3-0.1L763.7,546.8z M764,546l0.3,0.1l0.2-0.5l-0.3-0.1L764,546z M764.4,545.2 l0.3,0.1l0.2-0.6l-0.3-0.1L764.4,545.2z M764.8,544.3l0.3,0.1l0.2-0.5l-0.3-0.1L764.8,544.3z M765.1,543.5l0.3,0.1l0.2-0.6 l-0.3-0.1L765.1,543.5z M765.5,542.6l0.3,0.1l0.2-0.6l-0.3-0.1L765.5,542.6z M765.9,541.8l0.3,0.1l0.2-0.6l-0.3-0.1 L765.9,541.8z M766.3,541l0.3,0.1l0.2-0.5l-0.3-0.1L766.3,541z M766.6,540.1l0.3,0.1l0.2-0.6l-0.3-0.1L766.6,540.1z M767,539.3 l0.3,0.1l0.2-0.6l-0.3-0.1L767,539.3z M767.4,538.5l0.3,0.1l0.2-0.6l-0.3-0.1L767.4,538.5z M767.7,537.6l0.3,0.1l0.2-0.5 l-0.3-0.1L767.7,537.6z M768.1,536.8l0.3,0.1l0.2-0.6l-0.3-0.1L768.1,536.8z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "757.9,566.5 758.7,566.5 755.2,633.6 754.5,633.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "757.3,566.4 793.5,587.4 793.3,587.6 757.1,566.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 808.8,
    y1: 519.1,
    x2: 754.5,
    y2: 633.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M628,516.5l-58.5-45.6l1.3,7.7l0.2-0.2l0.2,0.3c-0.1,0.1-0.3,0.2-0.4,0.3l1.7,10l0.1,0.1l-0.1,0.1l0.1,0.4 l0.2-0.2l0.5,0.6l-0.3,0.2l-0.3-0.4l1.7,9.9l15.2,30.1l38.2-11.2C627.8,517.9,627.9,517.2,628,516.5z M628.7,515.8l2.2,1.7 l2.1-4l5.4,0l2.8,4.8l-2.6,4.8h-0.3l0,0v0l-4,0l0.4,2.7c1.7,0.3,3.5,0.1,5.1-0.9c3.5-2.1,4.6-6.8,2.5-10.5 c-2.2-3.7-6.8-5-10.3-2.9C630.3,512.6,629.2,514.1,628.7,515.8z M634.4,526.4c-0.5-0.1-1-0.3-1.4-0.5l-7.3,24.5l12.3-0.7 L634.4,526.4z M638.3,550l1.8,11.7l12.5-7.9c-0.5-0.7-0.8-1.6-1-2.5c-0.1-0.7-0.1-1.4,0-2.1L638.3,550z M652.1,548.8l1.6-0.1 l-0.3-0.5l0.3-0.2l0.3,0.5l2.9-2.5l3.9,1.6l0.7,4.3l-3.2,2.7l-2.5-1l-0.5,2.2c1,0.5,2.1,0.7,3.2,0.5c3.1-0.5,5.2-3.5,4.7-6.8 c-0.5-3.2-3.5-5.5-6.6-5C654.4,544.8,652.6,546.6,652.1,548.8z M653.5,554.4c0.3,0.3,0.6,0.6,1,0.8l0.4-1.7L653.5,554.4z  M653.8,549.1l-1.8,0.1c-0.1,0.7-0.2,1.3-0.1,2.1c0.1,0.9,0.5,1.7,1,2.4l1.5-0.9L653.8,549.1z M654.4,555.7 c-0.4-0.3-0.9-0.6-1.2-1.1l-12.9,8.1l5.1,33.9h0.2L654.4,555.7z M646.3,597l-0.3,1.5l2.4,1.3l0.2,3.3l-2.8,1.7l-3-1.6l-0.1-2.5 l-1.6-0.2c-0.4,2,0.6,4,2.5,5c2.3,1.2,5.1,0.4,6.2-1.8c1.2-2.2,0.2-5-2-6.2C647.2,597.2,646.8,597.1,646.3,597z M640.8,600 c0-0.2,0.1-0.3,0.2-0.5L621.5,587c-0.1,0.1-0.1,0.1-0.2,0.2c-3.3,2.8-8.4,2.3-11.4-1.1c-0.6-0.7-1.1-1.6-1.4-2.4l-9,4.1 c0.6,0.7,1.1,1.6,1.5,2.5c0.7,1.7,0.9,3.4,0.8,5.1L640.8,600z M601,595.6l-2.7-0.3l-3.8,5.3l-6.7-0.9l-2.7-6.5l3.7-5.2l-1-2.7 c-4.5,2.1-6.6,7.6-4.5,12.5c2.1,4.9,7.6,7.3,12.3,5.3C598.7,601.7,600.6,598.8,601,595.6z M575.1,550.1l13.3,34.2l0.4-0.1 l-5.2-30.3l-7-5.6C576.1,548.9,575.6,549.6,575.1,550.1z M574,549.9l-1.8-4.6l-7.5,4.8l-8.9-4.6l-0.4-10l8-5.1l-0.1-4.1 c-7.4,0.6-13.1,7-12.8,14.5c0.3,7.7,6.8,13.6,14.4,13.3C568.5,553.8,571.7,552.3,574,549.9z M574.2,499.8l-11.7-23.1l0.2,5.2 c0.2,0,0.4,0,0.5-0.1l0.1,0.4c-0.2,0-0.4,0-0.6,0.1l1.4,43c5.8-0.1,10.9,3.3,13.3,8.2l2.4-0.7L574.2,499.8z M589.4,530l-14.7-29 l5.5,31.7L589.4,530z M589.6,530.3l-9.3,2.7l2.1,11.9l15.8,2.3L589.6,530.3z M633.1,525.4c0.4,0.2,0.8,0.3,1.2,0.4l-0.3-2.3 l-0.7,1.2L633.1,525.4z M625.2,550.4l7.3-24.2L621,546.8c1.2,0.9,1.9,2.3,2,3.8L625.2,550.4z M625.1,550.8l-2.2,0.1 c0,0.1,0,0.2,0,0.2c-0.2,1.7-1.3,3.1-2.8,3.8l2.4,4.5L625.1,550.8z M639.7,561.9L638,550l-12.4,0.7l-2.8,9.2l4.9,9.5 L639.7,561.9z M645.4,597l0-0.1h0L645.4,597z M645,596.9c-0.9,0.1-1.8,0.5-2.5,1.1l0.8,1.5l1.8-1.1l0.1-0.3L645,596.9z  M641.3,599.7c0,0.1-0.1,0.2-0.1,0.3l0.9,0.1L641.3,599.7z M642.9,599.7l-0.7-1.4c-0.2,0.2-0.4,0.4-0.5,0.7L642.9,599.7 L642.9,599.7z M641.4,598.7c0.2-0.3,0.4-0.5,0.6-0.8l-14.2-27.5l-6.8,4.3c0.3,0.3,0.7,0.6,1,1c2.7,3.2,2.7,7.7,0.1,10.6 L641.4,598.7z M608.6,582.6l2-0.9l1.5-4.6l-1.8-1.5C608.6,577.5,608,580.1,608.6,582.6z M599.1,548.4l12.8,25.4 c1.7-0.9,3.7-1.2,5.6-0.7l1.4-17.6c-0.5,0.1-1,0.1-1.5,0.1c-2.6-0.3-4.5-2.5-4.4-5L599.1,548.4z M622.7,550.6 c0-1.4-0.7-2.7-1.8-3.5l-0.7,1.3l1.1,2.4L622.7,550.6z M620,554.7c1.4-0.6,2.4-1.9,2.6-3.5c0-0.1,0-0.1,0-0.2l-1.3,0.1l-1.9,2.5 L620,554.7z M618.9,555l0.1-1.5l-3.1-0.4l-1.1-2.6l-1.5-0.2c-0.1,2.3,1.7,4.4,4.1,4.7C618,555.2,618.5,555.1,618.9,555z  M619.7,554.8l-0.3-0.6l-0.1,0.8C619.4,554.9,619.6,554.9,619.7,554.8z M622.4,560l-2.5-4.9c-0.2,0.1-0.4,0.1-0.6,0.2l-1.4,17.8 c0.2,0.1,0.4,0.1,0.6,0.2L622.4,560z M620.2,574.2l7.2-4.5l-4.8-9.2l-3.9,12.9C619.3,573.6,619.8,573.8,620.2,574.2z  M619.8,574.4c-0.4-0.2-0.7-0.4-1.1-0.6l-0.5,1.6L619.8,574.4z M618.3,573.7l-0.5-0.2l-0.2,2.2h0L618.3,573.7z M612.1,574.2 l1.2,2.3l4-0.7l0.2-2.3C615.7,573.1,613.8,573.3,612.1,574.2z M612.8,576.4l-1-2.1c-0.3,0.2-0.5,0.4-0.8,0.6L612.8,576.4z  M621.7,586.1c2.4-2.8,2.4-7.1-0.1-10c-0.3-0.4-0.7-0.7-1-1l-2.3,1.4l3,3.5l-1.6,4.8L621.7,586.1z M615.8,547l-0.2-0.2 c-1,0.6-1.8,1.6-2.1,2.8l1.5,0.2l1.5-1.9l-0.4-0.6l0.3-0.2l0.4,0.6l2.6,0.3l0.7-1.3c-0.5-0.2-1-0.4-1.5-0.5 c-0.9-0.1-1.8,0.1-2.6,0.4l0.2,0.2L615.8,547z M583.7,552.9l26.9,21.7c0.3-0.3,0.6-0.5,1-0.7l-12.9-25.6l-16.1-2.3L583.7,552.9z  M577,547.5l6.2,5l-1.2-6.6l-4-0.6C577.8,546.1,577.4,546.8,577,547.5z M573.4,545.7l1.3,3.4c0.4-0.5,0.8-0.9,1.1-1.5 L573.4,545.7z M576.3,546.9c0.3-0.6,0.6-1.1,0.8-1.7l-3.6-0.5L576.3,546.9z M579,539.4c0.1,1.7-0.2,3.4-0.7,5l3.6,0.5l-2-11.8 l-2.3,0.7C578.5,535.5,578.9,537.4,579,539.4z M573.1,543.6l4.4,0.6c0.5-1.5,0.7-3.1,0.6-4.8c-0.1-1.9-0.6-3.8-1.3-5.4l-4,1.2 L573.1,543.6z M572.7,534.7v0.2l3.9-1.1c-2.3-4.5-7-7.6-12.4-7.6l0.1,4.1L572.7,534.7z M598.8,587l9.4-4.3 c-0.7-2.6-0.1-5.5,1.8-7.5l-26-21l5.2,29.9C592.6,583.2,596.3,584.4,598.8,587z M598.2,587.3c-2.4-2.4-5.8-3.4-9-2.5l0.5,3 l5.7,0.8L598.2,587.3z M601.1,595.2c0.1-1.6-0.1-3.2-0.8-4.8c-0.4-0.9-0.9-1.7-1.5-2.4l-2.8,1.3l2.4,5.6L601.1,595.2z  M589.1,586.3l-0.3-1.5c-0.1,0-0.2,0.1-0.3,0.1L589.1,586.3z M621,586.8l-2.2-1.4l-4.6,0.8l-3.1-3.6l-2.2,1 c0.3,0.8,0.8,1.6,1.4,2.3C613,589,617.8,589.5,621,586.8C621,586.8,621,586.8,621,586.8z M639.9,562.9l-11.8,7.4l14.2,27.4 c0.7-0.6,1.6-1,2.6-1.1L639.9,562.9z M630,518l-1.5-1.2c-0.1,0.6-0.1,1.1-0.1,1.7L630,518z M628.4,518.9 c0.1,1.1,0.5,2.3,1.1,3.3c0.7,1.2,1.6,2.1,2.7,2.7l1.1-1.9l-2.8-4.7v0l-0.1-0.1L628.4,518.9z M601.1,527.5l-0.4-0.5l-10.9,3.2 l8.7,17.1l14.6,2.1c0.3-1.3,1.1-2.4,2.3-3l-0.1-0.1l0.3-0.2l0.1,0.1c0.8-0.4,1.8-0.6,2.8-0.5c0.6,0.1,1.2,0.2,1.7,0.5l11.7-20.9 c-1.1-0.7-2.1-1.7-2.8-2.9c-0.7-1.1-1-2.3-1.1-3.5l-26.8,7.9l0.3,0.4L601.1,527.5z M569.2,470.8l-6.7,4.6l0,0l0.3,0.4l-0.2,0.2 l0.2,0.3l0.2-0.2l0.5,0.6l-0.3,0.2l-0.3-0.4l2.6,5.1l-0.1-0.3l0.7-0.2l0.1,0.4c-0.2,0.1-0.5,0.1-0.7,0.2l8.5,16.8l-1.6-9.4 l-0.3-0.4l0.2-0.1L569.2,470.8z M560.3,455.8l9,4.3l0.8,10l58.2,45.4c0.6-1.7,1.7-3.2,3.4-4.2c3.8-2.2,8.7-0.9,11,3 c2.3,3.9,1.1,8.9-2.6,11.2l0.2,0.4l-0.3,0.2l-0.3-0.4c-1.6,0.9-3.3,1.1-5,0.8l3.5,23.2l13.4-0.8c0.2-0.7,0.5-1.4,0.9-2l-0.3-0.5 l0.3-0.2l0.2,0.3c0.9-1.2,2.3-2.2,3.9-2.4c3.3-0.5,6.5,1.9,7,5.3c0.5,3.5-1.7,6.7-5,7.2c-1.2,0.2-2.4,0-3.4-0.5l-8.8,40.5 c0.5,0.1,1,0.2,1.4,0.5c2.4,1.3,3.4,4.2,2.2,6.6c-1.2,2.4-4.2,3.2-6.7,2c-2-1-3-3.3-2.6-5.3l-39.1-4.7c-0.4,3.5-2.5,6.6-5.8,8 c-5,2.2-10.9-0.4-13.2-5.6c-2.2-5.2,0-11.1,4.9-13.3l-13.1-33.9c-2.5,2.4-5.8,3.9-9.5,4c-8.1,0.4-15-6-15.4-14.2 c-0.3-8,5.8-14.9,13.7-15.4l-1.7-49.5l-8.8-4.2l-0.8-10L560.3,455.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M573.7,475.8l0.3,0.2c0.2-0.2,0.3-0.4,0.4-0.6l-0.3-0.2C574,475.4,573.8,475.6,573.7,475.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M573,477.2c0.2-0.2,0.3-0.4,0.5-0.5l-0.3-0.2l-0.5,0.5L573,477.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M571.9,478.2c0.2-0.2,0.4-0.3,0.5-0.5l-0.3-0.3c-0.2,0.2-0.3,0.3-0.5,0.5L571.9,478.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M558.7,449.9l0-0.4c-0.2,0-0.5,0.1-0.7,0.1l0.1,0.4L558.7,449.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M557.2,450.2l-0.1-0.4c-0.2,0.1-0.5,0.1-0.7,0.2l0.1,0.4C556.8,450.3,557,450.2,557.2,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M575.7,459.2l0.3-0.2c-0.1-0.2-0.2-0.5-0.3-0.7l-0.3,0.2C575.5,458.8,575.6,459,575.7,459.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M555.8,450.6l-0.1-0.4c-0.2,0.1-0.5,0.2-0.7,0.3l0.1,0.4L555.8,450.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M554.5,451.1l-0.2-0.3c-0.2,0.1-0.5,0.2-0.7,0.3l0.2,0.3C554,451.3,554.3,451.2,554.5,451.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M553,451.5c-0.2,0.1-0.4,0.2-0.6,0.4l0.2,0.3c0.2-0.1,0.4-0.2,0.6-0.4L553,451.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566.7,481l0.1,0.4c0.2-0.1,0.5-0.2,0.7-0.3l-0.2-0.3C567.2,480.8,567,480.9,566.7,481z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M562,449.7l0-0.4c-0.2,0-0.5,0-0.7,0l0,0.4C561.5,449.7,561.8,449.7,562,449.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M563.4,449.9l0-0.4l-0.7-0.1l0,0.4C563,449.8,563.2,449.9,563.4,449.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M564.9,450.2l0.1-0.4c-0.2-0.1-0.5-0.1-0.7-0.2l-0.1,0.4C564.4,450.1,564.6,450.1,564.9,450.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566.3,450.6l0.1-0.4c-0.2-0.1-0.5-0.2-0.7-0.2l-0.1,0.4L566.3,450.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M567.6,451.1l0.2-0.3c-0.2-0.1-0.5-0.2-0.7-0.3l-0.1,0.4C567.2,450.9,567.4,451,567.6,451.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.7,470.8c0.1-0.2,0.1-0.5,0.2-0.7l-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7L576.7,470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M569.5,480c0.2-0.1,0.4-0.3,0.6-0.4l-0.2-0.3l-0.6,0.4L569.5,480z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M568.9,451.8l0.2-0.3c-0.2-0.1-0.4-0.2-0.6-0.4l-0.2,0.3C568.5,451.5,568.7,451.7,568.9,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M575,457.9l0.3-0.2c-0.1-0.2-0.2-0.4-0.4-0.6l-0.3,0.2C574.8,457.5,574.9,457.7,575,457.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M572.4,454.4l0.3-0.3l-0.5-0.5l-0.2,0.3C572,454.1,572.2,454.3,572.4,454.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M574.2,456.7l0.3-0.2l-0.4-0.6l-0.3,0.2C574,456.3,574.1,456.5,574.2,456.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M573.4,455.5l0.3-0.2c-0.2-0.2-0.3-0.4-0.5-0.6l-0.3,0.2C573.1,455.1,573.2,455.3,573.4,455.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M570.2,452.5l0.2-0.3l-0.6-0.4l-0.2,0.3C569.8,452.3,570,452.4,570.2,452.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M571.3,453.4l0.2-0.3c-0.2-0.2-0.4-0.3-0.6-0.5l-0.2,0.3C570.9,453.1,571.1,453.3,571.3,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M544.8,463.4c0,0.2-0.1,0.5-0.1,0.7l0.4,0c0-0.2,0-0.5,0.1-0.7L544.8,463.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M561,482v0.4c0.2,0,0.5,0,0.7,0l0-0.4C561.5,482,561.3,482,561,482z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M575.6,473.5c0.1-0.2,0.2-0.4,0.3-0.7l-0.3-0.2l-0.3,0.7L575.6,473.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.2,472.2c0.1-0.2,0.2-0.5,0.3-0.7l-0.3-0.1c-0.1,0.2-0.2,0.5-0.3,0.7L576.2,472.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M559.6,481.9l0,0.4c0.2,0,0.5,0,0.7,0.1l0-0.4C560.1,482,559.8,482,559.6,481.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M556.7,481.4l-0.1,0.4c0.2,0.1,0.5,0.1,0.7,0.2l0.1-0.4C557.2,481.6,557,481.5,556.7,481.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M555.3,481l-0.1,0.4c0.2,0.1,0.5,0.2,0.7,0.2l0.1-0.4L555.3,481z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M558.2,481.8l-0.1,0.4c0.2,0,0.5,0.1,0.7,0.1l0-0.4C558.6,481.8,558.4,481.8,558.2,481.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M559.3,449.4l0,0.4l0.4,0c0.2,0,0.5,0,0.7,0v-0.4c-0.2,0-0.5,0-0.8,0L559.3,449.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577.3,467.8c0-0.2,0.1-0.5,0.1-0.7l-0.4,0c0,0.2,0,0.5-0.1,0.7L577.3,467.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577.1,469.3c0.1-0.2,0.1-0.5,0.1-0.7l-0.4-0.1c0,0.2-0.1,0.5-0.1,0.7L577.1,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M577.5,466.3v-0.8l-0.4,0c0,0.2,0,0.5,0,0.7L577.5,466.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.9,463.4l0.4-0.1c0-0.2-0.1-0.5-0.1-0.7l-0.4,0.1C576.8,462.9,576.9,463.2,576.9,463.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.6,462l0.4-0.1c-0.1-0.2-0.1-0.5-0.2-0.7l-0.3,0.1C576.5,461.5,576.6,461.7,576.6,462z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577,464.6 577.1,464.9 577.4,464.8 577.4,464.6 577.4,464.1 577,464.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M576.2,460.6l0.3-0.1c-0.1-0.2-0.2-0.5-0.2-0.7l-0.3,0.1C576,460.1,576.1,460.3,576.2,460.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M544.6,466.4c0,0.2,0,0.5,0,0.8l0.4,0c0-0.2,0-0.5,0-0.7L544.6,466.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M545.3,469.3l-0.4,0.1c0.1,0.2,0.1,0.5,0.2,0.7l0.4-0.1C545.5,469.7,545.4,469.5,545.3,469.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M546.2,472.1l-0.3,0.1l0.3,0.7l0.3-0.2C546.4,472.5,546.3,472.3,546.2,472.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M545.7,470.7l-0.3,0.1c0.1,0.2,0.2,0.5,0.2,0.7l0.4-0.1C545.9,471.1,545.8,470.9,545.7,470.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M546.8,473.4l-0.3,0.2c0.1,0.2,0.2,0.4,0.4,0.7l0.3-0.2C547.1,473.8,546.9,473.6,546.8,473.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M568.1,480.4l0.2,0.3c0.2-0.1,0.4-0.2,0.7-0.3l-0.2-0.3C568.5,480.2,568.3,480.3,568.1,480.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M544.7,464.9c0,0.2,0,0.5,0,0.8l0.4,0c0-0.2,0-0.5,0-0.7L544.7,464.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M547.6,474.6l-0.3,0.2c0.1,0.2,0.3,0.4,0.4,0.6l0.3-0.2C547.8,475,547.7,474.8,547.6,474.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "545.1,467.8 544.8,467.9 544.8,468.6 545.2,468.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M552.7,479.7l-0.2,0.3c0.2,0.1,0.4,0.2,0.7,0.4l0.2-0.3C553.2,479.9,552.9,479.8,552.7,479.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M548.4,475.8l-0.3,0.2c0.1,0.2,0.3,0.4,0.5,0.6l0.3-0.2L548.4,475.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M549.3,476.9l-0.3,0.2c0.2,0.2,0.3,0.4,0.5,0.5l0.3-0.3C549.7,477.3,549.5,477.1,549.3,476.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M563.9,481.8l0.1,0.4l0.7-0.2l-0.1-0.4C564.4,481.7,564.2,481.7,563.9,481.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M551.5,478.9l-0.2,0.3c0.2,0.2,0.4,0.3,0.6,0.4l0.2-0.3C551.9,479.2,551.7,479,551.5,478.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M554,480.4l-0.2,0.3l0.7,0.3l0.1-0.4C554.5,480.6,554.2,480.5,554,480.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M550.4,478l-0.2,0.3l0.6,0.5l0.2-0.3C550.8,478.3,550.6,478.1,550.4,478z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "565.2,479.7 565.4,479.4 565,478.8 564.7,479.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "613.1,543.4 613.4,543.2 613,542.6 612.7,542.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "614.5,545.2 614.8,545 614.3,544.4 614,544.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "615.1,546.1 615.4,545.9 615,545.3 614.7,545.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "613.8,544.3 614.1,544.1 613.7,543.5 613.4,543.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "564.5,478.8 564.8,478.5 564.3,478 564,478.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "563.8,477.9 564.1,477.7 563.7,477.1 563.4,477.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "567.8,483.2 568.1,483 567.7,482.4 567.4,482.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "570.5,486.7 570.8,486.5 570.3,485.9 570,486.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "571.2,487.6 571.5,487.4 571,486.8 570.7,487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "571.8,488.5 572.1,488.3 571.7,487.7 571.4,487.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "566.3,480.6 566,480.8 566.5,481.4 566.8,481.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "569.8,485.9 570.1,485.6 569.7,485 569.4,485.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "565.7,479.7 565.4,479.9 565.8,480.5 566.1,480.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "567.2,482.3 567.5,482.1 567,481.5 566.7,481.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "568.5,484.1 568.8,483.9 568.3,483.3 568,483.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "569.2,485 569.5,484.7 569,484.2 568.7,484.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "607.8,536.3 608.1,536.1 607.7,535.5 607.4,535.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "585.8,507.1 586.1,506.9 585.7,506.3 585.4,506.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "586.5,508 586.8,507.8 586.3,507.2 586,507.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "587.1,508.9 587.4,508.7 587,508.1 586.7,508.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "587.8,509.8 588.1,509.5 587.7,509 587.4,509.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "583.8,504.5 584.1,504.2 583.7,503.6 583.4,503.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "585.2,506.2 585.4,506 585,505.4 584.7,505.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "584.5,505.3 584.8,505.1 584.3,504.5 584,504.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "591.2,514.2 591.4,514 591,513.4 590.7,513.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "591.8,515.1 592.1,514.9 591.7,514.3 591.4,514.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "593.2,516.9 593.4,516.6 593,516 592.7,516.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "583.2,503.6 583.4,503.3 583,502.8 582.7,503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "592.5,516 592.8,515.7 592.3,515.2 592,515.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "589.2,511.5 589.4,511.3 589,510.7 588.7,510.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "590.5,513.3 590.8,513.1 590.3,512.5 590,512.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "589.8,512.4 590.1,512.2 589.7,511.6 589.4,511.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "588.5,510.7 588.8,510.4 588.3,509.8 588,510.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "576.5,494.7 576.8,494.5 576.3,493.9 576,494.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577.8,496.5 578.1,496.3 577.7,495.7 577.4,495.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "575.8,493.8 576.1,493.6 575.7,493 575.4,493.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "577.2,495.6 577.5,495.4 577,494.8 576.7,495  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "575.2,492.9 575.5,492.7 575,492.1 574.7,492.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "573.8,491.2 574.1,490.9 573.7,490.4 573.4,490.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "574.5,492.1 574.8,491.8 574.3,491.2 574,491.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "581.8,501.8 582.1,501.6 581.7,501 581.4,501.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "581.2,500.9 581.4,500.7 581,500.1 580.7,500.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "582.5,502.7 582.8,502.5 582.3,501.9 582,502.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "580.5,500 580.8,499.8 580.3,499.2 580,499.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "579.8,499.1 580.1,498.9 579.7,498.3 579.4,498.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "578.5,497.4 578.8,497.1 578.3,496.5 578,496.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "579.2,498.3 579.4,498 579,497.4 578.7,497.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "604.5,531.9 604.8,531.7 604.3,531.1 604,531.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "595.1,519.5 595.4,519.3 595,518.7 594.7,518.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "595.8,520.4 596.1,520.2 595.7,519.6 595.4,519.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "594.5,518.6 594.8,518.4 594.3,517.8 594,518  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "593.8,517.7 594.1,517.5 593.7,516.9 593.4,517.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "596.5,521.3 596.8,521.1 596.3,520.5 596,520.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "602.5,529.2 602.8,529 602.3,528.4 602,528.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "603.8,531 604.1,530.8 603.7,530.2 603.4,530.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "601.8,528.4 602.1,528.1 601.7,527.5 601.4,527.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "599.8,525.7 600.1,525.5 599.7,524.9 599.4,525.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "600.5,526.6 600.8,526.4 600.3,525.8 600,526  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "599.1,524.8 599.4,524.6 599,524 598.7,524.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "598.5,523.9 598.8,523.7 598.3,523.1 598,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "597.1,522.2 597.4,521.9 597,521.4 596.7,521.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "597.8,523 598.1,522.8 597.7,522.2 597.4,522.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "603.1,530.1 603.4,529.9 603,529.3 602.7,529.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "610.5,539.9 610.8,539.7 610.3,539.1 610,539.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "608.5,537.2 608.8,537 608.3,536.4 608,536.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "609.1,538.1 609.4,537.9 609,537.3 608.7,537.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "609.8,539 610.1,538.8 609.7,538.2 609.4,538.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "611.8,541.6 612.1,541.4 611.7,540.8 611.4,541.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "611.1,540.8 611.4,540.5 611,539.9 610.7,540.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "606.5,534.6 606.8,534.3 606.3,533.7 606,534  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "607.1,535.4 607.4,535.2 607,534.6 606.7,534.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "612.5,542.5 612.8,542.3 612.3,541.7 612,541.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "605.2,532.8 605.4,532.6 605,532 604.7,532.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "605.8,533.7 606.1,533.5 605.7,532.9 605.4,533.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "652.4,545.8 652,545.2 651.7,545.4 652.1,546  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "651.8,544.9 651.4,544.2 651.1,544.4 651.5,545.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "653.2,547.1 652.8,547.3 653.2,547.9 653.5,547.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 639.3,
    y: 524.3,
    transform: "matrix(0.8599 -0.5105 0.5105 0.8599 -178.261 400.0084)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "642.9,530.8 643.2,530.6 642.9,530 642.5,530.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "644.7,533.7 645,533.5 644.6,532.8 644.3,533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "644.1,532.7 644.4,532.5 644,531.9 643.7,532.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "646.4,536.5 646.7,536.3 646.3,535.7 646,535.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "645.8,535.6 646.1,535.4 645.7,534.7 645.4,534.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "645.2,534.6 645.5,534.4 645.2,533.8 644.8,534  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "643.5,531.8 643.8,531.6 643.4,530.9 643.1,531.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "641.8,528.9 642.1,528.7 641.7,528.1 641.4,528.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "642.4,529.9 642.7,529.7 642.3,529 642,529.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.7,
    y: 523.4,
    transform: "matrix(0.8599 -0.5105 0.5105 0.8599 -177.8559 399.5843)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "641.2,528 641.5,527.8 641.2,527.1 640.8,527.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "646.9,537.5 647.2,537.3 646.9,536.6 646.6,536.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "650.4,543.2 650.7,543 650.3,542.3 650,542.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "649.8,542.2 650.1,542 649.7,541.4 649.4,541.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "640.6,527 641,526.8 640.6,526.2 640.3,526.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "650.9,544.1 651.2,543.9 650.9,543.3 650.5,543.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "649.2,541.3 649.5,541.1 649.2,540.4 648.8,540.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "647.5,538.4 647.8,538.2 647.4,537.6 647.1,537.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "648.1,539.4 648.4,539.2 648,538.5 647.7,538.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "648.7,540.3 649,540.1 648.6,539.5 648.3,539.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M482.4,648.9l39.6,62.9l1.3-7.7l-0.3,0.1l-0.1-0.3c0.2-0.1,0.3-0.1,0.5-0.2l1.8-10l0-0.2l0.1,0l0.1-0.4 l-0.3,0.1l-0.2-0.7l0.3-0.1l0.2,0.5l1.7-9.9l-4.1-33.6l-39.6-2.5C483.1,647.6,482.8,648.2,482.4,648.9z M481.6,649.2l-1.5-2.3 l-3.4,3l-5.1-1.9l-1-5.5l4-3.6l0.3,0.1h0v0l3.8,1.4l0.5-2.7c-1.5-0.9-3.3-1.3-5.1-0.9c-4,0.8-6.7,4.8-5.9,9 c0.8,4.2,4.7,7,8.8,6.2C479,651.7,480.5,650.6,481.6,649.2z M479.8,637.3c0.4,0.3,0.8,0.6,1.2,0.9l15.2-20.5l-11.8-3.5 L479.8,637.3z M484.1,613.8l2.3-11.6l-14.4,3.1c0.2,0.9,0.2,1.8,0.1,2.8c-0.1,0.7-0.4,1.4-0.7,2L484.1,613.8z M470.8,610.2 l-1.5-0.5l0.1,0.5l-0.4,0.1l-0.1-0.6l-3.6,1.3l-3.1-2.8l0.8-4.2l3.9-1.4l2,1.8l1.2-1.9c-0.8-0.8-1.8-1.3-2.9-1.6 c-3.1-0.6-6.1,1.5-6.7,4.8c-0.6,3.2,1.4,6.3,4.5,6.9C467.2,613.2,469.5,612.1,470.8,610.2z M471.3,604.5 c-0.2-0.4-0.4-0.8-0.6-1.1l-0.9,1.5L471.3,604.5z M469.2,609.4l1.7,0.5c0.3-0.6,0.6-1.2,0.7-1.9c0.2-0.9,0.1-1.8-0.1-2.6 l-1.7,0.4L469.2,609.4z M470.9,603c0.3,0.4,0.6,0.9,0.8,1.4l14.9-3.2l6.7-33.6l-0.1,0L470.9,603z M492.5,566.8l0.8-1.3l-1.8-2 l0.9-3.2l3.2-0.7l2.3,2.5l-0.7,2.5l1.4,0.7c1-1.7,0.9-4-0.6-5.6c-1.8-1.9-4.7-2.1-6.5-0.4s-1.9,4.6-0.2,6.5 C491.7,566.3,492,566.6,492.5,566.8z M498.7,565.9c-0.1,0.1-0.2,0.3-0.4,0.4l14.1,18.5l0.2-0.1c4.1-1.5,8.7,0.7,10.3,5 c0.3,0.9,0.5,1.8,0.5,2.8l9.9-0.8c-0.3-0.9-0.5-1.8-0.5-2.8c-0.1-1.8,0.2-3.5,1-5.1L498.7,565.9z M534.5,583.6l2.4,1.2l5.4-3.7 l6,3.2l0.4,7l-5.2,3.6l0.1,2.9c5-0.4,8.7-4.9,8.5-10.2c-0.3-5.3-4.7-9.5-9.8-9.2C538.9,578.7,536,580.7,534.5,583.6z  M543.6,635.3l-0.9-36.8c-0.1,0-0.3,0-0.4,0l-5.3,30.3l4.7,7.7C542.2,636.1,542.9,635.6,543.6,635.3z M544.5,635.9l0.1,5l8.7-2 l6.8,7.4l-3,9.6l-9.2,2.1l-1.3,3.9c7.2,2,14.7-2.1,16.9-9.2c2.3-7.3-1.8-15.1-9-17.4C551.1,634.1,547.5,634.4,544.5,635.9z  M527.5,682.9l3.2,25.7l1.6-4.9c-0.2-0.1-0.4-0.1-0.5-0.1l0.1-0.4c0.2,0,0.4,0.1,0.5,0.1l13.2-40.9c-5.5-1.9-9.1-6.8-9.8-12.3 l-2.5-0.2L527.5,682.9z M523.3,649.4l4,32.3l5.5-31.7L523.3,649.4z M523.3,649l9.6,0.6l2.1-11.9l-14.1-7.6L523.3,649z  M480.7,638.7c-0.3-0.3-0.6-0.6-1-0.8l-0.5,2.3l1-0.9L480.7,638.7z M496.5,617.9l-15,20.3l17.8-15.4c-0.8-1.2-1.1-2.8-0.6-4.2 L496.5,617.9z M496.8,617.5l2.1,0.6c0-0.1,0-0.1,0.1-0.2c0.8-1.5,2.3-2.5,3.9-2.6l-0.7-5.1L496.8,617.5z M486.8,602.1l-2.3,11.8 l11.9,3.5l5.7-7.7l-1.4-10.6L486.8,602.1z M493.4,567.1l-0.1,0.1l0.1,0L493.4,567.1z M493.7,567.4c0.9,0.2,1.8,0.2,2.7-0.1 l-0.2-1.7l-2.1,0.4l-0.2,0.2L493.7,567.4z M498.1,566c0.1-0.1,0.2-0.2,0.2-0.3l-0.8-0.4L498.1,566z M496.5,565.5l0.2,1.6 c0.2-0.1,0.5-0.3,0.7-0.4L496.5,565.5L496.5,565.5z M497.6,566.9c-0.3,0.2-0.6,0.4-0.9,0.5l4.1,30.7l7.8-1.7 c-0.2-0.4-0.4-0.8-0.6-1.2c-1.4-3.9,0.1-8.1,3.5-10L497.6,566.9z M523,593.3l-2.2,0.2l-3,3.8l1.2,2 C521.3,598.1,522.8,595.8,523,593.3z M520.4,628.8l-3.5-28.2c-1.9,0.3-3.9-0.2-5.5-1.2l-7.3,16.1c0.5,0.1,0.9,0.2,1.4,0.4 c2.4,1.2,3.4,3.9,2.5,6.2L520.4,628.8z M499,618.6c-0.5,1.3-0.3,2.8,0.5,3.9l1.1-1l-0.2-2.6L499,618.6z M502.9,615.6 c-1.5,0.1-2.9,1-3.6,2.4c0,0.1,0,0.1-0.1,0.2l1.3,0.4l2.6-1.7L502.9,615.6z M504,615.7l-0.6,1.3l2.8,1.4l0.2,2.8l1.3,0.7 c0.8-2.2-0.1-4.7-2.3-5.8C505,615.9,504.5,615.8,504,615.7z M503.2,615.6l0.1,0.7l0.3-0.7C503.5,615.6,503.4,615.6,503.2,615.6z  M502.5,609.8l0.7,5.5c0.2,0,0.4,0,0.6,0l7.4-16.2c-0.2-0.1-0.3-0.2-0.5-0.4L502.5,609.8z M509.3,597.2L501,599l1.4,10.3l8-10.8 C510,598.1,509.6,597.7,509.3,597.2z M509.8,597.1c0.3,0.3,0.5,0.7,0.9,1l1-1.4L509.8,597.1z M511,598.3 c0.1,0.1,0.2,0.2,0.4,0.3l0.9-2l0,0L511,598.3z M516.9,600l-0.3-2.5l-4-0.7l-0.9,2.1C513.2,599.9,515,600.3,516.9,600z  M517,597.7l0.3,2.3c0.3-0.1,0.6-0.2,1-0.3L517,597.7z M511.9,585.5c-3.2,1.8-4.7,5.8-3.3,9.5c0.2,0.5,0.4,0.9,0.6,1.3l2.6-0.6 l-1.6-4.4l3.1-4L511.9,585.5z M504.2,624.3l0.1,0.3c1.2-0.2,2.3-0.9,3-1.9l-1.4-0.7l-2,1.3l0.2,0.7l-0.4,0.1l-0.2-0.7l-2.3-1.2 l-1.1,1c0.4,0.4,0.8,0.7,1.3,1c0.8,0.4,1.7,0.6,2.6,0.5l-0.1-0.2L504.2,624.3z M536.4,629.8l-17.9-29.6h0 c-0.4,0.1-0.8,0.2-1.2,0.3l3.5,28.5l14.4,7.7L536.4,629.8z M540.9,637.1l-4.2-6.9l-1.2,6.6l3.6,2 C539.7,638.2,540.2,637.6,540.9,637.1z M543.7,640l-0.1-3.7c-0.5,0.3-1,0.6-1.5,1L543.7,640z M541.3,637.9 c-0.5,0.4-0.9,0.9-1.4,1.4l3.2,1.7L541.3,637.9z M536.3,644c0.5-1.7,1.3-3.1,2.3-4.5l-3.2-1.7l-2.1,11.8l2.4,0.2 C535.5,647.9,535.7,645.9,536.3,644z M543.3,642.1l-3.9-2.1c-1,1.3-1.7,2.7-2.2,4.3c-0.6,1.8-0.7,3.7-0.6,5.5l4.2,0.3 L543.3,642.1z M540.6,650.6l0.1-0.2l-4-0.2c0.6,5.1,4,9.6,9.1,11.3l1.2-3.9L540.6,650.6z M533.8,592.5l-10.2,0.8 c-0.2,2.7-1.8,5.2-4.2,6.5l17.3,28.6l5.2-29.9C538.3,598.2,535.2,595.8,533.8,592.5z M534.4,592.4c1.4,3,4.3,5.1,7.6,5.4l0.5-3 l-5.1-2.7L534.4,592.4z M534.4,584c-0.7,1.4-1,3-0.9,4.7c0,1,0.2,1.9,0.5,2.8l3.1-0.2l-0.3-6.1L534.4,584z M542.6,596.4 l-0.2,1.5c0.1,0,0.2,0,0.3,0L542.6,596.4z M512.8,585.1l1.6,2.1l4.6,0.8l1.7,4.5l2.4-0.2c0-0.9-0.2-1.8-0.5-2.7 C521,585.7,516.7,583.6,512.8,585.1L512.8,585.1z M487,601.1l13.5-2.9l-4.1-30.6c-0.9,0.3-1.9,0.4-2.8,0.1L487,601.1z  M481.1,646.7l1,1.7c0.3-0.5,0.5-1,0.7-1.5L481.1,646.7z M482.9,646.5c0.3-1.1,0.3-2.3,0.1-3.5c-0.2-1.3-0.8-2.5-1.6-3.5 l-1.6,1.4l1,5.3l0,0l0,0.1L482.9,646.5z M511.4,647.7l0.2,0.6l11.3,0.7l-2.3-19.1l-13-7c-0.7,1.1-1.9,1.8-3.1,2.1l0,0.1 l-0.4,0.1l0-0.1c-0.9,0.1-1.9-0.1-2.8-0.5c-0.5-0.3-1-0.6-1.4-1l-18.1,15.7c0.8,1,1.4,2.3,1.7,3.7c0.2,1.2,0.2,2.5-0.1,3.6 l27.8,1.7l-0.1-0.4L511.4,647.7z M522.4,711.9l7.9-2l0-0.1l-0.1-0.5l0.2-0.1l0-0.4L530,709l-0.2-0.7l0.3-0.1l0.2,0.5l-0.7-5.7 l0,0.3l-0.7,0l0-0.4c0.2,0,0.5,0,0.7,0l-2.3-18.7l-1.6,9.4l0.1,0.5l-0.2,0.1L522.4,711.9z M525.7,729.1l-7-7.2l2.6-9.6 l-39.4-62.6c-1.1,1.4-2.7,2.5-4.6,2.8c-4.3,0.8-8.5-2.2-9.3-6.6c-0.8-4.5,1.9-8.8,6.2-9.6l-0.1-0.5l0.3-0.1l0.1,0.5 c1.8-0.3,3.5,0.1,5,1l4.6-23l-12.9-3.8c-0.4,0.6-0.9,1.2-1.5,1.6l0.1,0.5l-0.4,0.1l-0.1-0.4c-1.3,0.9-2.9,1.2-4.4,1 c-3.3-0.6-5.4-4-4.8-7.4s3.9-5.7,7.2-5.1c1.2,0.2,2.2,0.8,3,1.6l22-35.1c-0.4-0.3-0.8-0.6-1.2-0.9c-1.9-2-1.8-5.2,0.2-7 c1.9-1.8,5-1.6,6.9,0.4c1.5,1.7,1.7,4.1,0.6,5.9l35.1,17.8c1.6-3.1,4.6-5.3,8.2-5.5c5.5-0.3,10.1,4.1,10.5,9.8 c0.3,5.6-3.7,10.4-9.1,10.9l0.9,36.3c3.1-1.4,6.8-1.7,10.3-0.6c7.8,2.4,12.1,10.8,9.7,18.6c-2.4,7.7-10.4,12-18.1,9.8 l-15.2,47.2l6.8,7l-2.7,9.7L525.7,729.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "615.5,479.1 616.9,485.9 611.7,490.5 605.1,488.3 603.7,481.4 608.9,476.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M601.2,480.6c1.7-5,7.1-7.8,12.2-6.1c5,1.7,7.7,7.2,6,12.2c-1.7,5-7.1,7.8-12.2,6.1 C602.2,491.1,599.5,485.6,601.2,480.6z M600.6,480.4c-1.8,5.4,1.1,11.2,6.4,13c5.3,1.8,11.2-1.1,13-6.5 c1.8-5.4-1.1-11.2-6.4-13C608.2,472.1,602.4,475,600.6,480.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "611.7,487.4 631.4,592.2 630.6,592.3 610.8,487.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "529.6,528.6 529.9,524.8 533.2,523.1 536.3,525.2 536.1,529 532.7,530.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M537.3,529.8c-1.6,2.4-4.8,3-7.2,1.5c-2.4-1.6-3-4.8-1.4-7.2c1.6-2.4,4.8-3,7.2-1.5 C538.2,524.1,538.8,527.4,537.3,529.8z M537.6,529.9c1.7-2.5,1-6-1.6-7.7c-2.5-1.7-6-1-7.6,1.6s-1,6,1.6,7.7 C532.5,533.2,535.9,532.5,537.6,529.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "627.9,596.8 627.5,593 630.6,590.8 634,592.4 634.3,596.1 631.3,598.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M635.6,596.7c-1.2,2.6-4.2,3.8-6.8,2.6c-2.6-1.2-3.7-4.3-2.6-6.9c1.2-2.6,4.2-3.8,6.8-2.6 C635.7,591,636.8,594.1,635.6,596.7z M636,596.8c1.2-2.8,0-6.1-2.7-7.3c-2.8-1.3-6,0-7.3,2.8c-1.3,2.8,0,6.1,2.7,7.3 C631.4,600.9,634.7,599.6,636,596.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "548.6,496.4 546.3,493.5 547.7,490 551.3,489.4 553.7,492.4 552.3,495.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M555.1,492.1c0.4,2.8-1.5,5.5-4.3,5.9c-2.8,0.4-5.4-1.5-5.9-4.4c-0.4-2.8,1.5-5.5,4.3-5.9 C552,487.4,554.7,489.3,555.1,492.1z M555.4,492.1c-0.5-3-3.3-5.1-6.3-4.6c-3,0.5-5.1,3.3-4.6,6.3c0.5,3,3.3,5.1,6.3,4.6 S555.9,495.1,555.4,492.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "546.8,566.1 545.6,563.9 546.9,561.7 549.5,561.8 550.7,564 549.3,566.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M551.6,564.1c0,1.9-1.7,3.5-3.6,3.4c-1.9,0-3.5-1.7-3.4-3.6c0-2,1.7-3.5,3.6-3.4 C550.2,560.5,551.7,562.1,551.6,564.1z M551.9,564.1c0.1-2.1-1.6-3.8-3.6-3.8c-2-0.1-3.8,1.6-3.8,3.7c-0.1,2.1,1.6,3.8,3.6,3.8 C550.1,567.8,551.8,566.1,551.9,564.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "535,526.1 534.6,525.4 606.9,486.4 607.3,487.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "548.2,563.5 607.4,485.4 607.7,485.6 548.5,563.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "533,528.8 547.7,563 546.9,563.3 532.2,529.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "606.6,486.2 606.7,487.4 551.3,493.6 551.2,492.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "549.7,494.8 533.6,524.7 532.6,524.1 548.7,494.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "504.6,571.3 502,571.8 500.2,569.7 501.1,567.1 503.8,566.6 505.5,568.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M504.1,565.6c1.9,0.7,3,2.8,2.3,4.8c-0.7,2-2.8,3-4.8,2.3c-1.9-0.7-3-2.8-2.2-4.8 C500,566,502.2,564.9,504.1,565.6z M504.2,565.4c-2.1-0.7-4.4,0.4-5.1,2.4c-0.7,2.1,0.3,4.4,2.4,5.1c2.1,0.7,4.4-0.4,5.1-2.4 C507.4,568.5,506.3,566.2,504.2,565.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "488.8,593.9 485.1,594.6 482.6,591.7 483.9,588.1 487.6,587.4 490.1,590.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M488.1,586.1c2.7,1,4.1,4,3.2,6.7c-1,2.7-4,4.2-6.7,3.2c-2.7-1-4.1-4-3.1-6.7 C482.4,586.5,485.4,585.1,488.1,586.1z M488.2,585.7c-2.9-1-6.1,0.5-7.1,3.4c-1,2.9,0.5,6.1,3.4,7.1c2.9,1,6.1-0.5,7.1-3.4 C492.6,590,491.1,586.8,488.2,585.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "558.7,532.7 557.1,535 554.3,534.7 553.2,532.1 554.8,529.8 557.6,530.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M554.4,528.8c2-0.9,4.3,0,5.1,2c0.9,2,0,4.3-2,5.2c-2,0.9-4.3,0-5.1-2C551.5,532,552.4,529.7,554.4,528.8z  M554.2,528.6c-2.1,1-3,3.4-2.1,5.5c0.9,2.1,3.4,3,5.5,2.1c2.1-0.9,3-3.4,2.1-5.5C558.8,528.6,556.3,527.6,554.2,528.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "527.9,552.6 526.5,553.8 524.8,553.3 524.4,551.4 525.8,550.2 527.5,550.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M525.6,549.5c1.4-0.3,2.7,0.6,3,2s-0.6,2.7-1.9,3c-1.4,0.3-2.7-0.6-3-1.9 C523.4,551.2,524.2,549.8,525.6,549.5z M525.6,549.3c-1.5,0.3-2.4,1.8-2.1,3.2c0.3,1.5,1.8,2.4,3.2,2.1 c1.5-0.3,2.4-1.8,2.1-3.2C528.5,549.9,527,549,525.6,549.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "526.5,599.1 524.7,599.6 523.5,598.2 524,596.4 525.8,596 527,597.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M526,595.3c1.3,0.4,2.1,1.8,1.7,3.2c-0.4,1.3-1.8,2.1-3.2,1.7c-1.3-0.4-2.1-1.8-1.7-3.2 C523.2,595.7,524.7,594.9,526,595.3z M526,595.2c-1.4-0.4-2.9,0.4-3.4,1.8c-0.4,1.4,0.4,3,1.8,3.4c1.4,0.4,3-0.4,3.4-1.8 C528.3,597.1,527.5,595.6,526,595.2z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 501.6,
    y: 560.6,
    transform: "matrix(0.7935 -0.6086 0.6086 0.7935 -235.0009 429.2789)",
    className: "st5",
    width: 26.9,
    height: 0.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "485.7,589.5 503,570.3 503.4,570.7 486.2,589.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 514,
    y: 566.4,
    transform: "matrix(0.7849 -0.6196 0.6196 0.7849 -251.0622 444.1465)",
    className: "st5",
    width: 0.2,
    height: 34.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "488.3,590 524.8,598.3 524.8,598.5 488.2,590.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "525.9,551.7 555,533.9 555.2,534.1 526,551.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "586.2,513.4 592.6,516.1 593.4,523 587.9,527.3 581.5,524.5 580.7,517.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M579.4,526.1c-3.2-4.2-2.3-10.3,1.9-13.5c4.2-3.2,10.2-2.3,13.4,1.9c3.2,4.2,2.3,10.3-1.9,13.5 C588.6,531.2,582.5,530.4,579.4,526.1z M578.9,526.5c3.4,4.5,9.8,5.4,14.3,2c4.5-3.4,5.4-9.9,2-14.4c-3.4-4.5-9.8-5.4-14.3-2 C576.4,515.5,575.5,522,578.9,526.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "571.9,428.2 575.4,429.7 575.9,433.4 573,435.7 569.5,434.3 569,430.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M568.4,435.2c-1.8-2.2-1.3-5.5,0.9-7.3c2.2-1.8,5.5-1.3,7.2,0.9c1.8,2.2,1.3,5.5-0.9,7.3 C573.4,437.8,570.1,437.4,568.4,435.2z M568.1,435.4c1.9,2.4,5.3,2.9,7.7,1c2.4-1.9,2.8-5.4,1-7.8c-1.9-2.4-5.3-2.8-7.7-1 C566.7,429.5,566.2,433,568.1,435.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "590.8,521.3 687.9,564 687.6,564.7 590.5,522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "572.5,434.1 573.3,434 586.9,515.4 586.1,515.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "689.7,569.5 686.4,567.7 686.3,563.9 689.5,562 692.8,563.8 692.9,567.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M694,563c1.5,2.4,0.7,5.6-1.7,7.1c-2.4,1.5-5.6,0.7-7.1-1.7c-1.5-2.4-0.7-5.6,1.7-7.1 C689.4,559.8,692.6,560.6,694,563z M694.3,562.8c-1.6-2.6-5-3.4-7.5-1.9c-2.6,1.6-3.4,5-1.9,7.6c1.6,2.6,5,3.4,7.6,1.9 C695.1,568.9,695.9,565.4,694.3,562.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "562.6,578.7 558.9,579 556.8,575.9 558.4,572.5 562.1,572.3 564.2,575.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M562.8,570.9c2.6,1.2,3.6,4.4,2.4,7c-1.2,2.6-4.3,3.7-6.9,2.4c-2.6-1.2-3.6-4.3-2.4-6.9 S560.2,569.7,562.8,570.9z M562.9,570.6c-2.7-1.3-6-0.2-7.4,2.6c-1.3,2.8-0.2,6.1,2.6,7.4c2.7,1.3,6,0.2,7.4-2.6 C566.8,575.3,565.6,572,562.9,570.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "579.2,606.8 578.4,606.8 587.3,524.7 588.2,524.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "617.4,616.9 586.8,523.7 587.1,523.6 617.7,616.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "587,524.8 588,525.4 561.8,575 560.8,574.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "561.9,576.9 577.3,607.1 576.3,607.7 560.8,577.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "559.5,577 560.2,577.4 541.5,608.7 540.8,608.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "573,529.2 568.7,530.7 565.4,527.5 566.4,523 570.7,521.6 574,524.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M571.1,519.8c3.3,0.7,5.4,4.2,4.6,7.6c-0.8,3.5-4.1,5.7-7.4,5c-3.3-0.7-5.4-4.2-4.6-7.6 C564.5,521.3,567.8,519.1,571.1,519.8z M571.2,519.4c-3.5-0.8-7.1,1.6-7.9,5.3c-0.8,3.7,1.4,7.3,4.9,8.1 c3.5,0.8,7.1-1.6,7.9-5.3C576.9,523.8,574.7,520.2,571.2,519.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "566.3,561 562.8,560.8 561.4,557.6 563.4,554.7 566.8,554.9 568.3,558  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M567.6,553.7c2.2,1.5,2.7,4.5,1.1,6.8c-1.5,2.2-4.5,2.9-6.7,1.4c-2.1-1.5-2.7-4.5-1.1-6.8 C562.4,552.9,565.4,552.3,567.6,553.7z M567.8,553.5c-2.3-1.6-5.5-0.9-7.1,1.5c-1.6,2.4-1.1,5.6,1.2,7.2 c2.3,1.6,5.5,0.9,7.1-1.5C570.6,558.3,570,555,567.8,553.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "550.1,457.7 526.9,505.6 526.3,505.1 549.5,457.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "531.5,582.4 529.7,584.5 527,584 526.1,581.3 527.9,579.2 530.5,579.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M527.5,578.2c2-0.7,4.1,0.4,4.8,2.5s-0.3,4.2-2.2,4.9s-4.1-0.4-4.8-2.5 C524.6,581.1,525.6,578.9,527.5,578.2z M527.4,577.9c-2.1,0.7-3.1,3.1-2.4,5.2c0.8,2.2,3,3.3,5.1,2.6c2.1-0.7,3.1-3.1,2.4-5.2 C531.8,578.4,529.5,577.2,527.4,577.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "563,558 530,580.8 529.6,580.2 562.5,557.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "530,580.7 529.7,580.6 566.5,527 566.7,527.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M568.9,529.9l-0.3-0.1l-0.1,0.6l0.3,0.1L568.9,529.9z M568.7,530.8l-0.3-0.1l-0.1,0.6l0.3,0.1L568.7,530.8 z M568.5,531.7l-0.3-0.1l-0.1,0.6l0.3,0.1L568.5,531.7z M568.3,532.6l-0.3-0.1l-0.1,0.6l0.3,0.1L568.3,532.6z M568.1,533.5 l-0.3-0.1l-0.1,0.6l0.3,0.1L568.1,533.5z M567.9,534.4l-0.3-0.1l-0.1,0.6l0.3,0.1L567.9,534.4z M567.8,535.3l-0.3-0.1l-0.1,0.6 l0.3,0.1L567.8,535.3z M567.6,536.2l-0.3-0.1l-0.1,0.6l0.3,0.1L567.6,536.2z M567.4,537.1l-0.3-0.1l-0.1,0.6l0.3,0.1 L567.4,537.1z M567.2,538l-0.3-0.1l-0.1,0.6l0.3,0.1L567.2,538z M567,538.9l-0.3-0.1l-0.1,0.6l0.3,0.1L567,538.9z M566.8,539.8 l-0.3-0.1l-0.1,0.6l0.3,0.1L566.8,539.8z M566.6,540.7l-0.3-0.1l-0.1,0.6l0.3,0.1L566.6,540.7z M566.4,541.6l-0.3-0.1l-0.1,0.6 l0.3,0.1L566.4,541.6z M566.2,542.5l-0.3-0.1l-0.1,0.6l0.3,0.1L566.2,542.5z M566,543.4l-0.3-0.1l-0.1,0.6l0.3,0.1L566,543.4z  M565.8,544.3l-0.3-0.1l-0.1,0.6l0.3,0.1L565.8,544.3z M565.7,545.2l-0.3-0.1l-0.1,0.6l0.3,0.1L565.7,545.2z M565.5,546.1 l-0.3-0.1l-0.1,0.6l0.3,0.1L565.5,546.1z M565.3,547L565,547l-0.1,0.6l0.3,0.1L565.3,547z M565.1,547.9l-0.3-0.1l-0.1,0.6 l0.3,0.1L565.1,547.9z M564.9,548.8l-0.3-0.1l-0.1,0.6l0.3,0.1L564.9,548.8z M564.7,549.7l-0.3-0.1l-0.1,0.6l0.3,0.1 L564.7,549.7z M564.5,550.6l-0.3-0.1l-0.1,0.6l0.3,0.1L564.5,550.6z M564.3,551.5l-0.3-0.1l-0.1,0.6l0.3,0.1L564.3,551.5z  M564.1,552.4l-0.3-0.1l-0.1,0.6l0.3,0.1L564.1,552.4z M564,553.3l-0.3-0.1l-0.1,0.6l0.3,0.1L564,553.3z M563.8,554.2l-0.3-0.1 l-0.1,0.6l0.3,0.1L563.8,554.2z M563.6,555.1l-0.3-0.1l-0.1,0.6l0.3,0.1L563.6,555.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "567.3,523.8 566.6,523.9 556,457.1 556.8,457  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "568,523.7 528.2,510.6 528.3,510.3 568.2,523.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "528.1,580.9 527.9,580.7 516.9,514.9 517.2,515.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 527.4,
    y1: 581,
    x2: 556.8,
    y2: 457
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M5.4,496.4l23-70.2l3.2,7.1l-0.3,0l0,0.4c0.2,0,0.4,0,0.5,0l4.1,9.2l0,0.2H36l0.2,0.4l-0.3,0l0,0.7l0.4,0 l0-0.6l4.1,9.1l4.2,33.4l-37.8,12C6.3,497.5,5.9,496.9,5.4,496.4z M4.4,496.2l-0.8,2.6l-4-2.1l-4.5,3l0.3,5.6l4.8,2.5l0.3-0.2h0 v0l3.3-2.3l1.2,2.5c-1.2,1.2-2.9,2-4.7,2.1c-4.1,0.2-7.6-3-7.9-7.3c-0.2-4.2,2.9-7.9,7-8.1C1.3,494.5,3.1,495.1,4.4,496.2z  M5.6,508.1c0.3-0.4,0.7-0.8,0.9-1.2L26.3,523l-10.6,6.2L5.6,508.1z M15.6,529.8l5.1,10.6l-14.7,0.5c0-0.9-0.2-1.8-0.6-2.7 c-0.3-0.7-0.7-1.2-1.2-1.7L15.6,529.8z M3.5,536.5l-1.4,0.8l0-0.5l-0.4,0l0,0.6l-3.8-0.4l-2.3,3.5l1.8,3.9l4.1,0.4l1.5-2.2 l1.6,1.5c-0.6,0.9-1.4,1.7-2.4,2.2c-2.8,1.3-6.3,0-7.7-3c-1.4-3-0.2-6.5,2.7-7.8C-0.6,534.5,1.8,535,3.5,536.5z M5.4,541.9 c-0.1,0.4-0.2,0.8-0.3,1.3l-1.2-1.2L5.4,541.9z M2.2,537.7l1.5-0.9c0.5,0.5,0.9,1,1.2,1.7c0.4,0.8,0.6,1.7,0.6,2.5l-1.7,0 L2.2,537.7z M5.4,543.4c0.2-0.5,0.4-1,0.4-1.5l15.2-0.5l14.7,30.8l-0.1,0.1L5.4,543.4z M35.1,573l1.1,1l-1.3,2.4l1.7,2.8 l3.3-0.1l1.6-3l-1.3-2.2l1.2-1c1.4,1.4,1.8,3.6,0.8,5.5c-1.2,2.3-4,3.1-6.2,2c-2.2-1.2-3-4-1.8-6.3 C34.5,573.7,34.8,573.3,35.1,573z M41.4,572.4c-0.1-0.1-0.3-0.2-0.4-0.3l9.2-21.2c0.1,0,0.2,0,0.2,0c4.3,0.5,8.3-2.8,8.8-7.3 c0.1-1,0-1.9-0.2-2.8l9.8-1.7c-0.1,0.9,0,1.9,0.2,2.9c0.3,1.8,1.1,3.3,2.2,4.6L41.4,572.4z M71.8,546.6l2.1-1.8l6.2,2.2l5-4.5 l-1.3-6.8l-6-2.2l-0.6-2.8c4.9-0.8,9.7,2.7,10.7,7.8c1,5.2-2.2,10.3-7.3,11.2C77.2,550.3,74,549,71.8,546.6z M68,494.6l8.1,35.6 l-0.4,0.1l-12.6-27.9l2.6-8.5C66.5,494.2,67.2,494.4,68,494.6z M68.8,493.8l-1.1-4.8l8.9-0.2l4.8-8.8l-5.2-8.5l-9.5,0.2 l-2.2-3.5c6.5-3.7,14.7-1.6,18.7,4.8c4,6.5,2,15-4.5,19C75.6,494,72,494.5,68.8,493.8z M40.7,452.6l-3.2-25.5l2.7,4.4 c-0.1,0.1-0.3,0.2-0.5,0.2l0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.3L63.2,468c-4.8,3.2-7.2,8.8-6.5,14.2l-2.4,0.8L40.7,452.6z M44.9,486 l-4-32.1L54,483.1L44.9,486z M45,486.3l9.2-2.9l5,11l-11.8,10.7L45,486.3z M6.2,506.6c-0.2,0.4-0.5,0.7-0.8,1l-1-2.1l1.2,0.6 L6.2,506.6z M26.6,522.8L7.1,506.9l21,10.6c-0.5,1.4-0.3,2.9,0.5,4.2L26.6,522.8z M26.9,523.1l1.9-1.1c0,0.1,0.1,0.1,0.1,0.2 c1.1,1.3,2.8,1.8,4.4,1.6l0.6,5.1L26.9,523.1z M21,540.4l-5.2-10.8l10.7-6.3l7.4,6l1.2,10.6L21,540.4z M36,572.5l-0.1-0.1l0,0 L36,572.5z M36.2,572.2c0.8-0.4,1.7-0.6,2.7-0.5l0.2,1.7l-2.1,0.1l-0.2-0.2L36.2,572.2z M40.8,572.4c0.1,0.1,0.2,0.1,0.3,0.2 l-0.7,0.6L40.8,572.4z M39.4,573.3l-0.2-1.6c0.3,0,0.5,0.1,0.8,0.2L39.4,573.3L39.4,573.3z M40.1,571.7 c-0.3-0.1-0.6-0.2-0.9-0.3l-3.5-30.6l8-0.3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.5,4.1,2.1,7.8,5.8,8.8L40.1,571.7z M58.3,540.1 l-2.2,0.4l-3.8-2.9l0.7-2.2C55.5,535.8,57.4,537.7,58.3,540.1z M47.1,506.5l3.5,28.1c-2,0.2-3.7,1.1-5,2.5l-11-13.8 c0.4-0.2,0.9-0.4,1.2-0.8c2-1.7,2.3-4.6,0.9-6.6L47.1,506.5z M28.9,521.5c-0.8-1.2-0.9-2.6-0.5-3.9l1.3,0.7l0.4,2.5L28.9,521.5z  M33.3,523.4c-1.5,0.2-3.1-0.2-4.1-1.5c0-0.1-0.1-0.1-0.1-0.2l1.1-0.7l3,1L33.3,523.4z M34.4,523.1l-0.9-1.1l2.3-2l-0.5-2.8 l1.1-1c1.3,1.9,1,4.5-0.8,6.1C35.3,522.7,34.8,522.9,34.4,523.1z M33.7,523.4l-0.1-0.7l0.5,0.6 C33.9,523.3,33.8,523.3,33.7,523.4z M34.3,529.1l-0.6-5.5c0.2,0,0.4-0.1,0.6-0.2l11.1,13.9c-0.1,0.2-0.2,0.3-0.4,0.5L34.3,529.1 z M44,539.6l-8.4,0.3l-1.2-10.2l10.4,8.5C44.5,538.6,44.2,539.1,44,539.6z M44.6,539.6c0.2-0.4,0.4-0.8,0.6-1.1l1.3,1.1 L44.6,539.6z M45.4,538.2l0.3-0.4l1.4,1.7l0,0L45.4,538.2z M50.7,535.1l0.3,2.6l-3.7,1.7l-1.5-1.8 C47.2,536.1,48.9,535.3,50.7,535.1z M51.4,537.4l-0.3-2.3c0.3,0,0.7,0,1,0L51.4,537.4z M49.5,550.3c-3.5-0.9-6-4.5-5.5-8.3 c0-0.5,0.2-1,0.3-1.4l2.7-0.1l-0.5,4.6l4,3.1L49.5,550.3z M32.5,514.7l0-0.3c1.2-0.1,2.4,0.3,3.3,1.1l-1.1,1l-2.3-0.8l0-0.7 l-0.4,0l0,0.7l-2,1.7l-1.4-0.7c0.3-0.5,0.6-0.9,1-1.2c0.7-0.6,1.5-1,2.4-1.1l0,0.3L32.5,514.7z M62.4,501.7l-10.2,32.9 c-0.4,0-0.8-0.1-1.2,0l-3.6-28.3l12-10.9L62.4,501.7z M64.9,493.5l-2.4,7.6l-2.8-6.1l3-2.8C63.5,492.8,64.2,493.2,64.9,493.5z  M66.9,490l0.8,3.6c-0.6-0.1-1.2-0.4-1.7-0.6L66.9,490z M65.2,492.6c-0.6-0.3-1.1-0.6-1.7-1l2.7-2.5L65.2,492.6z M58.8,488 c0.9,1.5,2,2.7,3.3,3.7l-2.7,2.4l-4.9-10.9l2.3-0.7C57.1,484.4,57.7,486.3,58.8,488z M66,488.1l-3.2,2.9c-1.2-1-2.3-2.2-3.2-3.6 c-1-1.6-1.6-3.4-1.9-5.2l4-1.3L66,488.1z M61.3,480.5l0.1,0.2l-3.8,1.2c-0.6-5,1.6-10.2,6-13.2l2.2,3.5L61.3,480.5z M68.9,538.3 L58.8,540c-0.9-2.5-3-4.6-5.6-5.2L63,503l12.4,27.5C71.9,531.7,69.5,534.7,68.9,538.3z M69.6,538.2c0.6-3.3,2.9-6,6-7.1l1.2,2.8 l-4.3,3.8L69.6,538.2z M71.6,546.3c-1-1.2-1.7-2.7-2-4.3c-0.2-1-0.2-1.9-0.2-2.8l3-0.5l1.2,6L71.6,546.3z M76.6,532.3l-0.6-1.3 c0.1,0,0.2,0,0.3-0.1L76.6,532.3z M50.4,550.4l1.1-2.4l4.2-1.9l0.5-4.7l2.4-0.4c0.2,0.9,0.3,1.8,0.2,2.7 c-0.5,4.2-4.2,7.3-8.2,6.8C50.4,550.5,50.4,550.5,50.4,550.4z M21.5,541.3l13.9-0.5l3.5,30.5c-1-0.1-1.9,0.1-2.7,0.5L21.5,541.3 z M4.6,498.8l0.6-1.8c0.4,0.4,0.7,0.8,1,1.3L4.6,498.8z M6.4,498.6c0.6,1,0.9,2.1,1,3.3c0.1,1.3-0.2,2.6-0.7,3.7l-1.9-1 l-0.3-5.4h0l0-0.1L6.4,498.6z M33.8,490.5l0-0.6l10.8-3.4l2.4,19l-10.9,9.9c-1-0.9-2.3-1.3-3.6-1.2l0-0.1l-0.4,0v0.2 c-0.9,0.1-1.8,0.5-2.6,1.2c-0.4,0.4-0.8,0.9-1.1,1.3L7.1,505.9c0.6-1.2,0.8-2.6,0.7-4c-0.1-1.3-0.4-2.4-1-3.5l26.6-8.4l0,0.5 L33.8,490.5z M28.7,425.9l8.1,0.1l0,0l0,0.5l0.3,0l0,0.4l-0.3,0l0,0.7l0.4,0l0-0.5l0.7,5.7l-0.1-0.3l-0.7,0.2l0.1,0.4 c0.2-0.1,0.5-0.1,0.7-0.2l2.3,18.6l-3.9-8.6l0-0.5l-0.2,0L28.7,425.9z M27.7,408.6l-5.1,8.6l4.9,8.6L4.6,495.7 c-1.4-1.1-3.2-1.7-5.2-1.6c-4.4,0.2-7.7,4.1-7.4,8.7c0.3,4.5,4,8,8.3,7.8l0,0.5l0.4,0l0-0.5c1.8-0.2,3.4-0.9,4.6-2.1l10.1,21.1 l-11.6,6.8c-0.5-0.5-1.2-0.9-1.8-1.2l0-0.5l-0.4,0l0,0.4c-1.4-0.5-3.1-0.5-4.5,0.2c-3,1.4-4.3,5.1-2.8,8.3 c1.5,3.2,5.2,4.6,8.2,3.2c1.1-0.5,1.9-1.3,2.5-2.3l29.9,28.5c-0.3,0.4-0.7,0.7-0.9,1.2c-1.3,2.4-0.5,5.4,1.9,6.7 c2.3,1.3,5.3,0.3,6.6-2.1c1.1-2,0.7-4.4-0.8-5.9L71.4,547c2.3,2.6,5.8,4,9.3,3.3c5.4-1,8.8-6.4,7.8-12 c-1.1-5.5-6.2-9.1-11.5-8.3l-8-35.2c3.4,0.6,7,0,10.1-2c6.9-4.2,9.1-13.3,4.8-20.3c-4.2-6.8-13.1-9-20-5.1l-26.2-41.8l4.9-8.4 l-5-8.7L27.7,408.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.7,432.5l-0.1,0.3c-0.2-0.1-0.5-0.1-0.7-0.2l0.1-0.3C27.3,432.4,27.5,432.4,27.7,432.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29,433.3c-0.2-0.1-0.5-0.1-0.7-0.2l0.1-0.4l0.7,0.2L29,433.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.5,433.5c-0.2,0-0.5-0.1-0.7-0.1l0.1-0.4c0.2,0,0.5,0.1,0.7,0.1L30.5,433.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.7,402.7l-0.2-0.3c0.2-0.1,0.5-0.2,0.7-0.3l0.1,0.3L25.7,402.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27,402.2l-0.1-0.3c0.2-0.1,0.5-0.2,0.7-0.2l0.1,0.3C27.5,402,27.3,402.1,27,402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.8,419.9l-0.4,0.1c0-0.2-0.1-0.5-0.1-0.7l0.4,0C16.7,419.5,16.8,419.7,16.8,419.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M28.4,401.7l-0.1-0.4c0.2-0.1,0.5-0.1,0.7-0.2l0.1,0.4L28.4,401.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.9,401.4l-0.1-0.4c0.2,0,0.5-0.1,0.7-0.1l0,0.4C30.3,401.4,30.1,401.4,29.9,401.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.3,400.9c0.2,0,0.5,0,0.7,0l0,0.4c-0.2,0-0.5,0-0.7,0L31.3,400.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.3,432.9l0.1,0.4c-0.2,0-0.5,0.1-0.7,0.1l-0.1-0.4C35.9,433,36.1,432.9,36.3,432.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.9,404.5l-0.2-0.3c0.2-0.1,0.4-0.3,0.6-0.4l0.2,0.3C23.2,404.2,23,404.3,22.9,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.8,405.4l-0.2-0.3l0.6-0.5l0.2,0.3C22.1,405.1,21.9,405.2,21.8,405.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.7,406.4l-0.3-0.3c0.2-0.2,0.3-0.4,0.5-0.5l0.3,0.3C21,406.1,20.9,406.3,20.7,406.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.8,407.6l-0.3-0.2c0.1-0.2,0.3-0.4,0.5-0.6l0.3,0.2L19.8,407.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19,408.8l-0.3-0.2c0.1-0.2,0.3-0.4,0.4-0.6l0.3,0.2C19.2,408.4,19.1,408.6,19,408.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.4,430c-0.2-0.2-0.4-0.3-0.6-0.5l0.2-0.3c0.2,0.2,0.4,0.3,0.6,0.5L22.4,430z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.5,433.7c-0.2,0-0.5,0-0.8,0v-0.4l0.7,0L33.5,433.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.3,410l-0.3-0.2c0.1-0.2,0.2-0.4,0.4-0.7l0.3,0.2C18.5,409.6,18.4,409.8,18.3,410z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.6,418.5l-0.4,0c0-0.2,0-0.5-0.1-0.8l0.4,0C16.6,418,16.6,418.2,16.6,418.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.9,414.2l-0.4-0.1l0.2-0.7l0.4,0.1C17,413.7,16.9,413.9,16.9,414.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.6,417h-0.4l0-0.8l0.4,0C16.6,416.6,16.6,416.8,16.6,417z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.6,415.6l-0.4,0c0-0.2,0-0.5,0.1-0.7l0.4,0C16.7,415.1,16.7,415.3,16.6,415.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.7,411.4l-0.3-0.1l0.3-0.7l0.3,0.1C17.9,410.9,17.8,411.1,17.7,411.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.2,412.7l-0.4-0.1c0.1-0.2,0.1-0.5,0.2-0.7l0.4,0.1C17.4,412.3,17.3,412.5,17.2,412.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.7,406.2c0.2,0.2,0.3,0.4,0.5,0.5l-0.3,0.2c-0.2-0.2-0.3-0.4-0.5-0.6L44.7,406.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.6,430.6l0.2,0.3c-0.2,0.1-0.4,0.3-0.6,0.4L41,431C41.2,430.8,41.4,430.7,41.6,430.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.9,431.7c-0.2-0.1-0.4-0.2-0.7-0.4l0.2-0.3l0.6,0.3L24.9,431.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.6,430.9c-0.2-0.1-0.4-0.3-0.6-0.4l0.2-0.3c0.2,0.1,0.4,0.3,0.6,0.4L23.6,430.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M42.8,429.7L43,430c-0.2,0.2-0.4,0.3-0.6,0.5l-0.2-0.3C42.4,430,42.6,429.9,42.8,429.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.9,427.7l0.3,0.2c-0.2,0.2-0.3,0.4-0.5,0.6l-0.3-0.2C44.6,428.1,44.7,427.9,44.9,427.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.8,426.5l0.3,0.2c-0.2,0.2-0.3,0.4-0.4,0.6l-0.3-0.2L45.8,426.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43.9,428.8l0.3,0.3c-0.2,0.2-0.4,0.3-0.5,0.5l-0.2-0.3L43.9,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.9,402.8l0.2,0.3l-0.4,0.2c-0.2,0.1-0.4,0.2-0.6,0.4l-0.2-0.3c0.2-0.1,0.4-0.3,0.6-0.4L24.9,402.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.2,428c-0.2-0.2-0.3-0.4-0.5-0.6l0.3-0.2c0.2,0.2,0.3,0.4,0.5,0.6L20.2,428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M21.3,429.1c-0.2-0.2-0.4-0.4-0.5-0.5l0.3-0.2c0.2,0.2,0.3,0.4,0.5,0.5L21.3,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19.3,426.8l-0.4-0.6l0.3-0.2c0.1,0.2,0.3,0.4,0.4,0.6L19.3,426.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.1,424.1l-0.3,0.1c-0.1-0.2-0.2-0.4-0.3-0.7l0.3-0.1C17.9,423.6,18,423.9,18.1,424.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.6,422.7l-0.4,0.1c-0.1-0.2-0.2-0.5-0.2-0.7l0.4-0.1C17.4,422.3,17.5,422.5,17.6,422.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "18.7,425.1 18.8,425.4 18.5,425.6 18.4,425.3 18.1,424.9 18.5,424.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.1,421.4l-0.4,0.1c-0.1-0.2-0.1-0.5-0.2-0.7l0.4-0.1C17,420.9,17,421.1,17.1,421.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.5,408.5c0.1,0.2,0.3,0.4,0.4,0.6l-0.3,0.2c-0.1-0.2-0.2-0.4-0.4-0.6L46.5,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.5,411.3l0.3-0.1c0.1,0.2,0.2,0.5,0.3,0.7l-0.4,0.1C47.7,411.7,47.6,411.5,47.5,411.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "48.4,414.1 48.7,414 48.9,414.7 48.5,414.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48,412.7l0.4-0.1c0.1,0.2,0.1,0.5,0.2,0.7l-0.4,0.1C48.2,413.1,48.1,412.9,48,412.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.6,415.5l0.4,0c0,0.2,0,0.5,0.1,0.7l-0.4,0C48.7,416,48.6,415.8,48.6,415.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.9,433.2l0,0.4c-0.2,0-0.5,0.1-0.7,0.1l0-0.4C34.4,433.2,34.7,433.2,34.9,433.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.7,407.3c0.1,0.2,0.3,0.4,0.4,0.6l-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6L45.7,407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.7,417l0.4,0v0.7l-0.4,0C48.7,417.4,48.7,417.2,48.7,417z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "46.9,410 47.2,409.8 47.6,410.5 47.2,410.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.2,424l0.3,0.2c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3-0.2C47,424.5,47.1,424.2,47.2,424z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.7,418.4l0.4,0c0,0.2,0,0.5-0.1,0.7l-0.4,0L48.7,418.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.5,419.9l0.4,0.1c0,0.2-0.1,0.5-0.1,0.7l-0.4-0.1C48.4,420.3,48.5,420.1,48.5,419.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M39.1,432l0.2,0.3l-0.7,0.3l-0.1-0.4C38.7,432.2,38.9,432.1,39.1,432z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M47.8,422.7l0.3,0.1c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3-0.1C47.6,423.1,47.7,422.9,47.8,422.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.6,425.3l0.3,0.2l-0.4,0.6l-0.3-0.2C46.3,425.7,46.4,425.5,46.6,425.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.2,421.3l0.4,0.1l-0.2,0.7L48,422C48.1,421.8,48.1,421.5,48.2,421.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.9,430.9 36.6,430.9 36.6,430.2 37,430.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.7,510.3 32.4,510.3 32.4,509.5 32.8,509.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.6,512.5 32.2,512.5 32.3,511.7 32.7,511.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.6,513.6 32.2,513.6 32.2,512.9 32.6,512.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 510.8,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -479.5201 515.9099)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "37,429.8 36.6,429.8 36.7,429.1 37,429.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "37,428.7 36.7,428.7 36.7,428 37.1,428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.7,435.3 36.3,435.3 36.4,434.6 36.7,434.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 439.2,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -404.3936 451.897)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.4,440.9 36,440.8 36.1,440.1 36.4,440.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.3,442 36,441.9 36,441.2 36.4,441.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.5,432.4 36.8,432.4 36.8,433.1 36.4,433.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 438.1,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -403.2384 450.9163)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.5,431.3 36.9,431.3 36.9,432 36.5,432  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.8,434.2 36.4,434.2 36.4,433.5 36.8,433.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.6,436.4 36.3,436.4 36.3,435.7 36.7,435.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.6,437.5 36.2,437.5 36.2,436.8 36.6,436.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.2,501.5 32.8,501.5 32.9,500.7 33.2,500.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.1,465.1 34.8,465.1 34.8,464.3 35.2,464.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.1,466.2 34.7,466.2 34.7,465.5 35.1,465.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35,467.3 34.6,467.3 34.7,466.6 35,466.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.9,468.4 34.6,468.4 34.6,467.7 35,467.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.3,461.8 34.9,461.8 35,461 35.3,461.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.2,464 34.8,464 34.9,463.2 35.2,463.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.2,462.9 34.9,462.9 34.9,462.1 35.3,462.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.7,473.9 34.3,473.9 34.3,473.2 34.7,473.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.6,475 34.2,475 34.3,474.3 34.6,474.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 476.7,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -443.697 485.3816)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.8,
    y: 460.1,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -426.3581 470.6031)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 475.6,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -442.5369 484.3961)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.3,
    y: 470.1,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -436.7606 479.4731)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.7,472.8 34.3,472.8 34.4,472.1 34.8,472.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.8,471.7 34.4,471.7 34.5,471 34.8,471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.9,469.5 34.5,469.5 34.6,468.8 34.9,468.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 449.1,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -414.791 460.7623)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.8,451.9 35.5,451.9 35.5,451.1 35.9,451.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36,448.6 35.6,448.5 35.7,447.8 36,447.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.9,450.8 35.5,450.8 35.5,450 35.9,450  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.1,447.5 35.7,447.4 35.7,446.7 36.1,446.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.2,445.3 35.8,445.2 35.8,444.5 36.2,444.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "36.1,446.4 35.8,446.3 35.8,445.6 36.2,445.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.5,458.5 35.1,458.5 35.1,457.7 35.5,457.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.5,457.4 35.2,457.4 35.2,456.6 35.6,456.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.4,459.6 35,459.6 35.1,458.8 35.5,458.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.6,456.3 35.2,456.3 35.3,455.5 35.6,455.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.7,455.2 35.3,455.2 35.3,454.4 35.7,454.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.2,
    y: 452.4,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -418.2615 463.7092)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "35.7,454.1 35.3,454.1 35.4,453.3 35.7,453.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.5,496 33.1,495.9 33.2,495.2 33.5,495.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.3,480.5 33.9,480.5 34,479.8 34.3,479.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.7,
    y: 481.1,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -448.3132 489.3192)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.4,479.4 34,479.4 34,478.7 34.4,478.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.4,478.3 34.1,478.3 34.1,477.6 34.5,477.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.2,482.7 33.8,482.7 33.9,482 34.2,482  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.7,492.7 33.3,492.6 33.3,491.9 33.7,491.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.6,494.9 33.2,494.9 33.2,494.1 33.6,494.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.7,491.6 33.4,491.5 33.4,490.8 33.8,490.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.9,488.3 33.5,488.2 33.6,487.5 33.9,487.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.8,489.4 33.5,489.3 33.5,488.6 33.9,488.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34,487.2 33.6,487.1 33.6,486.4 34,486.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34,486 33.7,486 33.7,485.3 34,485.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.1,483.8 33.8,483.8 33.8,483.1 34.2,483.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "34.1,484.9 33.7,484.9 33.8,484.2 34.1,484.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.1,
    y: 493.2,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -461.026 500.1507)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 505.3,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -473.7437 510.9869)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.1,502.6 32.8,502.6 32.8,501.8 33.2,501.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.1,503.7 32.7,503.7 32.8,502.9 33.1,503  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 504.2,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -472.5836 510.0014)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.8,508.1 32.5,508.1 32.5,507.3 32.9,507.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.9,507 32.5,507 32.6,506.2 33,506.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 498.7,
    transform: "matrix(5.397526e-02 -0.9985 0.9985 5.397526e-02 -466.8073 505.0784)",
    className: "st5",
    width: 0.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.3,500.4 32.9,500.4 32.9,499.6 33.3,499.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "32.8,509.2 32.4,509.2 32.5,508.4 32.8,508.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.4,497.1 33.1,497 33.1,496.3 33.5,496.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "33.4,498.2 33,498.2 33,497.4 33.4,497.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 533.5,
    transform: "matrix(0.9985 -5.471245e-02 5.471245e-02 0.9985 -29.2045 0.8945)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.5,533.1 1.5,532.4 1.9,532.3 1.9,533.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.6,535.7 2,535.7 2,536.4 1.7,536.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 509.2,
    transform: "matrix(0.9985 -5.397526e-02 5.397526e-02 0.9985 -27.5032 0.7695)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1,516.5 0.7,516.6 0.6,515.8 1,515.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.2,519.8 0.8,519.9 0.8,519.1 1.2,519.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 518,
    transform: "matrix(0.9985 -5.397526e-02 5.397526e-02 0.9985 -27.9786 0.8067)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.4,523.2 1,523.2 1,522.4 1.3,522.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.3,522.1 0.9,522.1 0.9,521.3 1.3,521.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.3,521 0.9,521 0.9,520.2 1.2,520.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.1,517.6 0.7,517.7 0.7,516.9 1.1,516.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 513.6,
    transform: "matrix(0.9985 -5.397526e-02 5.397526e-02 0.9985 -27.7409 0.7878)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1,515.4 0.6,515.5 0.6,514.7 0.9,514.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0.6,508.8 0.3,508.8 0.2,508.1 0.6,508.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0.9,513.2 0.5,513.3 0.5,512.5 0.8,512.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.4,524.3 1.1,524.3 1,523.5 1.4,523.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.8,530.9 1.4,530.9 1.4,530.2 1.7,530.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.7,529.8 1.4,529.8 1.3,529.1 1.7,529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "0.8,512.1 0.4,512.1 0.4,511.4 0.8,511.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.8,532 1.5,532 1.4,531.3 1.8,531.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.3,
    y: 527.9,
    transform: "matrix(0.9985 -5.397526e-02 5.397526e-02 0.9985 -28.5138 0.8487)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.5,525.4 1.1,525.4 1.1,524.6 1.5,524.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.5,526.5 1.2,526.5 1.1,525.7 1.5,525.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1.6,527.6 1.2,527.6 1.2,526.9 1.6,526.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M199.8,524.3l2.2,74l-5.4-5.6l0.3-0.1l-0.1-0.4c-0.2,0-0.3,0.1-0.5,0.1l-7-7.3l-0.1-0.2l-0.1,0l-0.3-0.3 l0.3-0.1l-0.2-0.7l-0.4,0.1l0.2,0.5l-6.9-7.2l-15.3-30l31.4-24.2C198.5,523.6,199.1,524,199.8,524.3z M200.7,524.1l-0.1-2.8 l4.5,0.6l3.2-4.4l-2.2-5.1l-5.4-0.8l-0.2,0.3l0,0l0,0l-2.4,3.3l-2-1.9c0.7-1.6,2-2.9,3.7-3.6c3.8-1.6,8.2,0.3,9.9,4.2 c1.7,3.9,0,8.4-3.8,10C204.2,524.7,202.4,524.7,200.7,524.1z M195.5,513.3c-0.2,0.5-0.4,0.9-0.5,1.4l-24-8.5l7.8-9.5 L195.5,513.3z M178.8,496.3l-8.4-8.3l13.7-5.5c0.3,0.8,0.8,1.6,1.5,2.3c0.5,0.5,1.1,0.9,1.7,1.2L178.8,496.3z M187.9,485.9 l1-1.2l0.2,0.5l0.3-0.1l-0.2-0.5l3.7-0.9l1-4l-3-3l-4,1l-0.7,2.6l-2-0.9c0.2-1.1,0.7-2.1,1.5-2.9c2.2-2.2,5.9-2.1,8.2,0.2 c2.3,2.3,2.4,6,0.2,8.2C192.4,486.4,190,486.8,187.9,485.9z M184.2,481.5c-0.1-0.4-0.1-0.9-0.1-1.3l1.6,0.7L184.2,481.5z  M188.7,484.4l-1.1,1.4c-0.6-0.3-1.2-0.7-1.7-1.2c-0.6-0.6-1.1-1.4-1.4-2.2l1.6-0.6L188.7,484.4z M183.7,480 c0,0.5,0,1.1,0.1,1.6l-14.1,5.7l-24.3-24l0.1-0.1L183.7,480z M145.7,462.3l-1.4-0.6l0.4-2.7l-2.5-2.1l-3,1.2l-0.5,3.3l2,1.6 l-0.8,1.4c-1.8-0.8-2.9-2.8-2.6-4.9c0.4-2.5,2.7-4.3,5.1-3.9c2.5,0.4,4.2,2.7,3.8,5.3C146.1,461.4,145.9,461.8,145.7,462.3z  M140.1,464.9c0.2,0.1,0.3,0.1,0.5,0.1l-1.4,23.1l-0.2,0c-4.2,1-6.9,5.4-5.8,9.9c0.2,0.9,0.6,1.8,1.1,2.6l-8.6,4.9 c-0.2-0.9-0.6-1.8-1.1-2.6c-0.9-1.6-2.2-2.8-3.6-3.6L140.1,464.9z M120.2,499.6l-1.3,2.4l-6.5,0l-3.2,6l3.6,6l6.3,0l1.6,2.4 c-4.4,2.4-10,0.8-12.7-3.7c-2.7-4.6-1.4-10.4,3-13C113.9,497.9,117.4,498,120.2,499.6z M141.6,547.2l-19.7-30.8 c0.1-0.1,0.2-0.2,0.3-0.2l21.3,22l0.4,8.9C143.1,547.1,142.3,547.2,141.6,547.2z M141.1,548.2l2.7,4.2l-8.3,3.2l-1.5,9.9 l7.8,6.2l8.8-3.4l3.2,2.5c-4.8,5.7-13.3,6.5-19.2,1.8c-6-4.8-7-13.5-2.2-19.4C134.7,550.4,137.8,548.8,141.1,548.2z  M181.5,577.5l11.7,23l-4-3.2c0.1-0.1,0.2-0.3,0.4-0.4l-0.3-0.3c-0.1,0.1-0.2,0.3-0.4,0.4l-33.7-26.4c3.4-4.6,3.8-10.7,1.2-15.6 l2-1.5L181.5,577.5z M166.2,547.6l14.7,28.9l-22.3-23.1L166.2,547.6z M166,547.2l-7.7,5.9l-8.4-8.7l7.4-14.1L166,547.2z  M195.6,514.9c0.1-0.4,0.2-0.8,0.4-1.2l1.7,1.6l-1.3-0.2L195.6,514.9z M170.8,506.6l23.7,8.4l-23.3-2.8c0-1.5-0.7-2.9-1.9-3.8 L170.8,506.6z M170.4,506.5l-1.4,1.7c-0.1,0-0.1-0.1-0.2-0.1c-1.5-0.8-3.2-0.8-4.7,0l-2.3-4.6L170.4,506.5z M170.1,488.2 l8.5,8.4l-7.9,9.6l-9-3.2l-4.8-9.6L170.1,488.2z M145.1,463l0.1,0.1l0,0L145.1,463z M145,463.4c-0.6,0.7-1.4,1.2-2.3,1.4 l-0.7-1.5l2-0.8l0.3,0.1L145,463.4z M140.6,464.7c-0.1,0-0.2-0.1-0.4-0.1l0.4-0.8L140.6,464.7z M141.6,463.4l0.7,1.4 c-0.3,0-0.5,0.1-0.8,0L141.6,463.4L141.6,463.4z M141.5,465.2c0.3,0,0.7,0,1-0.1l13.7,27.6l-7.4,3c0-0.5-0.1-0.9-0.2-1.4 c-1-4-4.6-6.7-8.5-6.4L141.5,465.2z M135.2,501.1l1.9-1.1l4.6,1.5l0.1,2.4C139.3,504.2,136.8,503.1,135.2,501.1z M157.1,528.9 l-12.9-25.2c1.8-0.8,3.1-2.3,3.9-4.1l15,9.2c-0.3,0.3-0.7,0.7-0.9,1.1c-1.3,2.3-0.6,5.1,1.4,6.5L157.1,528.9z M169.2,508.6 c1.1,0.8,1.8,2.1,1.8,3.5l-1.4-0.2l-1.3-2.2L169.2,508.6z M164.3,508.3c1.3-0.8,3-0.8,4.4,0c0.1,0,0.1,0.1,0.2,0.1l-0.8,1 l-3.1,0.1L164.3,508.3z M163.4,509l1.2,0.8l-1.5,2.7l1.4,2.4l-0.7,1.3c-1.9-1.3-2.5-3.9-1.3-6.1 C162.7,509.7,163.1,509.3,163.4,509z M164,508.5l0.3,0.6l-0.7-0.4C163.8,508.6,163.9,508.6,164,508.5z M161.4,503.3l2.5,4.9 c-0.2,0.1-0.3,0.2-0.5,0.3l-15.2-9.3c0.1-0.2,0.1-0.4,0.2-0.6L161.4,503.3z M148.8,496.7l7.8-3.1l4.6,9.2l-12.7-4.5 C148.7,497.8,148.8,497.3,148.8,496.7z M148.3,496.9c0,0.4-0.1,0.9-0.2,1.3l-1.6-0.6L148.3,496.9z M148,498.6 c0,0.2-0.1,0.3-0.1,0.5l-1.9-1.1l0,0L148,498.6z M144,503.3l-1.2-2.3l2.9-2.8l2,1.2C147,501.1,145.7,502.5,144,503.3z  M142.6,501.3l1,2c-0.3,0.1-0.6,0.2-0.9,0.3L142.6,501.3z M140,488.5c3.6-0.3,7.1,2.2,8,6c0.1,0.5,0.2,1,0.2,1.4l-2.5,1 l-1.1-4.5l-4.8-1.5L140,488.5z M168,516.3l0.1,0.3c-1.1,0.5-2.4,0.5-3.5,0.1l0.7-1.4l2.4-0.1l0.2,0.7l0.4-0.1l-0.2-0.7l1.3-2.3 l1.5,0.2c-0.1,0.5-0.3,1-0.5,1.5c-0.5,0.8-1.1,1.4-1.9,1.8l-0.1-0.2L168,516.3z M144.4,538.7l-1.7-34.5l0,0 c0.4-0.1,0.8-0.2,1.1-0.4l13,25.5l-7.6,14.4L144.4,538.7z M144.8,547.2l-0.4-8l4.7,4.8l-1.9,3.6 C146.4,547.5,145.6,547.3,144.8,547.2z M144.1,551.2l-2-3.1c0.6,0,1.2-0.1,1.8,0L144.1,551.2z M144.9,548.2 c0.6,0.1,1.3,0.2,1.9,0.4l-1.7,3.2L144.9,548.2z M152.5,550.4c-1.3-1.1-2.8-1.9-4.4-2.4l1.7-3.2l8.3,8.6l-1.9,1.4 C155.3,553.1,154,551.6,152.5,550.4z M145.6,552.7l2.1-3.9c1.5,0.5,2.9,1.3,4.2,2.3c1.5,1.2,2.7,2.7,3.6,4.2l-3.3,2.6 L145.6,552.7z M152.6,558.3l-0.2-0.1l3.2-2.4c2.3,4.5,2,10.1-1.2,14.4l-3.2-2.5L152.6,558.3z M125.8,506.4l8.9-5.1 c1.7,2.1,4.3,3.3,7.1,3l1.6,33.3l-21-21.7C125.2,513.7,126.5,510,125.8,506.4z M125.3,506.8c0.5,3.3-0.7,6.6-3.3,8.7l-2.1-2.2 l2.7-5.1L125.3,506.8z M120.6,499.8c1.3,0.8,2.5,2,3.4,3.4c0.5,0.8,0.9,1.7,1.1,2.6l-2.7,1.5l-3.1-5.2L120.6,499.8z  M120.7,514.7l1,1.1c-0.1,0.1-0.2,0.1-0.2,0.2L120.7,514.7z M139.1,488.7l-0.2,2.7l-3.3,3.2l1.1,4.6l-2.1,1.2 c-0.5-0.7-0.8-1.6-1.1-2.5c-1-4.1,1.4-8.3,5.4-9.2L139.1,488.7z M169.4,487.5l-12.8,5.2l-13.7-27.5c0.9-0.2,1.8-0.8,2.4-1.5 L169.4,487.5z M199.7,521.8l0.1,1.9c-0.5-0.2-1-0.5-1.4-0.9L199.7,521.8z M198.1,522.6c-0.8-0.8-1.6-1.7-2.1-2.8 c-0.5-1.2-0.7-2.5-0.6-3.8l2.1,0.3l2.1,5l0,0l0,0.1L198.1,522.6z M175.1,539.5l0.2,0.6l-9,6.9l-8.7-17.1l6.9-13 c1.2,0.5,2.6,0.5,3.8,0l0,0.1l0.4-0.1l0-0.1c0.8-0.4,1.5-1.1,2-2c0.3-0.5,0.5-1.1,0.6-1.6l23.7,2.9c-0.1,1.3,0.1,2.7,0.7,4 c0.5,1.2,1.2,2.1,2.1,2.9l-22.1,17l-0.1-0.4L175.1,539.5z M201.9,598.6l-7.7,2.7l0,0l-0.1-0.5l-0.2,0.1l-0.2-0.3l0.3-0.1 l-0.2-0.7l-0.4,0.1l0.2,0.5l-2.6-5.1l0.2,0.2l0.6-0.4l-0.2-0.3c-0.2,0.1-0.4,0.3-0.6,0.4l-8.5-16.7l6.6,6.8l0.1,0.5l0.2-0.1 L201.9,598.6z M208.7,614.6l1.8-9.8l-7.6-6.5l-2.2-73.7c1.7,0.6,3.6,0.5,5.4-0.2c4-1.7,5.8-6.5,4-10.7 c-1.8-4.2-6.5-6.2-10.5-4.5l-0.2-0.4l-0.3,0.1l0.2,0.5c-1.6,0.8-2.9,2-3.6,3.6l-16.6-16.4l8.5-10.4c0.7,0.3,1.4,0.5,2.1,0.5 l0.2,0.5l0.3-0.1l-0.1-0.3c1.5,0,3.1-0.6,4.2-1.7c2.4-2.4,2.3-6.3-0.2-8.8c-2.5-2.5-6.4-2.6-8.8-0.2c-0.9,0.8-1.4,1.9-1.6,3 L146,462.4c0.2-0.5,0.4-0.9,0.4-1.4c0.4-2.7-1.4-5.3-4-5.6c-2.6-0.4-5.1,1.5-5.5,4.2c-0.3,2.2,0.9,4.4,2.8,5.2l-19.2,34.3 c-3-1.7-6.8-1.8-9.9,0c-4.7,2.8-6.1,9-3.2,13.9c2.9,4.8,8.9,6.5,13.6,3.9l19.5,30.5c-3.4,0.6-6.5,2.4-8.8,5.3 c-5.1,6.3-4,15.6,2.4,20.7c6.3,5,15.3,4.1,20.5-2l38.8,30.4l-1.8,9.6l7.6,6.5L208.7,614.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.5,592.1l0-0.4c0.2,0,0.5,0,0.7,0v0.4H200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199,591.8l0.7-0.1l0,0.4c-0.2,0-0.5,0-0.7,0.1L199,591.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.6,592.1c0.2-0.1,0.5-0.1,0.7-0.1l0.1,0.4l-0.7,0.1L197.6,592.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.3,594.6l-0.2-0.3c0.2-0.1,0.4-0.3,0.6-0.4l0.2,0.3C192.7,594.4,192.5,594.5,192.3,594.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M206.4,592.6c0.2,0.1,0.5,0.2,0.7,0.3l-0.1,0.3c-0.2-0.1-0.5-0.2-0.7-0.3L206.4,592.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.7,592.9c0.2-0.1,0.4-0.2,0.7-0.3l0.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.3L194.7,592.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.1,598.6l-0.3-0.2c0.1-0.2,0.3-0.4,0.4-0.6l0.3,0.2L188.1,598.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.5,591.9c0.2,0,0.5,0.1,0.7,0.1l-0.1,0.3c-0.2,0-0.5-0.1-0.7-0.1L203.5,591.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.9,592.1c0.2,0.1,0.5,0.1,0.7,0.2l-0.1,0.4l-0.7-0.2L204.9,592.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.3,599.8l-0.3-0.2l0.4-0.6l0.3,0.2C187.5,599.4,187.4,599.6,187.3,599.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.1,593.8c0.2,0.1,0.4,0.2,0.7,0.4l-0.2,0.3c-0.2-0.1-0.4-0.2-0.6-0.4L209.1,593.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.8,593.1c0.2,0.1,0.5,0.2,0.7,0.3l-0.2,0.3c-0.2-0.1-0.4-0.2-0.7-0.3L207.8,593.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M210.4,594.6c0.2,0.1,0.4,0.3,0.6,0.4l-0.2,0.3c-0.2-0.1-0.4-0.3-0.6-0.4L210.4,594.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M212.4,596.7l0.3-0.3c0.2,0.2,0.4,0.3,0.5,0.5l-0.3,0.2C212.7,597.1,212.6,596.9,212.4,596.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M213.4,597.8l0.3-0.2c0.2,0.2,0.3,0.4,0.5,0.6l-0.3,0.2C213.7,598.2,213.5,598,213.4,597.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.5,595.9l-0.2-0.2l0.2-0.3l0.2,0.2c0.1,0.1,0.2,0.2,0.4,0.3l-0.2,0.3 C211.8,596.1,211.6,596,211.5,595.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M214.3,599l0.3-0.2l0.4,0.6l-0.3,0.2C214.5,599.4,214.4,599.2,214.3,599z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193.5,593.9l-0.2-0.3c0.2-0.1,0.4-0.2,0.7-0.3l0.2,0.3L193.5,593.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190,596.4 189.8,596.2 190.3,595.7 190.6,595.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.4,596.7 192.8,596.6 193,597.3 192.6,597.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "169.3,520.5 169.7,520.4 169.9,521.1 169.5,521.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "168.7,518.4 169,518.3 169.3,519 168.9,519.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "168.4,517.3 168.7,517.2 168.9,517.9 168.6,518  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "169,519.4 169.4,519.3 169.6,520 169.2,520.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.7,597.7 193.1,597.6 193.3,598.3 192.9,598.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "193.1,598.8 193.4,598.7 193.6,599.4 193.3,599.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "191.1,592.4 191.5,592.3 191.7,593 191.3,593.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "189.9,588.2 190.2,588.1 190.4,588.8 190.1,588.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "189.5,587.2 189.9,587 190.1,587.8 189.7,587.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "189.2,586.1 189.6,586 189.8,586.7 189.4,586.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.3,595.2 192,595.3 191.8,594.6 192.1,594.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190.2,589.3 190.5,589.2 190.7,589.9 190.4,590  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.7,596.2 192.3,596.3 192.1,595.6 192.4,595.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "191.4,593.5 191.8,593.4 192,594.1 191.7,594.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190.8,591.4 191.2,591.3 191.4,592 191,592.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190.5,590.3 190.8,590.2 191.1,590.9 190.7,591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "171.9,529 172.2,528.9 172.5,529.6 172.1,529.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.5,563.9 182.8,563.8 183,564.5 182.7,564.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.2,562.8 182.5,562.7 182.7,563.4 182.4,563.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.8,561.8 182.2,561.7 182.4,562.4 182.1,562.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.5,560.7 181.9,560.6 182.1,561.3 181.7,561.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "183.4,567 183.8,566.9 184,567.7 183.6,567.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "182.8,564.9 183.1,564.8 183.4,565.5 183,565.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "183.1,566 183.5,565.9 183.7,566.6 183.3,566.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.9,555.4 180.3,555.3 180.5,556 180.1,556.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.6,554.4 179.9,554.3 180.1,555 179.8,555.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.9,552.2 179.3,552.1 179.5,552.8 179.2,552.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "183.8,568.1 184.1,568 184.3,568.7 184,568.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.3,553.3 179.6,553.2 179.8,553.9 179.5,554  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "180.9,558.6 181.2,558.5 181.4,559.2 181.1,559.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "180.2,556.5 180.6,556.4 180.8,557.1 180.4,557.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "180.6,557.5 180.9,557.4 181.1,558.1 180.8,558.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.2,559.6 181.5,559.5 181.8,560.2 181.4,560.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187,578.7 187.3,578.6 187.5,579.3 187.2,579.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.3,576.6 186.7,576.5 186.9,577.2 186.5,577.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.3,579.7 187.6,579.6 187.9,580.3 187.5,580.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.6,577.6 187,577.5 187.2,578.2 186.9,578.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.7,
    y: 580.7,
    transform: "matrix(0.954 -0.2998 0.2998 0.954 -165.5883 83.0676)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "188.2,582.9 188.6,582.8 188.8,583.5 188.5,583.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "187.9,581.9 188.3,581.8 188.5,582.5 188.1,582.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "184.4,570.2 184.8,570.1 185,570.8 184.6,570.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "184.7,571.3 185.1,571.2 185.3,571.9 184.9,572  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "184.1,569.2 184.4,569.1 184.6,569.8 184.3,569.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "185,572.3 185.4,572.2 185.6,572.9 185.2,573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "185.4,573.4 185.7,573.3 185.9,574 185.6,574.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186,575.5 186.4,575.4 186.6,576.1 186.2,576.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "185.7,574.5 186,574.3 186.2,575.1 185.9,575.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "173.5,534.3 173.9,534.1 174.1,534.9 173.7,535  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178,549.1 178.3,549 178.6,549.7 178.2,549.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "177.7,548 178,547.9 178.2,548.6 177.9,548.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.3,550.1 178.7,550 178.9,550.7 178.5,550.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.6,551.2 179,551.1 179.2,551.8 178.8,551.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "177.3,546.9 177.7,546.8 177.9,547.6 177.6,547.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "174.5,537.4 174.8,537.3 175,538 174.7,538.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "173.8,535.3 174.2,535.2 174.4,535.9 174,536  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "174.8,538.5 175.1,538.4 175.3,539.1 175,539.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "175.7,541.7 176.1,541.6 176.3,542.3 176,542.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "175.4,540.6 175.8,540.5 176,541.2 175.6,541.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "176.1,542.7 176.4,542.6 176.6,543.3 176.3,543.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "176.4,543.8 176.7,543.7 176.9,544.4 176.6,544.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "177,545.9 177.4,545.8 177.6,546.5 177.2,546.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "176.7,544.8 177.1,544.7 177.3,545.4 176.9,545.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "174.1,536.4 174.5,536.3 174.7,537 174.4,537.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "170.6,524.7 171,524.6 171.2,525.3 170.8,525.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "171.6,527.9 171.9,527.8 172.1,528.5 171.8,528.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "171.3,526.8 171.6,526.7 171.8,527.4 171.5,527.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "170.9,525.8 171.3,525.7 171.5,526.4 171.1,526.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "170,522.6 170.3,522.5 170.5,523.2 170.2,523.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "170.3,523.7 170.6,523.6 170.9,524.3 170.5,524.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "172.5,531.1 172.9,531 173.1,531.7 172.8,531.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "172.2,530 172.6,529.9 172.8,530.6 172.4,530.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "169.6,521.6 170,521.5 170.2,522.2 169.9,522.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "173.2,533.2 173.5,533.1 173.8,533.8 173.4,533.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "172.9,532.1 173.2,532 173.4,532.7 173.1,532.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190.5,487.4 190.7,488.1 190.4,488.2 190.1,487.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "190.9,488.4 191.2,489.1 190.8,489.2 190.6,488.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "189.9,486 189.6,486.2 189.3,485.5 189.6,485.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "199.6,510 199.9,509.8 200.2,510.5 199.8,510.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.1,
    y: 503.8,
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -177.0852 113.0898)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.7,500.8 196,500.7 196.3,501.3 196,501.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "196.1,501.8 196.5,501.7 196.8,502.4 196.4,502.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.5,
    y: 497.6,
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -174.9486 111.6503)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194.8,498.8 195.2,498.6 195.5,499.3 195.1,499.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "195.3,499.8 195.6,499.6 195.9,500.3 195.6,500.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.7,
    y: 502.7,
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -176.7293 112.8492)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "197.8,505.9 198.2,505.8 198.5,506.4 198.1,506.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "197.4,504.9 197.7,504.7 198,505.4 197.7,505.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "200,511 200.3,510.8 200.6,511.5 200.3,511.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "198.3,506.9 198.6,506.8 198.9,507.5 198.6,507.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194,496.7 194.3,496.6 194.6,497.3 194.3,497.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 490.5,
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -172.4598 109.971)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "191.8,491.6 192.2,491.5 192.5,492.2 192.1,492.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "198.7,507.9 199,507.8 199.3,508.5 199,508.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "191,489.6 191.3,489.4 191.6,490.1 191.3,490.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.3,492.6 192.6,492.5 192.9,493.2 192.6,493.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "193.6,495.7 193.9,495.6 194.2,496.2 193.8,496.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.2,
    y: 494.6,
    transform: "matrix(0.9247 -0.3807 0.3807 0.9247 -173.8807 110.9286)",
    className: "st5",
    width: 0.4,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.7,493.7 193,493.5 193.3,494.2 193,494.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-5.1,458.5 -2.4,464.9 4.5,465.8 8.7,460.3 6,453.9 -0.9,453  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.6,451.8c-4.2-3.2-10.2-2.4-13.5,1.8s-2.4,10.2,1.8,13.5c4.2,3.2,10.2,2.4,13.5-1.8 C12.6,461.1,11.8,455,7.6,451.8z M8,451.3c4.5,3.4,5.4,9.9,2,14.3c-3.4,4.5-9.9,5.3-14.4,1.9c-4.5-3.4-5.4-9.9-2-14.4 C-3,448.7,3.5,447.9,8,451.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2.7,463.2 44.8,560.7 45.6,560.4 3.5,462.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "93.6,451.4 91.3,448.5 87.6,448.9 86.2,452.4 88.5,455.4 92.2,454.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.9,456.7c2.6,1.1,5.7-0.2,6.7-2.8c1.1-2.6-0.2-5.6-2.8-6.8c-2.6-1.1-5.7,0.1-6.7,2.8 C84.1,452.6,85.3,455.6,87.9,456.7z M87.8,457c-2.8-1.2-4.1-4.4-3-7.2c1.2-2.8,4.4-4.1,7.2-3c2.8,1.2,4.2,4.4,3,7.2 C93.8,456.8,90.6,458.2,87.8,457z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50.2,562.5 48.5,559.2 44.7,559.1 42.8,562.3 44.6,565.6 48.3,565.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.8,566.8c2.4,1.5,5.6,0.7,7.1-1.7c1.5-2.4,0.7-5.6-1.7-7.1s-5.6-0.8-7.1,1.7 C40.6,562.1,41.4,565.3,43.8,566.8z M43.6,567.1c-2.6-1.6-3.4-5-1.8-7.6c1.6-2.6,5-3.4,7.6-1.8c2.6,1.6,3.4,5,1.8,7.6 C49.6,567.9,46.2,568.7,43.6,567.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "60,435.5 60.2,431.8 57.2,429.7 53.8,431.3 53.5,435 56.6,437.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.2,435.6c1.2,2.6,4.3,3.7,6.9,2.5c2.6-1.2,3.7-4.3,2.4-6.9c-1.2-2.6-4.3-3.7-6.9-2.5 C52.1,430,51,433,52.2,435.6z M51.9,435.8c-1.3-2.7-0.1-6,2.6-7.3c2.8-1.3,6-0.1,7.4,2.6c1.3,2.7,0.1,6-2.6,7.3 C56.5,439.7,53.2,438.5,51.9,435.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "100.3,492 100.1,489.5 97.8,488.4 95.7,489.9 96,492.4 98.3,493.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.2,493c1.1,1.6,3.3,2,4.9,0.8c1.6-1.1,1.9-3.3,0.8-4.9c-1.1-1.6-3.3-2-4.9-0.8 C94.4,489.2,94.1,491.4,95.2,493z M95,493.1c-1.2-1.7-0.8-4,0.9-5.2c1.7-1.2,4-0.8,5.2,0.9c1.2,1.7,0.8,4-0.9,5.2 C98.5,495.2,96.2,494.8,95,493.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "87.8,452.4 87.8,451.6 6.1,459.8 6.2,460.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "97.7,490.7 5.1,459.3 5,459.6 97.6,491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "91,453.5 97.8,489.9 98.7,489.8 91.8,453.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "6.3,459.5 6.8,460.5 56.2,434.7 55.7,433.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "58.2,434.8 88.1,450.5 88.7,449.4 58.7,433.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "135,592.2 134.5,586.1 128.9,583.5 123.8,587 124.4,593.2 130,595.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.4,594.5c2.7,3.8,8,4.8,11.9,2.1c3.8-2.7,4.8-8,2.1-11.9c-2.7-3.9-8-4.8-11.9-2.1 S119.7,590.7,122.4,594.5z M122,594.8c-2.9-4.1-1.9-9.8,2.2-12.7c4.1-2.9,9.8-1.9,12.7,2.2c2.9,4.1,1.9,9.8-2.2,12.7 C130.6,600,124.9,598.9,122,594.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.5,591 180.7,589.3 178.8,589 177.6,590.6 178.4,592.3 180.3,592.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M177.9,592.9c1.2,0.9,2.9,0.7,3.7-0.5c0.9-1.2,0.6-2.8-0.5-3.7c-1.2-0.9-2.9-0.6-3.7,0.5 C176.5,590.4,176.8,592.1,177.9,592.9z M177.9,593.1c-1.3-1-1.5-2.7-0.6-4c0.9-1.3,2.7-1.5,4-0.6c1.3,0.9,1.5,2.7,0.6,4 C180.9,593.8,179.1,594,177.9,593.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "132.6,592.3 178.5,590.8 178.5,590.4 132.6,591.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "124.7,587.8 96.2,544.3 95.9,544.3 124.3,587.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "162.2,606.8 162.4,606.5 131.9,590.5 131.7,590.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "136.1,622.7 136.4,622.6 129.4,592.2 129,592.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "156.9,622.4 133.5,590.7 133.4,590.7 156.8,622.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "92.2,581.4 92.8,582.8 94.3,583.1 95.3,581.9 94.8,580.4 93.2,580.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95.2,580c-0.9-0.8-2.3-0.6-3.1,0.2c-0.8,0.9-0.7,2.3,0.3,3c0.9,0.8,2.3,0.7,3.1-0.2 C96.2,582.1,96.1,580.8,95.2,580z M95.2,579.9c1,0.8,1.1,2.3,0.3,3.2s-2.3,1.1-3.2,0.3c-1-0.8-1.1-2.3-0.3-3.2 C92.8,579.2,94.3,579.1,95.2,579.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "85.6,595.8 86.3,597.8 88.5,598.2 89.9,596.6 89.2,594.5 87,594.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.7,593.9c-1.3-1.1-3.2-0.9-4.2,0.3c-1.1,1.3-0.9,3.2,0.4,4.2c1.3,1.1,3.2,0.9,4.2-0.4 C91.1,596.9,91,594.9,89.7,593.9z M89.8,593.7c1.4,1.1,1.5,3.2,0.4,4.5c-1.1,1.4-3.2,1.5-4.5,0.4c-1.4-1.2-1.5-3.2-0.4-4.5 C86.4,592.7,88.5,592.6,89.8,593.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.5,543.2 94.9,544.7 95.8,546 97.5,545.8 98.1,544.3 97.2,543  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.7,544.3c-0.1-1.2-1.2-2.1-2.5-2c-1.2,0.1-2.1,1.2-2,2.5c0.1,1.2,1.2,2.1,2.5,2 C98,546.6,98.9,545.5,98.7,544.3z M98.9,544.2c0.1,1.3-0.8,2.5-2.1,2.6c-1.3,0.1-2.5-0.8-2.6-2.1c-0.1-1.3,0.8-2.5,2.1-2.6 C97.6,542,98.7,542.9,98.9,544.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "103.6,592 103.1,593.4 104,594.7 105.6,594.4 106.2,593 105.2,591.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.8,592.9c-0.2-1.2-1.3-2-2.4-1.8s-2,1.2-1.8,2.4c0.2,1.2,1.3,2,2.4,1.8 C106.1,595.2,106.9,594.1,106.8,592.9z M106.9,592.9c0.2,1.3-0.7,2.4-2,2.6c-1.3,0.2-2.4-0.7-2.6-2c-0.2-1.3,0.7-2.4,2-2.6 C105.6,590.8,106.7,591.6,106.9,592.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "94.7,564.3 94.5,565.4 95.2,566.1 96.3,565.8 96.5,564.7 95.7,564  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96.9,564.6c-0.2-0.8-1.1-1.2-1.9-1c-0.8,0.2-1.2,1.1-0.9,1.8c0.2,0.8,1.1,1.2,1.8,1 C96.7,566.2,97.1,565.4,96.9,564.6z M97,564.6c0.3,0.8-0.2,1.7-1,2c-0.8,0.3-1.7-0.2-2-1c-0.3-0.8,0.2-1.7,1-2 C95.8,563.3,96.7,563.7,97,564.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "72,578.4 72.3,579.4 73.3,579.7 74,578.9 73.7,577.9 72.7,577.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74,577.6c-0.6-0.5-1.5-0.5-2.1,0.1c-0.6,0.6-0.5,1.5,0.1,2.1c0.6,0.5,1.5,0.5,2.1-0.1 C74.6,579.1,74.6,578.1,74,577.6z M74.1,577.5c0.6,0.6,0.7,1.6,0.1,2.2c-0.6,0.6-1.6,0.7-2.2,0.1c-0.6-0.6-0.7-1.6-0.1-2.2 C72.4,577,73.4,576.9,74.1,577.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "94.6,581.7 94.6,582 126.4,587.9 126.5,587.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.6,565.2 125.5,588.5 125.6,588.4 95.6,565.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "178.7,592.3 178.5,592 162.9,605.9 163.1,606.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "93.5,580.9 95.4,565.5 95.1,565.4 93.2,580.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "125.6,586.9 125.5,586.4 105,592.8 105.2,593.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "104.3,592.5 94.3,582.4 93.9,582.8 103.9,592.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "103.9,593.4 103.9,593.1 89.1,596.5 89.1,596.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "88.7,596 93.2,581.9 92.8,581.8 88.4,595.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "93.1,581.7 93.1,581.5 73.4,578.6 73.4,578.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "87.7,594.9 72.9,579 72.8,579.1 87.6,595  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.7,565.1 96,545.4 95.9,545.4 95.6,565.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.1,535.8c-0.1,0.2-0.2,0.3-0.3,0.5l-0.2-0.2c0.1-0.2,0.2-0.3,0.3-0.5L202.1,535.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.8,523l0.2-0.1c0.1,0.2,0.2,0.3,0.3,0.5l-0.2,0.1L201.8,523z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.1,522.1l0.2-0.2l0.3,0.5l-0.2,0.2C201.4,522.4,201.2,522.2,201.1,522.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.4,521.2l0.2-0.2c0.1,0.1,0.2,0.3,0.4,0.4l-0.2,0.2L200.4,521.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "199.6,520.4 199.9,520.2 200.3,520.6 200.1,520.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "202.5,524.5 202.3,524 202.6,523.8 202.8,524.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M201.5,536.8l-0.3,0.5l-0.2-0.2c0.1-0.1,0.2-0.3,0.3-0.4L201.5,536.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.8,
    y: 516.8,
    transform: "matrix(0.1414 -0.9899 0.9899 0.1414 -346.2008 635.0171)",
    className: "st5",
    width: 0.3,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.8,519.7l0.2-0.2c0.2,0.1,0.3,0.2,0.4,0.4l-0.2,0.2L198.8,519.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "193.8,517.4 193.8,517.1 194.4,517.2 194.3,517.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.9,518l0.1-0.3l0.5,0.2l-0.1,0.3C196.3,518.2,196.1,518.1,195.9,518z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.9,517.7l0.1-0.3c0.2,0.1,0.4,0.1,0.5,0.2l-0.1,0.3C195.2,517.8,195.1,517.7,194.9,517.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196.9,518.5l0.1-0.3c0.2,0.1,0.3,0.2,0.5,0.3l-0.1,0.2C197.2,518.7,197.1,518.6,196.9,518.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.9,519.1l0.1-0.2c0.2,0.1,0.3,0.2,0.5,0.3l-0.2,0.2C198.2,519.3,198.1,519.2,197.9,519.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.4,517.3l-0.1-0.3c0.2,0,0.4-0.1,0.6-0.1l0,0.3C189.8,517.2,189.6,517.2,189.4,517.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.1,526.4c0.1-0.2,0.1-0.4,0.1-0.5l0.3,0.1l-0.1,0.5L179.1,526.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M178.9,527.5c0-0.2,0.1-0.4,0.1-0.6l0.3,0.1c0,0.2-0.1,0.4-0.1,0.5L178.9,527.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.3,523.3c0.1-0.2,0.2-0.3,0.3-0.5l0.2,0.1c-0.1,0.2-0.2,0.3-0.3,0.5L180.3,523.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M178.8,529.8c0-0.2,0-0.4,0-0.6h0.3v0.5L178.8,529.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.9,522.3c0.1-0.2,0.2-0.3,0.3-0.5l0.2,0.2l-0.3,0.5L180.9,522.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.3,532l-0.3,0.1c-0.1-0.2-0.1-0.4-0.1-0.6l0.3,0C179.3,531.6,179.3,531.8,179.3,532z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.6,517.1l0-0.3c0.2,0,0.4,0,0.6,0l0,0.3C192,517.1,191.8,517.1,191.6,517.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "180,534.1 179.8,534.2 179.6,533.7 179.8,533.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.6,533.1l-0.3,0.1c-0.1-0.2-0.1-0.4-0.2-0.5l0.3-0.1L179.6,533.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "181.6,521.4 182,520.9 182.2,521.1 181.8,521.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "179.1,530.9 178.9,530.9 178.8,530.4 179.1,530.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.8,537.6c-0.1,0.1-0.2,0.3-0.4,0.4l-0.2-0.2c0.1-0.1,0.2-0.3,0.4-0.4L200.8,537.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.2,517.8l-0.1-0.3c0.2-0.1,0.4-0.1,0.5-0.2l0.1,0.3C187.6,517.7,187.4,517.7,187.2,517.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "188.3,517.5 188.2,517.2 188.8,517.1 188.8,517.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.5,517.1l0-0.3c0.2,0,0.4,0,0.6,0l0,0.3L190.5,517.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.1,518.5c0.2-0.1,0.3-0.2,0.5-0.3l0.1,0.2c-0.2,0.1-0.3,0.2-0.5,0.3L185.1,518.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.2,519.8l0.4-0.4l0.2,0.2c-0.2,0.1-0.3,0.2-0.4,0.3L183.2,519.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.1,519.1c0.1-0.1,0.3-0.2,0.5-0.3l0.1,0.2l-0.5,0.3L184.1,519.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M182.4,520.5c0.1-0.1,0.3-0.3,0.4-0.4l0.2,0.2l-0.4,0.4L182.4,520.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.2,518.2 186.1,518 186.6,517.7 186.7,518  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M178.8,528.7c0-0.2,0-0.4,0-0.6l0.3,0c0,0.2,0,0.4,0,0.5L178.8,528.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "196.9,540.3 197.1,540.2 197.2,540.4 197,540.5 196.7,540.7 196.6,540.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.2,539.9c-0.2,0.1-0.3,0.2-0.5,0.3l-0.1-0.2c0.2-0.1,0.3-0.2,0.5-0.3L198.2,539.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M196.1,540.7l0.1,0.3l-0.5,0.2l-0.1-0.3C195.7,540.8,195.9,540.7,196.1,540.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200,538.5c-0.1,0.1-0.3,0.3-0.4,0.4l-0.2-0.2c0.1-0.1,0.3-0.2,0.4-0.4L200,538.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M192.9,541.5l0,0.3c-0.2,0-0.4,0-0.6,0.1l0-0.3C192.5,541.6,192.7,541.5,192.9,541.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195,541.1l0.1,0.3c-0.2,0.1-0.4,0.1-0.5,0.2l-0.1-0.3L195,541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M202.8,533.7l0.3,0.1c-0.1,0.2-0.1,0.3-0.2,0.5l-0.3-0.1L202.8,533.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.7,527.6l-0.3,0c0-0.2-0.1-0.4-0.1-0.5l0.3,0C203.7,527.3,203.7,527.4,203.7,527.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M191.8,541.6v0.3c-0.2,0-0.4,0-0.6,0v-0.3L191.8,541.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.2,526.6c0-0.2-0.1-0.4-0.1-0.6l0.3-0.1l0.1,0.5L203.2,526.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "194,541.3 194,541.6 193.5,541.7 193.4,541.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.8,528.8l-0.3,0c0-0.2,0-0.4,0-0.6l0.3,0L203.8,528.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.8,529.9l-0.3,0l0-0.6h0.3C203.9,529.5,203.9,529.7,203.8,529.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.3,532.1c0-0.2,0.1-0.4,0.1-0.5l0.3,0.1c0,0.2-0.1,0.4-0.1,0.6L203.3,532.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M203.5,531c0-0.2,0.1-0.4,0.1-0.5l0.3,0l-0.1,0.6L203.5,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M190.6,541.6l0,0.3c-0.2,0-0.4,0-0.6,0l0-0.3C190.3,541.6,190.5,541.6,190.6,541.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M183.5,538.8l-0.2,0.2c-0.1-0.1-0.3-0.2-0.4-0.4l0.2-0.2C183.2,538.5,183.4,538.7,183.5,538.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.9,537.2l-0.2,0.2l-0.4-0.5l0.2-0.2C181.7,536.9,181.8,537.1,181.9,537.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M182.7,538l-0.2,0.2c-0.1-0.1-0.3-0.3-0.4-0.4l0.2-0.2C182.4,537.8,182.6,537.9,182.7,538z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M184.4,539.5l-0.1,0.2l-0.5-0.3l0.2-0.2C184.1,539.2,184.2,539.3,184.4,539.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M181.3,536.3l-0.2,0.2c-0.1-0.2-0.2-0.3-0.3-0.5l0.2-0.2C181.1,536,181.1,536.2,181.3,536.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M199.1,539.2l-0.5,0.3l-0.2-0.2c0.1-0.1,0.3-0.2,0.4-0.3L199.1,539.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M185.4,540l-0.1,0.2c-0.2-0.1-0.3-0.2-0.5-0.3l0.1-0.2L185.4,540z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180,534.7l0.2-0.1l0.1,0.3l0.3,0.5l-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5C180.1,534.9,180.1,534.8,180,534.7z "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "186.4,540.5 186.2,540.8 185.7,540.6 185.8,540.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M179.9,524.9l-0.2,0.5l-0.3-0.1c0.1-0.2,0.1-0.4,0.2-0.5L179.9,524.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M180.3,523.9c-0.1,0.2-0.2,0.3-0.2,0.5l-0.3-0.1l0.2-0.5L180.3,523.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M189.6,541.5l-0.1,0.3c-0.2,0-0.4-0.1-0.6-0.1l0.1-0.3C189.2,541.4,189.4,541.4,189.6,541.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.4,541.3l-0.1,0.3l-0.6-0.1l0.1-0.3C188.1,541.2,188.3,541.2,188.4,541.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M187.4,540.9l-0.1,0.3c-0.2-0.1-0.3-0.1-0.5-0.2l0.1-0.3L187.4,540.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "138.1,472.7 140.6,471.6 140.9,468.9 138.7,467.3 136.3,468.4 136,471.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M135.4,467.8c-1.2,1.7-0.9,4,0.8,5.2c1.7,1.2,4,0.9,5.2-0.8c1.2-1.7,0.9-4-0.8-5.2 C139,465.8,136.6,466.1,135.4,467.8z M135.2,467.6c1.3-1.8,3.8-2.2,5.6-0.8c1.8,1.3,2.2,3.8,0.9,5.6c-1.3,1.8-3.8,2.2-5.6,0.8 C134.3,471.9,133.9,469.4,135.2,467.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "163.9,482.5 167.3,481 167.7,477.3 164.7,475 161.2,476.5 160.8,480.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M160.1,475.7c-1.7,2.3-1.2,5.6,1.1,7.3c2.3,1.7,5.6,1.2,7.3-1.1c1.7-2.3,1.2-5.6-1.1-7.3 C165,472.9,161.8,473.4,160.1,475.7z M159.8,475.5c1.8-2.5,5.3-3,7.8-1.2c2.5,1.8,3,5.3,1.2,7.8c-1.8,2.5-5.3,3-7.8,1.2 C158.5,481.4,158,477.9,159.8,475.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "71.8,471.1 74.4,472 76.6,470.2 76.1,467.5 73.5,466.5 71.3,468.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.3,465.4c-2.1,0.4-3.5,2.4-3.1,4.5c0.4,2.1,2.4,3.5,4.5,3.2c2.1-0.4,3.5-2.4,3.2-4.5 C77.4,466.5,75.4,465.1,73.3,465.4z M73.2,465.2c2.3-0.4,4.4,1.1,4.8,3.4c0.4,2.3-1.1,4.4-3.4,4.8c-2.3,0.4-4.4-1.1-4.8-3.4 C69.5,467.7,71,465.6,73.2,465.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "108.4,470.3 110.2,470.5 111.4,469.1 110.7,467.4 108.9,467.1 107.7,468.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M108.6,466.5c-1.3,0.5-1.9,2-1.4,3.3c0.5,1.3,2,1.9,3.3,1.4c1.3-0.5,1.9-2,1.4-3.3 C111.4,466.6,109.9,466,108.6,466.5z M108.6,466.3c1.4-0.5,3,0.1,3.5,1.5c0.6,1.4-0.1,3-1.5,3.5c-1.4,0.5-3-0.1-3.5-1.5 C106.5,468.4,107.2,466.9,108.6,466.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "135.6,507.9 137.3,507.3 137.6,505.4 136.1,504.3 134.4,504.9 134.1,506.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M133.9,504.5c-0.9,1.1-0.7,2.7,0.4,3.6c1.1,0.9,2.7,0.7,3.6-0.4c0.9-1.1,0.7-2.7-0.4-3.6 C136.3,503.2,134.7,503.4,133.9,504.5z M133.7,504.4c0.9-1.1,2.7-1.3,3.8-0.4c1.2,0.9,1.3,2.7,0.4,3.8 c-0.9,1.2-2.7,1.3-3.8,0.4C133,507.2,132.8,505.5,133.7,504.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "137.2,470.5 110.3,468.9 110.3,469.5 137.1,471.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "163.9,477.2 138.9,471 138.8,471.6 163.8,477.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "138.6,471.1 138.3,471.1 135.7,505.3 136,505.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "162.1,479 136.5,506.2 136.6,506.4 162.2,479.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "109.6,468.4 75.5,470 75.6,470.3 109.6,468.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "38.3,470.5 34.5,476.3 37.7,482.5 44.6,482.9 48.4,477 45.2,470.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.1,477.2c0.3-5.3-3.8-9.8-9.1-10.1c-5.3-0.3-9.8,3.8-10.1,9.1c-0.3,5.3,3.8,9.8,9.1,10.1 C46.3,486.5,50.8,482.5,51.1,477.2z M51.7,477.2c-0.3,5.6-5.1,10-10.7,9.7c-5.7-0.3-10-5.1-9.7-10.8c0.3-5.6,5.1-10,10.8-9.7 C47.6,466.8,52,471.6,51.7,477.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2.7,392.3 0.6,395.4 2.2,398.8 5.9,399 8,395.9 6.4,392.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.5,396c0.2-2.8-2-5.3-4.8-5.5c-2.8-0.2-5.3,1.9-5.5,4.8c-0.2,2.8,2,5.3,4.8,5.5 C6.8,401,9.3,398.9,9.5,396z M9.8,396c-0.2,3-2.8,5.3-5.9,5.1c-3-0.2-5.3-2.8-5.2-5.9s2.8-5.3,5.9-5.1 C7.7,390.4,10,393,9.8,396z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "38.9,479.6 -17.7,569 -17,569.5 39.6,480  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5.4,397.5 4.7,397.8 38.9,472.5 39.6,472.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "100.2,547.9 101.4,544.4 98.9,541.6 95.3,542.3 94.1,545.9 96.6,548.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.7,546.2c0.6,2.8,3.3,4.6,6.1,4c2.8-0.6,4.6-3.3,4-6.1c-0.6-2.8-3.3-4.6-6.1-4 C93.9,540.6,92.1,543.4,92.7,546.2z M92.4,546.2c-0.6-3,1.3-5.9,4.2-6.5c3-0.6,5.9,1.3,6.5,4.3c0.6,3-1.3,5.9-4.3,6.5 C95.9,551.1,93,549.2,92.4,546.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "133.9,530.5 135.6,525.6 132.1,521.7 127,522.8 125.4,527.7 128.9,531.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.4,528.1c0.8,3.9,4.7,6.4,8.5,5.6c3.9-0.8,6.4-4.6,5.6-8.5c-0.8-3.9-4.6-6.4-8.5-5.6 C125.1,520.4,122.6,524.2,123.4,528.1z M122.9,528.2c-0.9-4.1,1.8-8.2,5.9-9.1c4.1-0.9,8.2,1.8,9.1,5.9 c0.9,4.1-1.8,8.2-5.9,9.1C127.9,535,123.8,532.4,122.9,528.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "94.3,511.2 97.5,509.4 97.5,505.6 94.3,503.8 91.1,505.6 91.1,509.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M89.8,504.9c-1.4,2.5-0.6,5.6,1.9,7.1c2.5,1.4,5.6,0.6,7.1-1.9c1.4-2.5,0.6-5.6-1.9-7 C94.4,501.6,91.2,502.4,89.8,504.9z M89.5,504.7c1.5-2.6,4.9-3.5,7.5-2c2.6,1.5,3.5,4.9,2,7.5c-1.5,2.6-4.9,3.5-7.5,2 C88.9,510.7,88,507.3,89.5,504.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "70.6,576.2 72.5,574.6 72.1,572.1 69.7,571.2 67.7,572.9 68.2,575.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.8,572.5c-0.7,1.8,0.3,3.8,2.1,4.5c1.8,0.7,3.8-0.2,4.5-2.1c0.7-1.8-0.3-3.8-2.1-4.5 S67.5,570.7,66.8,572.5z M66.6,572.4c0.7-1.9,2.8-2.9,4.8-2.2c1.9,0.7,2.9,2.9,2.2,4.8c-0.7,1.9-2.9,2.9-4.8,2.2 C66.9,576.5,65.9,574.4,66.6,572.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "134.2,583.1 135.1,580.7 133.5,578.8 131,579.2 130.1,581.5 131.7,583.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.1,581.7c0.3,1.9,2.1,3.2,4,2.9c1.9-0.3,3.2-2.1,2.9-4c-0.3-1.9-2.1-3.2-4-2.9 C130.1,578,128.8,579.8,129.1,581.7z M128.9,581.7c-0.3-2,1.1-4,3.1-4.3c2-0.3,3.9,1.1,4.3,3.1c0.3,2-1.1,4-3.1,4.3 C131.1,585.2,129.2,583.8,128.9,581.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "96.2,543.7 96.8,543.2 43.6,480.4 43,481  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "70.2,573.3 43.5,479.3 43.2,479.4 69.9,573.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 559.8,
    transform: "matrix(0.7078 -0.7064 0.7064 0.7078 -371.1265 223.2393)",
    className: "st5",
    width: 37,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "44,480.4 43.5,481.4 92.8,507.7 93.4,506.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "93.9,509.3 97.9,542.8 99.1,542.7 95,509.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "95.9,508 95.6,508.8 128.4,524.2 128.8,523.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "128.5,525.5 99.2,545.5 99.7,546.2 129,526.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "99.1,546 98.8,546.2 131.7,580.5 131.9,580.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "128.7,529.1 133.3,580.6 133.6,580.6 129,529.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "58.1,476.2 62.4,475 63.4,470.6 60,467.4 55.7,468.6 54.7,473  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.4,467.4c-2.3,2.5-2.1,6.4,0.4,8.9c2.6,2.4,6.5,2.4,8.9,0c2.3-2.5,2.1-6.4-0.4-8.9 C60.7,464.9,56.8,464.9,54.4,467.4z M54.1,467.1c2.5-2.6,6.7-2.6,9.5,0c2.7,2.6,2.9,6.8,0.4,9.4c-2.5,2.6-6.7,2.6-9.5,0.1 C51.8,473.9,51.6,469.7,54.1,467.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "81.3,498.6 84.1,496.5 83.5,493.1 80.2,491.8 77.5,493.9 78.1,497.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.2,493.4c-1,2.4,0.3,5.2,2.8,6.2c2.5,1,5.4-0.1,6.3-2.5c1-2.4-0.3-5.2-2.8-6.2 C80,489.8,77.2,491,76.2,493.4z M75.9,493.3c1-2.6,4-3.8,6.7-2.7c2.7,1.1,4,4,3,6.6c-1,2.6-4.1,3.8-6.7,2.7 C76.2,498.8,74.9,495.8,75.9,493.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "37.2,404.4 83.1,431 83.3,430.2 37.4,403.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "122.1,496.9 124.8,497.6 126.7,495.7 125.9,493 123.3,492.2 121.4,494.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123,491.2c-2,0.5-3.2,2.6-2.6,4.7c0.6,2.1,2.6,3.3,4.6,2.8c2-0.5,3.1-2.6,2.6-4.7 C127.1,491.9,125,490.7,123,491.2z M123,490.9c2.1-0.5,4.3,0.8,4.9,3c0.6,2.2-0.7,4.4-2.8,5c-2.1,0.6-4.3-0.8-4.9-3 C119.6,493.7,120.8,491.5,123,490.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "82.4,494.3 122.4,494.7 122.4,494 82.4,493.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "122.4,494.7 122.5,494.4 62.2,470.7 62.1,471  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61.8,474.5l0.2-0.2l0.4,0.4l-0.2,0.2L61.8,474.5z M62.5,475.1l0.2-0.2l0.4,0.4l-0.2,0.2L62.5,475.1z  M63.2,475.7l0.2-0.2l0.4,0.4l-0.2,0.2L63.2,475.7z M63.8,476.4l0.2-0.2l0.4,0.4l-0.2,0.2L63.8,476.4z M64.5,477l0.2-0.2 l0.4,0.4l-0.2,0.2L64.5,477z M65.2,477.6l0.2-0.2l0.4,0.4l-0.2,0.2L65.2,477.6z M65.8,478.3l0.2-0.2l0.4,0.4l-0.2,0.2 L65.8,478.3z M66.5,478.9l0.2-0.2l0.4,0.4l-0.2,0.2L66.5,478.9z M67.1,479.6l0.2-0.2l0.4,0.4l-0.2,0.2L67.1,479.6z M67.8,480.2 L68,480l0.4,0.4l-0.2,0.2L67.8,480.2z M68.4,480.8l0.2-0.2l0.4,0.4l-0.2,0.2L68.4,480.8z M69.1,481.5l0.2-0.2l0.4,0.4l-0.2,0.2 L69.1,481.5z M69.8,482.1l0.2-0.2l0.4,0.4l-0.2,0.2L69.8,482.1z M70.4,482.7l0.2-0.2l0.4,0.4l-0.2,0.2L70.4,482.7z M71.1,483.4 l0.2-0.2l0.4,0.4l-0.2,0.2L71.1,483.4z M71.7,484l0.2-0.2l0.4,0.4l-0.2,0.2L71.7,484z M72.4,484.7l0.2-0.2l0.4,0.4l-0.2,0.2 L72.4,484.7z M73.1,485.3l0.2-0.2l0.4,0.4l-0.2,0.2L73.1,485.3z M73.7,485.9l0.2-0.2l0.4,0.4l-0.2,0.2L73.7,485.9z M74.4,486.6 l0.2-0.2l0.4,0.4l-0.2,0.2L74.4,486.6z M75,487.2l0.2-0.2l0.4,0.4l-0.2,0.2L75,487.2z M75.7,487.8l0.2-0.2l0.4,0.4l-0.2,0.2 L75.7,487.8z M76.4,488.5l0.2-0.2l0.4,0.4l-0.2,0.2L76.4,488.5z M77,489.1l0.2-0.2l0.4,0.4l-0.2,0.2L77,489.1z M77.7,489.7 l0.2-0.2l0.5,0.4l-0.2,0.2L77.7,489.7z M78.3,490.4l0.2-0.2l0.4,0.4l-0.2,0.2L78.3,490.4z M79,491l0.2-0.2l0.4,0.4l-0.2,0.2 L79,491z M79.7,491.7l0.2-0.2l0.4,0.4l-0.2,0.2L79.7,491.7z M80.3,492.3l0.2-0.2l0.4,0.4l-0.2,0.2L80.3,492.3z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "59.7,468.6 60.4,468.2 31.9,407.2 31.2,407.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "59.1,468.9 84.8,435.8 84.5,435.6 58.9,468.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "124,493.7 124.1,493.5 96.5,433.1 96.5,433.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 124.7,
    y1: 493.4,
    x2: 31.2,
    y2: 407.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-4.7,491.3 -7,494.2 -5.7,497.7 -2,498.4 0.3,495.5 -1,491.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1.8,495.7c0.4-2.8-1.5-5.5-4.3-6c-2.8-0.5-5.5,1.5-5.9,4.3c-0.4,2.8,1.5,5.5,4.3,6 C-1.4,500.4,1.3,498.5,1.8,495.7z M2.1,495.8c-0.5,3-3.3,5.1-6.3,4.6c-3-0.5-5.1-3.4-4.6-6.4c0.5-3,3.3-5.1,6.3-4.6 C0.5,489.9,2.6,492.7,2.1,495.8z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicPlaceholder);
export default __webpack_public_path__ + "static/media/graphic_placeholder.318921eb8cb0b99638ca3533e053ebe6.svg";
export { ForwardRef as ReactComponent };